// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"5oZ8s":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExampleApp", ()=>ExampleApp);
var _jsxRuntime = require("react/jsx-runtime");
var _alertDialog = require("tailwind-starter/AlertDialog");
var _components = require("./components");
var _button = require("tailwind-starter/Button");
var _table = require("tailwind-starter/Table");
var _checkbox = require("tailwind-starter/Checkbox");
var _lucideReact = require("lucide-react");
var _reactAriaComponents = require("react-aria-components");
var _comboBox = require("tailwind-starter/ComboBox");
var _datePicker = require("tailwind-starter/DatePicker");
var _utils = require("tailwind-starter/utils");
var _date = require("@internationalized/date");
var _gridList = require("tailwind-starter/GridList");
var _menu = require("tailwind-starter/Menu");
var _modal = require("tailwind-starter/Modal");
var _plants = require("./plants");
var _plantsDefault = parcelHelpers.interopDefault(_plants);
var _popover = require("tailwind-starter/Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchField = require("tailwind-starter/SearchField");
var _select = require("tailwind-starter/Select");
var _tagGroup = require("tailwind-starter/TagGroup");
var _textField = require("tailwind-starter/TextField");
var _tooltip = require("tailwind-starter/Tooltip");
var _tailwindVariants = require("tailwind-variants");
var _reactAria = require("react-aria");
var _utils1 = require("@react-spectrum/utils");
'use client';
const allColumns = [
    {
        id: 'favorite',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.VisuallyHidden), {
            children: "Favorite"
        }),
        width: 40,
        minWidth: 40
    },
    {
        id: 'common_name',
        children: 'Name',
        minWidth: 150,
        allowsSorting: true
    },
    {
        id: 'cycle',
        children: 'Cycle',
        defaultWidth: 120,
        allowsSorting: true
    },
    {
        id: 'sunlight',
        children: 'Sunlight',
        defaultWidth: 120,
        allowsSorting: true
    },
    {
        id: 'watering',
        children: 'Watering',
        defaultWidth: 120,
        allowsSorting: true
    },
    {
        id: 'actions',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.VisuallyHidden), {
            children: "Actions"
        }),
        width: 48,
        minWidth: 48
    }
];
let hideOnScroll = typeof document !== 'undefined' ? document.getElementById('hideOnScroll') : null;
function ExampleApp() {
    let [sortDescriptor, setSortDescriptor] = (0, _react.useState)({
        column: 'common_name',
        direction: 'ascending'
    });
    let [allItems, setAllItems] = (0, _react.useState)(()=>(0, _plantsDefault.default).map((p)=>({
                ...p,
                isFavorite: false
            })));
    let [search, setSearch] = (0, _react.useState)('');
    let [favorite, setFavorite] = (0, _react.useState)(false);
    let [cycles, setCycles] = (0, _react.useState)(new Set());
    let [sunlight, setSunlight] = (0, _react.useState)(new Set());
    let [watering, setWatering] = (0, _react.useState)(new Set());
    let { contains } = (0, _reactAria.useFilter)({
        sensitivity: 'base'
    });
    let collator = (0, _reactAria.useCollator)();
    let dir = sortDescriptor.direction === 'descending' ? -1 : 1;
    let items = allItems.filter((item)=>(contains(item.common_name, search) || contains(item.scientific_name.join(''), search)) && (!favorite || item.isFavorite) && (cycles === 'all' || cycles.size === 0 || cycles.has(item.cycle)) && (sunlight === 'all' || sunlight.size === 0 || sunlight.has(getSunlight(item))) && (watering === 'all' || watering.size === 0 || watering.has(item.watering))).sort((a, b)=>collator.compare(a[sortDescriptor.column], b[sortDescriptor.column]) * dir);
    let [visibleColumns, setVisibleColumns] = (0, _react.useState)(new Set([
        'favorite',
        'common_name',
        'sunlight',
        'watering',
        'actions'
    ]));
    let columns = (0, _react.useMemo)(()=>{
        let res = allColumns.filter((c)=>visibleColumns === 'all' || visibleColumns.has(c.id));
        res[1] = {
            ...res[1],
            isRowHeader: true
        };
        return res;
    }, [
        visibleColumns
    ]);
    let filters = 0;
    if (favorite) filters++;
    if (cycles !== 'all') filters += cycles.size;
    if (sunlight !== 'all') filters += sunlight.size;
    if (watering !== 'all') filters += watering.size;
    let clearFilters = ()=>{
        setFavorite(false);
        setCycles(new Set());
        setSunlight(new Set());
        setWatering(new Set());
    };
    let toggleFavorite = (id, isFavorite)=>{
        setAllItems((allItems)=>{
            let items = [
                ...allItems
            ];
            let index = items.findIndex((item)=>item.id === id);
            items[index] = {
                ...items[index],
                isFavorite
            };
            return items;
        });
    };
    let addItem = (item)=>{
        setAllItems((allItems)=>[
                ...allItems,
                item
            ]);
    };
    let editItem = (item)=>{
        setAllItems((allItems)=>{
            let items = [
                ...allItems
            ];
            let index = items.findIndex((i)=>i.id === item.id);
            items[index] = item;
            return items;
        });
    };
    let deleteItem = ()=>{
        setAllItems((allItems)=>{
            if (!actionItem) return allItems;
            let items = [
                ...allItems
            ];
            let index = items.findIndex((item)=>item.id === actionItem.id);
            items.splice(index, 1);
            return items;
        });
    };
    let [isScrolled, setScrolled] = (0, _react.useState)(false);
    let onScroll = (e)=>{
        if (hideOnScroll) {
            let newIsScrolled = e.currentTarget.scrollTop > 0 || e.currentTarget.scrollLeft > 0;
            if (newIsScrolled !== isScrolled) setScrolled(newIsScrolled);
        }
    };
    let hasAtLeast4Items = items.length >= 4;
    (0, _react.useEffect)(()=>{
        if (hideOnScroll) hideOnScroll.style.opacity = isScrolled || !hasAtLeast4Items ? '0' : '1';
    }, [
        isScrolled,
        hasAtLeast4Items
    ]);
    let [dialog, setDialog] = (0, _react.useState)(null);
    let [actionItem, setActionItem] = (0, _react.useState)(null);
    let onAction = (item, action)=>{
        switch(action){
            case 'favorite':
                toggleFavorite(item.id, !item.isFavorite);
                break;
            default:
                setDialog(action);
                setActionItem(item);
                break;
        }
    };
    let onDialogClose = ()=>setDialog(null);
    let isSmall = (0, _utils1.useMediaQuery)('(max-width: 640px)');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "h-full flex flex-col gap-4 p-4 box-border",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-[1fr_auto_auto] sm:grid-cols-[1.1fr_auto_auto_1fr_auto] gap-2 items-end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchField.SearchField), {
                        "aria-label": "Search",
                        value: search,
                        onChange: setSearch,
                        className: "col-span-3 sm:col-span-1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TooltipTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        "aria-label": "Filters",
                                        variant: "secondary",
                                        className: "w-9 h-9 shrink-0 p-0 px-2 relative",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FilterIcon), {
                                                "aria-hidden": true,
                                                className: "block w-5 h-5"
                                            }),
                                            filters > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "absolute -top-2 -right-2 rounded-full h-4 aspect-square text-white text-xs bg-blue-600",
                                                children: filters
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                                        children: "Filters"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                                showArrow: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Dialog), {
                                    className: "outline outline-0 p-4 box-border max-h-[inherit] overflow-auto w-[350px]",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                                            slot: "title",
                                            className: "text-lg font-semibold m-0 mb-2",
                                            children: "Filters"
                                        }),
                                        filters > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            onPress: clearFilters,
                                            variant: "secondary",
                                            className: "absolute top-4 right-4 py-1 px-2 text-xs",
                                            children: "Clear"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-col gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                    isSelected: favorite,
                                                    onChange: setFavorite,
                                                    children: "Favorite"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                                                    label: "Cycle",
                                                    selectionMode: "multiple",
                                                    selectedKeys: cycles,
                                                    onSelectionChange: setCycles,
                                                    escapeKeyBehavior: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Annual",
                                                            color: "green",
                                                            textValue: "Annual",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                                    className: "w-4 h-4 shrink-0"
                                                                }),
                                                                " Annual"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Perennial",
                                                            color: "green",
                                                            textValue: "Perennial",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                                    className: "w-4 h-4 shrink-0"
                                                                }),
                                                                " Perennial"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                                                    label: "Sunlight",
                                                    selectionMode: "multiple",
                                                    selectedKeys: sunlight,
                                                    onSelectionChange: setSunlight,
                                                    escapeKeyBehavior: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "full sun",
                                                            color: "yellow",
                                                            textValue: "Full Sun",
                                                            children: [
                                                                sunIcons['full sun'],
                                                                " Full Sun"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "part sun",
                                                            color: "yellow",
                                                            textValue: "Part Sun",
                                                            children: [
                                                                sunIcons['part sun'],
                                                                " Part Sun"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "part shade",
                                                            color: "yellow",
                                                            textValue: "Part Shade",
                                                            children: [
                                                                sunIcons['part shade'],
                                                                " Part Shade"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                                                    label: "Watering",
                                                    selectionMode: "multiple",
                                                    selectedKeys: watering,
                                                    onSelectionChange: setWatering,
                                                    escapeKeyBehavior: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Frequent",
                                                            color: "blue",
                                                            textValue: "Frequent",
                                                            children: [
                                                                wateringIcons['Frequent'],
                                                                " Frequent"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Average",
                                                            color: "blue",
                                                            textValue: "Average",
                                                            children: [
                                                                wateringIcons['Average'],
                                                                " Average"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Minimum",
                                                            color: "blue",
                                                            textValue: "Minimum",
                                                            children: [
                                                                wateringIcons['Minimum'],
                                                                " Minimum"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TooltipTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        "aria-label": "Columns",
                                        variant: "secondary",
                                        className: "w-9 h-9 shrink-0 p-0 hidden sm:block",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.SlidersIcon), {
                                            "aria-hidden": true,
                                            className: "block w-5 h-5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                                        children: "Columns"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                                selectionMode: "multiple",
                                selectedKeys: visibleColumns,
                                onSelectionChange: setVisibleColumns,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "common_name",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "cycle",
                                        children: "Cycle"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "sunlight",
                                        children: "Sunlight"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "watering",
                                        children: "Watering"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                "aria-label": "Add plant",
                                variant: "secondary",
                                className: "w-9 h-9 shrink-0 p-0 col-start-5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.PlusIcon), {
                                    "aria-hidden": true,
                                    className: "block w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlantModal, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlantDialog, {
                                    onSave: addItem
                                })
                            })
                        ]
                    })
                ]
            }),
            isSmall && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
                "aria-label": "My plants",
                selectionMode: "multiple",
                items: items,
                className: "flex-1 w-full",
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridListItem), {
                        textValue: item.common_name,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "grid grid-cols-[40px_1fr_auto] gap-x-2 w-full",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    alt: "",
                                    src: item.default_image?.thumbnail,
                                    className: "inline rounded-sm row-span-3 object-contain h-[40px]"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "truncate capitalize",
                                    children: item.common_name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "truncate text-xs text-gray-600 dark:text-zinc-400 col-start-2 row-start-2",
                                    children: item.scientific_name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                                    placement: "bottom end",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            "aria-label": "Actions",
                                            variant: "secondary",
                                            className: "row-span-2 place-self-center bg-transparent dark:bg-transparent border-transparent dark:border-transparent !p-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MoreHorizontal), {
                                                className: "w-5 h-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                                            onAction: (action)=>onAction(item, action),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                    id: "favorite",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.StarIcon), {
                                                            "aria-hidden": true,
                                                            className: "w-4 h-4"
                                                        }),
                                                        " ",
                                                        item.isFavorite ? 'Unfavorite' : 'Favorite'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                    id: "edit",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.PencilIcon), {
                                                            "aria-hidden": true,
                                                            className: "w-4 h-4"
                                                        }),
                                                        " Edit\u2026"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                    id: "delete",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.TrashIcon), {
                                                            "aria-hidden": true,
                                                            className: "w-4 h-4"
                                                        }),
                                                        " Delete\u2026"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.SubmenuTrigger), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                            "aria-label": "Share",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ShareIcon), {
                                                                    "aria-hidden": true,
                                                                    className: "w-4 h-4"
                                                                }),
                                                                "Share"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                    href: `https://x.com/intent/tweet?text=${encodeURIComponent(item.common_name)}`,
                                                                    target: "blank",
                                                                    rel: "noopener noreferrer",
                                                                    "aria-label": "X",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Twitter), {
                                                                            "aria-hidden": true,
                                                                            className: "w-4 h-4"
                                                                        }),
                                                                        " X\u2026"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                    href: `mailto:abc@example.com?subject=${encodeURIComponent(item.common_name)}`,
                                                                    target: "blank",
                                                                    rel: "noopener noreferrer",
                                                                    "aria-label": "Email",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Mail), {
                                                                            "aria-hidden": true,
                                                                            className: "w-4 h-4"
                                                                        }),
                                                                        " Email\u2026"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
            }),
            !isSmall && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                "aria-label": "My plants",
                selectionMode: "multiple",
                sortDescriptor: sortDescriptor,
                onSortChange: setSortDescriptor,
                onScroll: onScroll,
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                        columns: columns,
                        children: (column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                                ...column
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                        items: items,
                        dependencies: [
                            columns
                        ],
                        renderEmptyState: ()=>'No results. Try changing the filters.',
                        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Row), {
                                columns: columns,
                                children: (column)=>{
                                    switch(column.id){
                                        case 'favorite':
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FavoriteButton, {
                                                    isSelected: item.isFavorite,
                                                    onChange: (v)=>toggleFavorite(item.id, v)
                                                })
                                            });
                                        case 'common_name':
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                                textValue: item.common_name,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "grid grid-cols-[40px_1fr] gap-x-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            alt: "",
                                                            src: item.default_image?.thumbnail,
                                                            className: "inline rounded-sm row-span-2 object-contain h-[40px] w-[40px]"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "truncate capitalize",
                                                            children: item.common_name
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "truncate text-xs text-gray-600 dark:text-zinc-400",
                                                            children: item.scientific_name
                                                        })
                                                    ]
                                                })
                                            });
                                        case 'cycle':
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CycleLabel, {
                                                    cycle: item.cycle
                                                })
                                            });
                                        case 'sunlight':
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SunLabel, {
                                                    sun: getSunlight(item)
                                                })
                                            });
                                        case 'watering':
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(WateringLabel, {
                                                    watering: item.watering
                                                })
                                            });
                                        case 'actions':
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                            "aria-label": "Actions",
                                                            variant: "secondary",
                                                            className: "bg-transparent dark:bg-transparent border-transparent dark:border-transparent !p-1",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MoreHorizontal), {
                                                                "aria-hidden": true,
                                                                className: "w-5 h-5"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                                                            onAction: (action)=>onAction(item, action),
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                    id: "favorite",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.StarIcon), {
                                                                            "aria-hidden": true,
                                                                            className: "w-4 h-4"
                                                                        }),
                                                                        " ",
                                                                        item.isFavorite ? 'Unfavorite' : 'Favorite'
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                    id: "edit",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.PencilIcon), {
                                                                            "aria-hidden": true,
                                                                            className: "w-4 h-4"
                                                                        }),
                                                                        " Edit\u2026"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                    id: "delete",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.TrashIcon), {
                                                                            "aria-hidden": true,
                                                                            className: "w-4 h-4"
                                                                        }),
                                                                        " Delete\u2026"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.SubmenuTrigger), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                            "aria-label": "Share",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ShareIcon), {
                                                                                    "aria-hidden": true,
                                                                                    className: "w-4 h-4"
                                                                                }),
                                                                                "Share"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                                    href: `https://x.com/intent/tweet?text=${encodeURIComponent(item.common_name)}`,
                                                                                    target: "blank",
                                                                                    rel: "noopener noreferrer",
                                                                                    "aria-label": "X",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Twitter), {
                                                                                            "aria-hidden": true,
                                                                                            className: "w-4 h-4"
                                                                                        }),
                                                                                        " X\u2026"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                                                                    href: `mailto:abc@example.com?subject=${encodeURIComponent(item.common_name)}`,
                                                                                    target: "blank",
                                                                                    rel: "noopener noreferrer",
                                                                                    "aria-label": "Email",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Mail), {
                                                                                            "aria-hidden": true,
                                                                                            className: "w-4 h-4"
                                                                                        }),
                                                                                        " Email\u2026"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            });
                                        default:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
                                    }
                                }
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                isOpen: dialog === 'delete',
                onOpenChange: onDialogClose,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alertDialog.AlertDialog), {
                    title: "Delete Plant",
                    variant: "destructive",
                    actionLabel: "Delete",
                    onAction: deleteItem,
                    children: [
                        'Are you sure you want to delete "',
                        actionItem?.common_name,
                        '"?'
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlantModal, {
                isOpen: dialog === 'edit',
                onOpenChange: onDialogClose,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlantDialog, {
                    item: actionItem,
                    onSave: editItem
                })
            })
        ]
    });
}
const labelStyles = {
    gray: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-zinc-700 dark:text-zinc-300 dark:border-zinc-600',
    green: 'bg-green-100 text-green-700 border-green-200 dark:bg-green-300/20 dark:text-green-400 dark:border-green-300/10',
    yellow: 'bg-yellow-100 text-yellow-700 border-yellow-200 dark:bg-yellow-300/20 dark:text-yellow-400 dark:border-yellow-300/10',
    blue: 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-400/20 dark:text-blue-300 dark:border-blue-400/10'
};
function Label({ color, icon, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: `${labelStyles[color]} text-xs rounded-full border px-2 flex items-center max-w-fit gap-1`,
        children: [
            icon,
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "truncate capitalize",
                children: children
            })
        ]
    });
}
const cycleIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
    "aria-hidden": "true",
    className: "w-4 h-4 shrink-0"
});
function CycleLabel({ cycle }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
        color: "green",
        icon: cycleIcon,
        children: cycle
    });
}
const sunIcons = {
    'full sun': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Sun), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'part sun': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.SunDim), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'part shade': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CloudSun), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    })
};
const sunColors = {
    'full sun': 'yellow',
    'part sun': 'yellow',
    'part shade': 'gray'
};
function SunLabel({ sun }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
        color: sunColors[sun],
        icon: sunIcons[sun],
        children: sun
    });
}
function getSunlight(item) {
    return (item.sunlight.find((s)=>s.startsWith('part')) || item.sunlight[0]).split('/')[0];
}
const wateringIcons = {
    'Frequent': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Droplets), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'Average': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Droplet), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'Minimum': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Dessert), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    })
};
const wateringColors = {
    'Frequent': 'blue',
    'Average': 'blue',
    'Minimum': 'gray'
};
function WateringLabel({ watering }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
        color: wateringColors[watering],
        icon: wateringIcons[watering],
        children: watering
    });
}
function PlantDialog({ item, onSave }) {
    let [droppedImage, setDroppedImage] = (0, _react.useState)(item?.default_image?.thumbnail);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
        className: "outline outline-0 relative",
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                        slot: "title",
                        className: "text-2xl font-semibold leading-6 my-0 text-slate-700 dark:text-zinc-300",
                        children: item ? 'Edit Plant' : 'Add Plant'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Form), {
                        onSubmit: (e)=>{
                            e.preventDefault();
                            close();
                            let data = Object.fromEntries(new FormData(e.currentTarget));
                            data.sunlight = [
                                data.sunlight
                            ];
                            data.scientific_name = [
                                data.scientific_name
                            ];
                            data.default_image = {
                                thumbnail: data.image
                            };
                            data.id = item?.id || Date.now();
                            data.isFavorite = item?.isFavorite || false;
                            onSave(data);
                        },
                        className: "mt-6 flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DropZone), {
                                        getDropOperation: (types)=>types.has('image/jpeg') || types.has('image/png') ? 'copy' : 'cancel',
                                        onDrop: async (e)=>{
                                            let item = e.items.filter((0, _reactAriaComponents.isFileDropItem)).find((item)=>item.type === 'image/jpeg' || item.type === 'image/png');
                                            if (item) setDroppedImage(URL.createObjectURL(await item.getFile()));
                                        },
                                        className: "w-24 sm:w-32 p-2 box-border flex items-center justify-center shrink-0 border-2 border-gray-400 border-dashed rounded-xl text-gray-500 dark:text-gray-300 focus-visible:border-blue-600 forced-colors:focus-visible:border-[Highlight] focus-visible:border-solid drop-target:border-blue-600 forced-colors:drop-target:border-[Highlight] drop-target:border-solid drop-target:bg-blue-200 dark:drop-target:bg-blue-800/60 drop-target:text-blue-600 dark:drop-target:text-blue-300",
                                        children: [
                                            droppedImage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                alt: "",
                                                src: droppedImage,
                                                className: "w-full h-full object-contain aspect-square"
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                                                slot: "label",
                                                className: "italic text-sm text-center",
                                                children: "Drop or paste image here"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "hidden",
                                                name: "image",
                                                value: droppedImage
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col gap-3 flex-1 min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBox), {
                                                label: "Common Name",
                                                name: "common_name",
                                                isRequired: true,
                                                items: (0, _plantsDefault.default),
                                                defaultInputValue: item?.common_name,
                                                allowsCustomValue: true,
                                                autoFocus: navigator.maxTouchPoints === 0,
                                                children: (plant)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBoxItem), {
                                                        children: plant.common_name
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textField.TextField), {
                                                label: "Scientific Name",
                                                name: "scientific_name",
                                                isRequired: true,
                                                defaultValue: item?.scientific_name?.join('')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                label: "Cycle",
                                name: "cycle",
                                isRequired: true,
                                defaultSelectedKey: item?.cycle,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Perennial",
                                        textValue: "Perennial",
                                        children: [
                                            cycleIcon,
                                            " Perennial"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Annual",
                                        textValue: "Annual",
                                        children: [
                                            cycleIcon,
                                            " Annual"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                label: "Sunlight",
                                name: "sunlight",
                                isRequired: true,
                                defaultSelectedKey: item ? getSunlight(item) : undefined,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "full sun",
                                        textValue: "Full Sun",
                                        children: [
                                            sunIcons['full sun'],
                                            " Full Sun"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "part sun",
                                        textValue: "Part Sun",
                                        children: [
                                            sunIcons['part sun'],
                                            " Part Sun"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "part shade",
                                        textValue: "Part Shade",
                                        children: [
                                            sunIcons['part shade'],
                                            " Part Shade"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                label: "Watering",
                                name: "watering",
                                isRequired: true,
                                defaultSelectedKey: item?.watering,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Frequent",
                                        textValue: "Frequent",
                                        children: [
                                            wateringIcons['Frequent'],
                                            " Frequent"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Average",
                                        textValue: "Average",
                                        children: [
                                            wateringIcons['Average'],
                                            " Average"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Minimum",
                                        textValue: "Minimum",
                                        children: [
                                            wateringIcons['Minimum'],
                                            " Minimum"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.DatePicker), {
                                label: "Date Planted",
                                isRequired: true,
                                defaultValue: item ? (0, _date.today)((0, _date.getLocalTimeZone)()) : null
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-6 flex justify-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "secondary",
                                        onPress: close,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "primary",
                                        type: "submit",
                                        children: item ? 'Save' : 'Add'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
}
function PlantModal(props) {
    let [isResized, setResized] = (0, _react.useState)(false);
    let observed = (0, _react.useRef)(null);
    let resizeObserver = (0, _react.useRef)(null);
    let ref = (0, _react.useCallback)((element)=>{
        if (resizeObserver.current && observed.current) {
            resizeObserver.current.unobserve(observed.current);
            resizeObserver.current = null;
            observed.current = null;
        }
        if (element) {
            let height = element.clientHeight;
            if (element.scrollHeight > element.clientHeight) {
                setResized(true);
                return;
            }
            let observer = new ResizeObserver(()=>{
                if (element.clientHeight !== height) setResized(true);
            });
            observer.observe(element);
            resizeObserver.current = observer;
            observed.current = element;
        } else setResized(false);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalOverlay), {
        ...props,
        // Use position: absolute instead of fixed to avoid
        // being clipped to the "inner" viewport in iOS 26
        className: ({ isEntering, isExiting })=>`
      absolute top-0 left-0 w-full h-(--page-height) isolate z-20 bg-black/[15%] backdrop-blur-lg
      ${isEntering ? 'animate-in fade-in duration-200 ease-out' : ''}
      ${isExiting ? 'animate-out fade-out duration-200 ease-in' : ''}
    `,
        children: ({ isEntering, isExiting })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "sticky top-0 left-0 w-full h-(--visual-viewport-height) flex items-center justify-center box-border p-4 text-center",
                    children: [
                        !isResized && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            "data-react-aria-top-layer": "true",
                            className: `absolute top-0 left-0 w-full h-(--visual-viewport-height) z-30 hidden sm:flex items-center justify-center pointer-events-none [filter:drop-shadow(0_0_3px_white)] dark:filter-none
                ${isEntering ? 'animate-in zoom-in-105 ease-out duration-200' : ''}
                ${isExiting ? 'animate-out zoom-out-95 ease-in duration-200' : ''}
              `,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                viewBox: "0 0 700 620",
                                width: 700,
                                height: 620,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Arrow), {
                                        textX: 52,
                                        x1: 88,
                                        x2: 130,
                                        y: 50,
                                        href: "Dialog.html",
                                        children: "Dialog"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Arrow), {
                                        textX: 34,
                                        x1: 88,
                                        x2: 150,
                                        y: 150,
                                        href: "DropZone.html",
                                        children: "DropZone"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Arrow), {
                                        textX: 54,
                                        x1: 88,
                                        x2: 150,
                                        y: 272,
                                        href: "Select.html",
                                        children: "Select"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Arrow), {
                                        textX: 32,
                                        x1: 88,
                                        x2: 150,
                                        y: 492,
                                        href: "DatePicker.html",
                                        children: "DatePicker"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Arrow), {
                                        textX: 616,
                                        x1: 550,
                                        x2: 612,
                                        y: 126,
                                        marker: "markerStart",
                                        href: "ComboBox.html",
                                        children: "ComboBox"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Arrow), {
                                        textX: 616,
                                        x1: 550,
                                        x2: 612,
                                        y: 198,
                                        marker: "markerStart",
                                        href: "TextField.html",
                                        children: "TextField"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Arrow), {
                                        points: "560,90 590,90 590,338 612,338 590,338 590,585 560,585",
                                        textX: 616,
                                        y: 338,
                                        marker: "none",
                                        href: "Form.html",
                                        children: "Form"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
                            ...props,
                            ref: ref,
                            className: ({ isEntering, isExiting })=>`
            w-full max-w-md max-h-full overflow-auto rounded-2xl bg-white dark:bg-zinc-800/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:!bg-[Canvas] box-border p-6 border-box text-left align-middle shadow-2xl bg-clip-padding border border-black/10 dark:border-white/10
            ${isEntering ? 'animate-in zoom-in-105 ease-out duration-200' : ''}
            ${isExiting ? 'animate-out zoom-out-95 ease-in duration-200' : ''}
          `
                        })
                    ]
                })
            })
    });
}
const favoriteButtonStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group cursor-default align-middle rounded-sm border-0 bg-transparent p-0',
    variants: {
        isSelected: {
            false: 'text-gray-500 dark:text-zinc-400 pressed:text-gray-600 dark:pressed:text-zinc-300',
            true: 'text-gray-700 dark:text-slate-300 pressed:text-gray-800 dark:pressed:text-slate-200'
        }
    }
});
function FavoriteButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButton), {
        "aria-label": "Favorite",
        ...props,
        className: favoriteButtonStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.StarIcon), {
            className: "block w-5 h-5 fill-white dark:fill-zinc-900 group-selected:fill-current"
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/AlertDialog":"9KkEN","./components":"bkILc","tailwind-starter/Button":"hk9LL","tailwind-starter/Table":"hjD4g","tailwind-starter/Checkbox":"9J9Ug","lucide-react":[["CloudSun","e905L","default"],["Dessert","dMqjU","default"],["Droplet","csbic","default"],["Droplets","itGFz","default"],["FilterIcon","7C0UI","default"],["Mail","kzuAl","default"],["MoreHorizontal","9vbpj","default"],["PencilIcon","lKTtr","default"],["PlusIcon","d6evu","default"],["RefreshCw","2oAid","default"],["ShareIcon","g4buQ","default"],["SlidersIcon","3FWGC","default"],["StarIcon","fJtT9","default"],["Sun","7xMzH","default"],["SunDim","KyXkF","default"],["TrashIcon","6PyBS","default"],["Twitter","jeVaH","default"]],"react-aria-components":[["Dialog","l2uUY"],["DialogTrigger","l2uUY"],["DropZone","8r9g2"],["Form","g7RKA"],["Heading","2f4nH"],["isFileDropItem","gR4JY"],["Modal","29rOq"],["ModalOverlay","29rOq"],["Text","jt9fm"],["ToggleButton","98v4o"],["TooltipTrigger","fLMVd"]],"tailwind-starter/ComboBox":"3jskB","tailwind-starter/DatePicker":"b5U0H","tailwind-starter/utils":"jNXji","@internationalized/date":"1rmIt","tailwind-starter/GridList":"4hFdV","tailwind-starter/Menu":"iPFGc","tailwind-starter/Modal":"2GPV8","./plants":"kG5mF","tailwind-starter/Popover":"Dr9D3","react":"a1TxN","tailwind-starter/SearchField":"f0WdN","tailwind-starter/Select":"gYM2m","tailwind-starter/TagGroup":"9wXZT","tailwind-starter/TextField":"lhOW9","tailwind-starter/Tooltip":"4lonv","tailwind-variants":"dpXBU","react-aria":[["useCollator","aohjl"],["useFilter","eUaoA"],["VisuallyHidden","7zrGr"]],"@react-spectrum/utils":"5Q3yF","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2Is6Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"6vHrA"}],"6vHrA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"9KkEN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertDialog", ()=>AlertDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAria = require("react-aria");
var _reactAriaComponents = require("react-aria-components");
var _button = require("./Button");
var _dialog = require("./Dialog");
'use client';
function AlertDialog({ title, variant, cancelLabel, actionLabel, onAction, children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        role: "alertdialog",
        ...props,
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                        slot: "title",
                        className: "text-xl font-semibold leading-6 my-0",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `w-6 h-6 absolute right-6 top-6 stroke-2 ${variant === 'destructive' ? 'text-red-500' : 'text-blue-500'}`,
                        children: variant === 'destructive' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircleIcon), {
                            "aria-hidden": true
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.InfoIcon), {
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mt-3 text-slate-500 dark:text-zinc-400",
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-6 flex justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "secondary",
                                onPress: close,
                                children: cancelLabel || 'Cancel'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: variant === 'destructive' ? 'destructive' : 'primary',
                                autoFocus: true,
                                onPress: (0, _reactAria.chain)(onAction, close),
                                children: actionLabel
                            })
                        ]
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["AlertCircleIcon","gpCZd","default"],["InfoIcon","bTmmM","default"]],"react":"a1TxN","react-aria":"ij7eS","react-aria-components":"2f4nH","./Button":"hk9LL","./Dialog":"cRN3c","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gpCZd":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleAlert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const CircleAlert = (0, _createLucideIconJsDefault.default)("circle-alert", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3OmcS":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bTmmM":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Info);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const Info = (0, _createLucideIconJsDefault.default)("info", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hk9LL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
let button = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative inline-flex items-center border-0 px-5 [&:has(svg:only-child)]:px-2 py-2 font-sans text-sm text-center transition rounded-lg border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none cursor-default',
    variants: {
        variant: {
            primary: 'bg-blue-600 hover:bg-blue-700 pressed:bg-blue-800 text-white',
            secondary: 'bg-gray-50 hover:bg-gray-100 pressed:bg-gray-200 text-gray-800 dark:bg-zinc-600 dark:hover:bg-zinc-500 dark:pressed:bg-zinc-400 dark:text-zinc-100',
            destructive: 'bg-red-700 hover:bg-red-800 pressed:bg-red-900 text-white'
        },
        isDisabled: {
            true: 'bg-gray-100 dark:bg-zinc-800 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5'
        },
        isPending: {
            true: 'text-transparent'
        }
    },
    defaultVariants: {
        variant: 'primary'
    }
});
function Button(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>button({
                ...renderProps,
                variant: props.variant,
                className
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isPending })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    isPending && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": true,
                        className: "flex absolute inset-0 justify-center items-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            className: "w-4 h-4 text-white animate-spin",
                            viewBox: "0 0 24 24",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    strokeWidth: "4",
                                    fill: "none",
                                    className: "opacity-25"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    strokeWidth: "4",
                                    strokeLinecap: "round",
                                    fill: "none",
                                    pathLength: "100",
                                    strokeDasharray: "60 140",
                                    strokeDashoffset: "0"
                                })
                            ]
                        })
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jNXji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusRing", ()=>focusRing);
parcelHelpers.export(exports, "composeTailwindRenderProps", ()=>composeTailwindRenderProps);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
const focusRing = (0, _tailwindVariants.tv)({
    base: 'outline outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2',
    variants: {
        isFocusVisible: {
            false: 'outline-0',
            true: 'outline-2'
        }
    }
});
function composeTailwindRenderProps(className, tw) {
    return (0, _reactAriaComponents.composeRenderProps)(className, (className)=>(0, _tailwindMerge.twMerge)(tw, className));
}

},{"react-aria-components":"bA6Cz","tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cRN3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
'use client';
function Dialog(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('outline outline-0 box-border p-6 [[data-placement]>&]:p-4 max-h-[inherit] overflow-auto relative', props.className)
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"l2uUY","tailwind-merge":"lEVAz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bkILc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Window", ()=>Window);
parcelHelpers.export(exports, "FileTab", ()=>FileTab);
parcelHelpers.export(exports, "AddressBar", ()=>AddressBar);
parcelHelpers.export(exports, "GradientText", ()=>GradientText);
parcelHelpers.export(exports, "Card", ()=>Card);
parcelHelpers.export(exports, "CardTitle", ()=>CardTitle);
parcelHelpers.export(exports, "CardDescription", ()=>CardDescription);
parcelHelpers.export(exports, "Arrow", ()=>Arrow);
parcelHelpers.export(exports, "Finger", ()=>Finger);
parcelHelpers.export(exports, "LearnMoreLink", ()=>LearnMoreLink);
parcelHelpers.export(exports, "Scrollable", ()=>Scrollable);
parcelHelpers.export(exports, "Section", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Window({ children, className = '', isBackground = false, toolbar }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `${className} flex flex-col border border-black/10 dark:border-white/20 bg-clip-content border-solid dark:text-white delay-100 duration-700 ease-out overflow-hidden rounded-lg ${isBackground ? 'shadow-lg' : 'shadow-xl'} text-black transition translate-y-0 opacity-100`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "bg-gray-200/80 dark:bg-zinc-700/80 backdrop-blur-md border-b border-gray-300 dark:border-white/10 flex flex-row px-3 relative shadow-[inset_0_1px_0_0_rgba(255,255,255,0.3)] dark:shadow-none",
                children: [
                    toolbar,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "absolute flex flex-row left-4 top-3.5 forced-color-adjust-none",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `${isBackground ? 'bg-gray-300 dark:bg-zinc-500' : 'bg-red-500'} box-border border border-black/5 h-3 mr-2 rounded-full w-3`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `${isBackground ? 'bg-gray-300 dark:bg-zinc-500' : 'bg-yellow-500'} box-border border border-black/5 h-3 mr-2 rounded-full w-3`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `${isBackground ? 'bg-gray-300 dark:bg-zinc-500' : 'bg-green-500'} box-border border border-black/5 h-3 rounded-full w-3`
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
}
function FileTab({ children, className = '' }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `${className} w-fit mt-3 border border-b-0 border-gray-300 bg-gray-50 dark:bg-zinc-600 dark:border-white/10 -mb-px rounded-t-md px-3 py-2 text-xs text-gray-500 dark:text-gray-300 first:ml-20 only:ml-0`,
        children: children
    });
}
function AddressBar({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "bg-gray-400/40 dark:bg-zinc-500/40 px-5 md:px-10 py-1 ml-20 sm:mx-auto my-2.5 rounded-md text-slate-600 dark:text-slate-300 text-xs",
        children: children
    });
}
function GradientText({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-transparent bg-clip-text bg-linear-to-b from-slate-600 to-slate-900 dark:from-white dark:to-zinc-400",
        children: children
    });
}
function Card({ className, ...otherProps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex flex-col bg-white dark:bg-zinc-800/80 dark:backdrop-saturate-200 rounded-2xl box-border p-6 overflow-hidden card-shadow snap-center snap-always ${className}`,
        ...otherProps
    });
}
function CardTitle({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
        className: "text-xl font-semibold m-0 mb-2 text-gray-800 dark:text-gray-100",
        children: children
    });
}
function CardDescription({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "m-0 text-gray-600 dark:text-gray-400 text-base [text-wrap:pretty] [&_a]:text-blue-600 dark:[&_a]:text-blue-400 [&_a]:underline",
        children: children
    });
}
function Arrow({ href, children, textX, x1, x2, points, y, marker = 'markerEnd' }) {
    let markerProps = marker === 'none' ? {} : {
        [marker]: 'url(#arrow)'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            points ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                points: points,
                ...markerProps,
                className: "stroke-slate-800 dark:stroke-white fill-none"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                x1: x1,
                y1: y,
                x2: x2,
                y2: y,
                ...markerProps,
                className: "stroke-slate-800 dark:stroke-white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: href,
                target: "_blank",
                className: "pointer-events-auto outline-hidden rounded-xs focus:outline-blue-600 dark:focus:outline-blue-500 outline-offset-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    x: textX,
                    y: y + 3,
                    className: "text-xs fill-slate-900 dark:fill-white underline",
                    children: children
                })
            })
        ]
    });
}
const Finger = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: "z-10 pointer-events-none absolute w-10 h-10 rounded-full border border-black/80 bg-black/80 dark:border-white/80 dark:bg-white/80 dark:mix-blend-difference opacity-0 [--hover-opacity:0.15] [--pressed-opacity:0.3] forced-colors:[--hover-opacity:0.5] forced-colors:[--pressed-opacity:1] forced-colors:bg-[Highlight]! forced-colors:mix-blend-normal!",
        ...props
    });
});
function LearnMoreLink({ href, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
        href: href,
        className: `group inline-block mt-6 mb-12 no-underline text-xl rounded-full px-4 -mx-4 py-1 transition focus-ring active:scale-95 ${className}`,
        children: [
            "Learn more",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                "aria-hidden": true,
                className: "inline w-5 h-5 align-middle ml-1 will-change-transform group-hover:translate-x-0.5 transition -mt-1"
            })
        ]
    });
}
function Scrollable({ children, className = '' }) {
    // eslint-disable-next-line
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        tabIndex: 0,
        className: `overflow-x-auto overflow-y-hidden focus-ring -outline-offset-2 ${className}`,
        children: children
    });
}
function Section({ children, className = '' }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        className: `px-8 md:px-20 xl:px-36 xl:-mx-16 pb-20 md:pb-56 ${className}`,
        children: children
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ArrowRight","72LCi","default"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"72LCi":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const ArrowRight = (0, _createLucideIconJsDefault.default)("arrow-right", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hjD4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "Row", ()=>Row);
parcelHelpers.export(exports, "Cell", ()=>Cell);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _checkbox = require("./Checkbox");
var _utils = require("./utils");
'use client';
function Table(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ResizableTableContainer), {
        onScroll: props.onScroll,
        className: (0, _tailwindMerge.twMerge)('w-full max-h-[320px] overflow-auto scroll-pt-[2.281rem] relative bg-white dark:bg-zinc-900 box-border border border-gray-300 dark:border-zinc-600 rounded-lg font-sans', props.className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Table), {
            ...props,
            className: "border-separate border-spacing-0 box-border overflow-hidden has-[>[data-empty]]:h-full"
        })
    });
}
const columnStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'px-2 h-5 box-border flex-1 flex gap-1 items-center overflow-hidden'
});
const resizerStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-px px-[8px] translate-x-[8px] box-content py-1 h-5 bg-clip-content bg-gray-400 dark:bg-zinc-500 forced-colors:bg-[ButtonBorder] cursor-col-resize rounded-xs resizing:bg-blue-600 forced-colors:resizing:bg-[Highlight] resizing:w-[2px] resizing:pl-[7px] -outline-offset-2'
});
function Column(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'box-border h-1 [&:hover]:z-20 focus-within:z-20 text-start text-sm font-semibold text-gray-700 dark:text-zinc-300 cursor-default'),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { allowsSorting, sortDirection })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Group), {
                        role: "presentation",
                        tabIndex: -1,
                        className: columnStyles,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "truncate",
                                children: children
                            }),
                            allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `w-4 h-4 flex items-center justify-center transition ${sortDirection === 'descending' ? 'rotate-180' : ''}`,
                                children: sortDirection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUp), {
                                    "aria-hidden": true,
                                    className: "w-4 h-4 text-gray-500 dark:text-zinc-400 forced-colors:text-[ButtonText]"
                                })
                            })
                        ]
                    }),
                    !props.width && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColumnResizer), {
                        className: resizerStyles
                    })
                ]
            }))
    });
}
function TableHeader(props) {
    let { selectionBehavior, selectionMode, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableHeader), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'sticky top-0 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 dark:supports-[-moz-appearance:none]:bg-zinc-700 forced-colors:bg-[Canvas] rounded-t-lg border-b border-b-gray-200 dark:border-b-zinc-700'),
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Column, {}),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                width: 36,
                minWidth: 36,
                className: "box-border p-2 text-sm font-semibold cursor-default text-start",
                children: selectionMode === 'multiple' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: props.columns,
                children: props.children
            })
        ]
    });
}
function TableBody(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableBody), {
        ...props,
        className: "empty:italic empty:text-center empty:text-sm"
    });
}
const rowStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group/row relative cursor-default select-none -outline-offset-2 text-gray-900 disabled:text-gray-300 dark:text-zinc-200 dark:disabled:text-zinc-600 text-sm hover:bg-gray-100 dark:hover:bg-zinc-700/60 selected:bg-blue-100 selected:hover:bg-blue-200 dark:selected:bg-blue-700/30 dark:selected:hover:bg-blue-700/40'
});
function Row({ id, columns, children, ...otherProps }) {
    let { selectionBehavior, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Row), {
        id: id,
        ...otherProps,
        className: rowStyles,
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                    slot: "drag",
                    children: "\u2261"
                })
            }),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
const cellStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'box-border border-b border-b-gray-200 dark:border-b-zinc-700 group-last/row:border-b-0 [--selected-border:var(--color-blue-200)] dark:[--selected-border:var(--color-blue-900)] group-selected/row:border-(--selected-border) in-[:has(+[data-selected])]:border-(--selected-border) p-2 truncate -outline-offset-2'
});
function Cell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
        ...props,
        className: cellStyles
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ArrowUp","fi8VG","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["Cell","3vnUd"],["Column","3vnUd"],["ColumnResizer","3vnUd"],["ResizableTableContainer","3vnUd"],["Row","3vnUd"],["Table","3vnUd"],["TableBody","3vnUd"],["TableHeader","3vnUd"],["useTableOptions","3vnUd"],["Collection","2Jd0Q"],["composeRenderProps","bA6Cz"],["Group","6UspO"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./Checkbox":"9J9Ug","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fi8VG":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
];
const ArrowUp = (0, _createLucideIconJsDefault.default)("arrow-up", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9J9Ug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroup", ()=>CheckboxGroup);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
function CheckboxGroup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.CheckboxGroup), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col gap-2 font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: props.label
            }),
            props.children,
            props.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: props.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: props.errorMessage
            })
        ]
    });
}
const checkboxStyles = (0, _tailwindVariants.tv)({
    base: 'flex gap-2 items-center group font-sans text-sm transition relative',
    variants: {
        isDisabled: {
            false: 'text-gray-800 dark:text-zinc-200',
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
const boxStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-5 h-5 box-border shrink-0 rounded-sm flex items-center justify-center border-2 transition',
    variants: {
        isSelected: {
            false: 'bg-white dark:bg-zinc-900 border-(--color) [--color:var(--color-gray-400)] dark:[--color:var(--color-zinc-400)] group-pressed:[--color:var(--color-gray-500)] dark:group-pressed:[--color:var(--color-zinc-300)]',
            true: 'bg-(--color) border-(--color) [--color:var(--color-gray-700)] group-pressed:[--color:var(--color-gray-800)] dark:[--color:var(--color-slate-300)] dark:group-pressed:[--color:var(--color-slate-200)] forced-colors:[--color:Highlight]!'
        },
        isInvalid: {
            true: '[--color:var(--color-red-700)] dark:[--color:var(--color-red-600)] forced-colors:[--color:Mark]! group-pressed:[--color:var(--color-red-800)] dark:group-pressed:[--color:var(--color-red-700)]'
        },
        isDisabled: {
            true: '[--color:var(--color-gray-200)] dark:[--color:var(--color-zinc-700)] forced-colors:[--color:GrayText]!'
        }
    }
});
const iconStyles = 'w-4 h-4 text-white group-disabled:text-gray-400 dark:text-slate-900 dark:group-disabled:text-slate-600 forced-colors:text-[HighlightText]';
function Checkbox(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Checkbox), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>checkboxStyles({
                ...renderProps,
                className
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isSelected, isIndeterminate, ...renderProps })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: boxStyles({
                            isSelected: isSelected || isIndeterminate,
                            ...renderProps
                        }),
                        children: isIndeterminate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Minus), {
                            "aria-hidden": true,
                            className: iconStyles
                        }) : isSelected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                            "aria-hidden": true,
                            className: iconStyles
                        }) : null
                    }),
                    children
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["Check","9PYFQ","default"],["Minus","5Mlaw","default"]],"react":"a1TxN","react-aria-components":[["Checkbox","9jC2J"],["CheckboxGroup","9jC2J"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9PYFQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Check);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const Check = (0, _createLucideIconJsDefault.default)("check", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Mlaw":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Minus);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
];
const Minus = (0, _createLucideIconJsDefault.default)("minus", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5fXWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "fieldBorderStyles", ()=>fieldBorderStyles);
parcelHelpers.export(exports, "fieldGroupStyles", ()=>fieldGroupStyles);
parcelHelpers.export(exports, "FieldGroup", ()=>FieldGroup);
parcelHelpers.export(exports, "Input", ()=>Input);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('text-sm text-gray-600 dark:text-zinc-400 font-medium cursor-default w-fit', props.className)
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props,
        slot: "description",
        className: (0, _tailwindMerge.twMerge)('text-sm text-gray-600', props.className)
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'text-sm text-red-600 forced-colors:text-[Mark]')
    });
}
const fieldBorderStyles = (0, _tailwindVariants.tv)({
    variants: {
        isFocusWithin: {
            false: 'border-gray-300 dark:border-zinc-500 forced-colors:border-[ButtonBorder]',
            true: 'border-gray-600 dark:border-zinc-300 forced-colors:border-[Highlight]'
        },
        isInvalid: {
            true: 'border-red-600 dark:border-red-600 forced-colors:border-[Mark]'
        },
        isDisabled: {
            true: 'border-gray-200 dark:border-zinc-700 forced-colors:border-[GrayText]'
        }
    }
});
const fieldGroupStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group flex items-center h-9 box-border bg-white dark:bg-zinc-900 forced-colors:bg-[Field] border-2 rounded-lg overflow-hidden',
    variants: fieldBorderStyles.variants
});
function FieldGroup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>fieldGroupStyles({
                ...renderProps,
                className
            }))
    });
}
function Input(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Input), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'px-2 py-1.5 flex-1 min-w-0 border-0 outline outline-0 bg-white dark:bg-zinc-900 text-sm text-gray-800 dark:text-zinc-200 disabled:text-gray-200 dark:disabled:text-zinc-600')
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["composeRenderProps","bA6Cz"],["FieldError","algyu"],["Group","6UspO"],["Input","jU9y1"],["Label","fjKq6"],["Text","jt9fm"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e905L":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CloudSun);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ],
    [
        "path",
        {
            d: "M15.947 12.65a4 4 0 0 0-5.925-4.128",
            key: "dpwdj0"
        }
    ],
    [
        "path",
        {
            d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z",
            key: "s09mg5"
        }
    ]
];
const CloudSun = (0, _createLucideIconJsDefault.default)("cloud-sun", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dMqjU":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Dessert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "4",
            r: "2",
            key: "muu5ef"
        }
    ],
    [
        "path",
        {
            d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
            key: "lfo06j"
        }
    ],
    [
        "path",
        {
            d: "M3.2 14.8a9 9 0 0 0 17.6 0",
            key: "12xarc"
        }
    ]
];
const Dessert = (0, _createLucideIconJsDefault.default)("dessert", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"csbic":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Droplet);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
            key: "c7niix"
        }
    ]
];
const Droplet = (0, _createLucideIconJsDefault.default)("droplet", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"itGFz":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Droplets);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
            key: "1ptgy4"
        }
    ],
    [
        "path",
        {
            d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
            key: "1sl1rz"
        }
    ]
];
const Droplets = (0, _createLucideIconJsDefault.default)("droplets", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7C0UI":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Funnel);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const Funnel = (0, _createLucideIconJsDefault.default)("funnel", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kzuAl":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Mail);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const Mail = (0, _createLucideIconJsDefault.default)("mail", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9vbpj":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Ellipsis);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
];
const Ellipsis = (0, _createLucideIconJsDefault.default)("ellipsis", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lKTtr":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Pencil);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const Pencil = (0, _createLucideIconJsDefault.default)("pencil", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d6evu":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Plus);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const Plus = (0, _createLucideIconJsDefault.default)("plus", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2oAid":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>RefreshCw);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const RefreshCw = (0, _createLucideIconJsDefault.default)("refresh-cw", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g4buQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Share);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 2v13",
            key: "1km8f5"
        }
    ],
    [
        "path",
        {
            d: "m16 6-4-4-4 4",
            key: "13yo43"
        }
    ],
    [
        "path",
        {
            d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
            key: "1b2hhj"
        }
    ]
];
const Share = (0, _createLucideIconJsDefault.default)("share", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3FWGC":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>SlidersVertical);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "line",
        {
            x1: "4",
            x2: "4",
            y1: "21",
            y2: "14",
            key: "1p332r"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "4",
            y1: "10",
            y2: "3",
            key: "gb41h5"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "21",
            y2: "12",
            key: "hf2csr"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "3",
            key: "1kfi7u"
        }
    ],
    [
        "line",
        {
            x1: "20",
            x2: "20",
            y1: "21",
            y2: "16",
            key: "1lhrwl"
        }
    ],
    [
        "line",
        {
            x1: "20",
            x2: "20",
            y1: "12",
            y2: "3",
            key: "16vvfq"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "6",
            y1: "14",
            y2: "14",
            key: "1uebub"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "14",
            y1: "8",
            y2: "8",
            key: "1yglbp"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "22",
            y1: "16",
            y2: "16",
            key: "1jxqpz"
        }
    ]
];
const SlidersVertical = (0, _createLucideIconJsDefault.default)("sliders-vertical", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fJtT9":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Star);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const Star = (0, _createLucideIconJsDefault.default)("star", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7xMzH":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Sun);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m17.66 17.66 1.41 1.41",
            key: "ptbguv"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ]
];
const Sun = (0, _createLucideIconJsDefault.default)("sun", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"KyXkF":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>SunDim);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 4h.01",
            key: "1ujb9j"
        }
    ],
    [
        "path",
        {
            d: "M20 12h.01",
            key: "1ykeid"
        }
    ],
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h.01",
            key: "158zrr"
        }
    ],
    [
        "path",
        {
            d: "M17.657 6.343h.01",
            key: "31pqzk"
        }
    ],
    [
        "path",
        {
            d: "M17.657 17.657h.01",
            key: "jehnf4"
        }
    ],
    [
        "path",
        {
            d: "M6.343 17.657h.01",
            key: "gdk6ow"
        }
    ],
    [
        "path",
        {
            d: "M6.343 6.343h.01",
            key: "1uurf0"
        }
    ]
];
const SunDim = (0, _createLucideIconJsDefault.default)("sun-dim", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6PyBS":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Trash);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ]
];
const Trash = (0, _createLucideIconJsDefault.default)("trash", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jeVaH":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Twitter);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
            key: "pff0z6"
        }
    ]
];
const Twitter = (0, _createLucideIconJsDefault.default)("twitter", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8r9g2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZoneContext", ()=>DropZoneContext);
parcelHelpers.export(exports, "DropZone", ()=>DropZone);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const DropZoneContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DropZone = /*#__PURE__*/ (0, _react.forwardRef)(function DropZone(props, ref) {
    let { isDisabled = false } = props;
    [props, ref] = (0, _utils.useContextProps)(props, ref, DropZoneContext);
    let dropzoneRef = (0, _utils1.useObjectRef)(ref);
    let buttonRef = (0, _react.useRef)(null);
    let { dropProps, dropButtonProps, isDropTarget } = (0, _reactAria.useDrop)({
        ...props,
        ref: buttonRef,
        hasDropButton: true
    });
    let { buttonProps } = (0, _reactAria.useButton)(dropButtonProps || {}, buttonRef);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let stringFormatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), 'react-aria-components');
    let textId = (0, _utils1.useSlotId)();
    let ariaLabel = props['aria-label'] || stringFormatter.format('dropzoneLabel');
    let messageId = props['aria-labelledby'];
    let ariaLabelledby = [
        textId,
        messageId
    ].filter(Boolean).join(' ');
    let labelProps = (0, _utils1.useLabels)({
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    let { clipboardProps } = (0, _reactAria.useClipboard)({
        isDisabled,
        onPaste: (items)=>props.onDrop?.({
                type: 'drop',
                items,
                x: 0,
                y: 0,
                dropOperation: 'copy'
            })
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDropTarget,
            isDisabled
        },
        defaultClassName: 'react-aria-DropZone'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _text.TextContext),
                {
                    id: textId,
                    slot: 'label'
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, dropProps, hoverProps),
        slot: props.slot || undefined,
        ref: dropzoneRef,
        onClick: (e)=>{
            let target = e.target;
            while(target && dropzoneRef.current?.contains(target)){
                if ((0, _utils1.isFocusable)(target)) break;
                else if (target === dropzoneRef.current) {
                    buttonRef.current?.focus();
                    break;
                }
                target = target.parentElement;
            }
        },
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-drop-target": isDropTarget || undefined,
        "data-disabled": isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _reactAria.mergeProps)(buttonProps, focusProps, clipboardProps, labelProps),
        ref: buttonRef
    })), renderProps.children));
});

},{"./utils":"bA6Cz","react-aria":[["mergeProps","aNvcY"],["useButton","exEOU"],["useClipboard","5RCSJ"],["useDrop","k4cyN"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useLocalizedStringFormatter","7lxyl"],["VisuallyHidden","7zrGr"]],"@react-aria/utils":[["filterDOMProps","3upVm"],["isFocusable","72VDv"],["useLabels","7Uhyw"],["useObjectRef","laqO5"],["useSlotId","jbI4Y"]],"../intl/*.json":"ibVl8","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5RCSJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles clipboard interactions for a focusable element. Supports items of multiple
 * data types, and integrates with the operating system native clipboard.
 */ parcelHelpers.export(exports, "useClipboard", ()=>useClipboard);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
const globalEvents = new Map();
function addGlobalEventListener(event, fn) {
    let eventData = globalEvents.get(event);
    if (!eventData) {
        let handlers = new Set();
        let listener = (e)=>{
            for (let handler of handlers)handler(e);
        };
        eventData = {
            listener,
            handlers
        };
        globalEvents.set(event, eventData);
        document.addEventListener(event, listener);
    }
    eventData.handlers.add(fn);
    return ()=>{
        eventData.handlers.delete(fn);
        if (eventData.handlers.size === 0) {
            document.removeEventListener(event, eventData.listener);
            globalEvents.delete(event);
        }
    };
}
function useClipboard(options) {
    let { isDisabled } = options;
    let isFocusedRef = (0, _react.useRef)(false);
    let { focusProps } = (0, _interactions.useFocus)({
        onFocusChange: (isFocused)=>{
            isFocusedRef.current = isFocused;
        }
    });
    let onBeforeCopy = (0, _utils.useEffectEvent)((e)=>{
        // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
        if (isFocusedRef.current && options.getItems) e.preventDefault();
    });
    let onCopy = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'copy'
            }));
            options.onCopy?.();
        }
    });
    let onBeforeCut = (0, _utils.useEffectEvent)((e)=>{
        if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
    });
    let onCut = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'cut'
            }));
            options.onCut();
        }
    });
    let onBeforePaste = (0, _utils.useEffectEvent)((e)=>{
        // Unfortunately, e.clipboardData.types is not available in this event so we always
        // have to enable the Paste menu item even if the type of data is unsupported.
        if (isFocusedRef.current && options.onPaste) e.preventDefault();
    });
    let onPaste = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onPaste) return;
        e.preventDefault();
        if (e.clipboardData) {
            let items = (0, _utils1.readFromDataTransfer)(e.clipboardData);
            options.onPaste(items);
        }
    });
    (0, _react.useEffect)(()=>{
        if (isDisabled) return;
        return (0, _utils.chain)(addGlobalEventListener('beforecopy', onBeforeCopy), addGlobalEventListener('copy', onCopy), addGlobalEventListener('beforecut', onBeforeCut), addGlobalEventListener('cut', onCut), addGlobalEventListener('beforepaste', onBeforePaste), addGlobalEventListener('paste', onPaste));
    }, [
        isDisabled
    ]);
    return {
        clipboardProps: focusProps
    };
}

},{"@react-aria/utils":[["chain","ij7eS"],["useEffectEvent","eg4dC"]],"./utils":"gR4JY","react":"a1TxN","@react-aria/interactions":"j8nkn","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gR4JY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "droppableCollectionMap", ()=>droppableCollectionMap);
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>DIRECTORY_DRAG_TYPE);
parcelHelpers.export(exports, "getDroppableCollectionId", ()=>getDroppableCollectionId);
parcelHelpers.export(exports, "getDroppableCollectionRef", ()=>getDroppableCollectionRef);
parcelHelpers.export(exports, "getTypes", ()=>getTypes);
parcelHelpers.export(exports, "useDragModality", ()=>useDragModality);
parcelHelpers.export(exports, "getDragModality", ()=>getDragModality);
parcelHelpers.export(exports, "writeToDataTransfer", ()=>writeToDataTransfer);
parcelHelpers.export(exports, "DragTypes", ()=>DragTypes);
parcelHelpers.export(exports, "readFromDataTransfer", ()=>readFromDataTransfer);
/** Returns whether a drop item contains text data. */ parcelHelpers.export(exports, "isTextDropItem", ()=>isTextDropItem);
/** Returns whether a drop item is a file. */ parcelHelpers.export(exports, "isFileDropItem", ()=>isFileDropItem);
/** Returns whether a drop item is a directory. */ parcelHelpers.export(exports, "isDirectoryDropItem", ()=>isDirectoryDropItem);
parcelHelpers.export(exports, "globalDndState", ()=>globalDndState);
parcelHelpers.export(exports, "setDraggingCollectionRef", ()=>setDraggingCollectionRef);
parcelHelpers.export(exports, "setDraggingKeys", ()=>setDraggingKeys);
parcelHelpers.export(exports, "setDropCollectionRef", ()=>setDropCollectionRef);
parcelHelpers.export(exports, "clearGlobalDnDState", ()=>clearGlobalDnDState);
parcelHelpers.export(exports, "setGlobalDnDState", ()=>setGlobalDnDState);
// Util function to check if the current dragging collection ref is the same as the current targeted droppable collection ref.
// Allows a droppable ref arg in case the global drop collection ref hasn't been set
parcelHelpers.export(exports, "isInternalDropOperation", ()=>isInternalDropOperation);
parcelHelpers.export(exports, "globalDropEffect", ()=>globalDropEffect);
parcelHelpers.export(exports, "setGlobalDropEffect", ()=>setGlobalDropEffect);
parcelHelpers.export(exports, "globalAllowedDropOperations", ()=>globalAllowedDropOperations);
parcelHelpers.export(exports, "setGlobalAllowedDropOperations", ()=>setGlobalAllowedDropOperations);
var _constants = require("./constants");
var _interactions = require("@react-aria/interactions");
const droppableCollectionMap = new WeakMap();
const DIRECTORY_DRAG_TYPE = Symbol();
function getDroppableCollectionId(state) {
    let { id } = droppableCollectionMap.get(state) || {};
    if (!id) throw new Error('Droppable item outside a droppable collection');
    return id;
}
function getDroppableCollectionRef(state) {
    let { ref } = droppableCollectionMap.get(state) || {};
    if (!ref) throw new Error('Droppable item outside a droppable collection');
    return ref;
}
function getTypes(items) {
    let types = new Set();
    for (let item of items)for (let type of Object.keys(item))types.add(type);
    return types;
}
function mapModality(modality) {
    if (!modality) modality = 'virtual';
    if (modality === 'pointer') modality = 'virtual';
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'touch';
    return modality;
}
function useDragModality() {
    return mapModality((0, _interactions.useInteractionModality)());
}
function getDragModality() {
    return mapModality((0, _interactions.getInteractionModality)());
}
function writeToDataTransfer(dataTransfer, items) {
    // The data transfer API doesn't support more than one item of a given type at once.
    // In addition, only a small set of types are supported natively for transfer between applications.
    // We allow for both multiple items, as well as multiple representations of a single item.
    // In order to make our API work with the native API, we serialize all items to JSON and
    // store as a single native item. We only need to do this if there is more than one item
    // of the same type, or if an item has more than one representation. Otherwise the native
    // API is sufficient.
    //
    // The DataTransferItemList API also theoretically supports adding files, which would enable
    // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
    // this does not currently work in any browser, so it is not currently supported by our API.
    // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
    let groupedByType = new Map();
    let needsCustomData = false;
    let customData = [];
    for (let item of items){
        let types = Object.keys(item);
        if (types.length > 1) needsCustomData = true;
        let dataByType = {};
        for (let type of types){
            let typeItems = groupedByType.get(type);
            if (!typeItems) {
                typeItems = [];
                groupedByType.set(type, typeItems);
            } else needsCustomData = true;
            let data = item[type];
            dataByType[type] = data;
            typeItems.push(data);
        }
        customData.push(dataByType);
    }
    for (let [type, items] of groupedByType)if ((0, _constants.NATIVE_DRAG_TYPES).has(type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        let data = items.join('\n');
        dataTransfer.items.add(data, type);
    } else // Set data to the first item so we have access to the list of types.
    dataTransfer.items.add(items[0], type);
    if (needsCustomData) {
        let data = JSON.stringify(customData);
        dataTransfer.items.add(data, (0, _constants.CUSTOM_DRAG_TYPE));
    }
}
class DragTypes {
    constructor(dataTransfer){
        this.types = new Set();
        let hasFiles = false;
        for (let item of dataTransfer.items)if (item.type !== (0, _constants.CUSTOM_DRAG_TYPE)) {
            if (item.kind === 'file') hasFiles = true;
            if (item.type) this.types.add(item.type);
            else // Files with unknown types or extensions that don't map to a known mime type
            // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, _constants.GENERIC_TYPE));
        }
        // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
        // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
        // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
        this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes('Files');
    }
    has(type) {
        if (this.includesUnknownTypes || type === DIRECTORY_DRAG_TYPE && this.types.has((0, _constants.GENERIC_TYPE))) return true;
        return typeof type === 'string' && this.types.has(type);
    }
}
function readFromDataTransfer(dataTransfer) {
    let items = [];
    if (!dataTransfer) return items;
    // If our custom drag type is available, use that. This is a JSON serialized
    // representation of all items in the drag, set when there are multiple items
    // of the same type, or an individual item has multiple representations.
    let hasCustomType = false;
    if (dataTransfer.types.includes((0, _constants.CUSTOM_DRAG_TYPE))) try {
        let data = dataTransfer.getData((0, _constants.CUSTOM_DRAG_TYPE));
        let parsed = JSON.parse(data);
        for (let item of parsed)items.push({
            kind: 'text',
            types: new Set(Object.keys(item)),
            getText: (type)=>Promise.resolve(item[type])
        });
        hasCustomType = true;
    } catch  {
    // ignore
    }
    // Otherwise, map native drag items to items of a single representation.
    if (!hasCustomType) {
        let stringItems = new Map();
        for (let item of dataTransfer.items){
            if (item.kind === 'string') // The data for all formats must be read here because the data transfer gets
            // cleared out after the event handler finishes. If the item has an empty string
            // as a type, the mime type is unknown. Map to a generic mime type instead.
            stringItems.set(item.type || (0, _constants.GENERIC_TYPE), dataTransfer.getData(item.type));
            else if (item.kind === 'file') {
                // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
                // In the future, we may use getAsFileSystemHandle instead, but that's currently
                // only implemented in Chrome.
                if (typeof item.webkitGetAsEntry === 'function') {
                    let entry = item.webkitGetAsEntry();
                    // eslint-disable-next-line max-depth
                    if (!entry) continue;
                    // eslint-disable-next-line max-depth
                    if (entry.isFile) items.push(createFileItem(item.getAsFile()));
                    else if (entry.isDirectory) items.push(createDirectoryItem(entry));
                } else // Assume it's a file.
                items.push(createFileItem(item.getAsFile()));
            }
        }
        // All string items are different representations of the same item. There's no way to have
        // multiple string items at once in the current DataTransfer API.
        if (stringItems.size > 0) items.push({
            kind: 'text',
            types: new Set(stringItems.keys()),
            getText: (type)=>Promise.resolve(stringItems.get(type))
        });
    }
    return items;
}
function blobToString(blob) {
    if (typeof blob.text === 'function') return blob.text();
    // Safari doesn't have the Blob#text() method yet...
    return new Promise((resolve, reject)=>{
        let reader = new FileReader;
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}
function createFileItem(file) {
    if (!file) throw new Error('No file provided');
    return {
        kind: 'file',
        type: file.type || (0, _constants.GENERIC_TYPE),
        name: file.name,
        getText: ()=>blobToString(file),
        getFile: ()=>Promise.resolve(file)
    };
}
function createDirectoryItem(entry) {
    return {
        kind: 'directory',
        name: entry.name,
        getEntries: ()=>getEntries(entry)
    };
}
async function* getEntries(item) {
    let reader = item.createReader();
    // We must call readEntries repeatedly because there may be a limit to the
    // number of entries that are returned at once.
    let entries;
    do {
        entries = await new Promise((resolve, reject)=>{
            reader.readEntries(resolve, reject);
        });
        for (let entry of entries){
            if (entry.isFile) {
                let file = await getEntryFile(entry);
                yield createFileItem(file);
            } else if (entry.isDirectory) yield createDirectoryItem(entry);
        }
    }while (entries.length > 0);
}
function getEntryFile(entry) {
    return new Promise((resolve, reject)=>entry.file(resolve, reject));
}
function isTextDropItem(dropItem) {
    return dropItem.kind === 'text';
}
function isFileDropItem(dropItem) {
    return dropItem.kind === 'file';
}
function isDirectoryDropItem(dropItem) {
    return dropItem.kind === 'directory';
}
let globalDndState = {
    draggingKeys: new Set()
};
function setDraggingCollectionRef(ref) {
    globalDndState.draggingCollectionRef = ref;
}
function setDraggingKeys(keys) {
    globalDndState.draggingKeys = keys;
}
function setDropCollectionRef(ref) {
    globalDndState.dropCollectionRef = ref;
}
function clearGlobalDnDState() {
    globalDndState = {
        draggingKeys: new Set()
    };
}
function setGlobalDnDState(state) {
    globalDndState = state;
}
function isInternalDropOperation(ref) {
    let { draggingCollectionRef, dropCollectionRef } = globalDndState;
    return draggingCollectionRef?.current != null && draggingCollectionRef.current === (ref?.current || dropCollectionRef?.current);
}
let globalDropEffect;
function setGlobalDropEffect(dropEffect) {
    globalDropEffect = dropEffect;
}
let globalAllowedDropOperations = (0, _constants.DROP_OPERATION).none;
function setGlobalAllowedDropOperations(o) {
    globalAllowedDropOperations = o;
}

},{"./constants":"dL7d2","@react-aria/interactions":"dkfxW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dL7d2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROP_OPERATION", ()=>DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_ALLOWED", ()=>DROP_OPERATION_ALLOWED);
parcelHelpers.export(exports, "EFFECT_ALLOWED", ()=>EFFECT_ALLOWED);
parcelHelpers.export(exports, "DROP_EFFECT_TO_DROP_OPERATION", ()=>DROP_EFFECT_TO_DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_TO_DROP_EFFECT", ()=>DROP_OPERATION_TO_DROP_EFFECT);
parcelHelpers.export(exports, "NATIVE_DRAG_TYPES", ()=>NATIVE_DRAG_TYPES);
parcelHelpers.export(exports, "CUSTOM_DRAG_TYPE", ()=>CUSTOM_DRAG_TYPE);
parcelHelpers.export(exports, "GENERIC_TYPE", ()=>GENERIC_TYPE);
var DROP_OPERATION = /*#__PURE__*/ function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
    return DROP_OPERATION;
}({});
const DROP_OPERATION_ALLOWED = {
    ...DROP_OPERATION,
    copyMove: 3,
    copyLink: 6,
    linkMove: 5,
    all: 7,
    uninitialized: 7
};
const EFFECT_ALLOWED = invert(DROP_OPERATION_ALLOWED);
EFFECT_ALLOWED[7] = 'all'; // ensure we don't map to 'uninitialized'.
const DROP_EFFECT_TO_DROP_OPERATION = {
    none: 'cancel',
    link: 'link',
    copy: 'copy',
    move: 'move'
};
const DROP_OPERATION_TO_DROP_EFFECT = invert(DROP_EFFECT_TO_DROP_OPERATION);
function invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
const NATIVE_DRAG_TYPES = new Set([
    'text/plain',
    'text/uri-list',
    'text/html'
]);
const CUSTOM_DRAG_TYPE = 'application/vnd.react-aria.items+json';
const GENERIC_TYPE = 'application/octet-stream';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3jskB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBox", ()=>ComboBox);
parcelHelpers.export(exports, "ComboBoxItem", ()=>ComboBoxItem);
parcelHelpers.export(exports, "ComboBoxSection", ()=>ComboBoxSection);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _field = require("./Field");
var _listBox = require("./ListBox");
var _popover = require("./Popover");
var _utils = require("./utils");
var _fieldButton = require("./FieldButton");
'use client';
function ComboBox({ label, description, errorMessage, children, items, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ComboBox), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldButton.FieldButton), {
                        className: "w-6 mr-1 rounded-sm outline-offset-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                className: "w-(--trigger-width)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                    items: items,
                    className: "outline-0 p-1 box-border max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]",
                    children: children
                })
            })
        ]
    });
}
function ComboBoxItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownItem), {
        ...props
    });
}
function ComboBoxSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownSection), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronDown","kWVt3","default"]],"react":"a1TxN","react-aria-components":[["ComboBox","aR9kO"],["ListBox","dNdIK"]],"./Field":"5fXWs","./ListBox":"4YPUR","./Popover":"Dr9D3","./utils":"jNXji","./FieldButton":"9xJpc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kWVt3":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const ChevronDown = (0, _createLucideIconJsDefault.default)("chevron-down", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4YPUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBox", ()=>ListBox);
parcelHelpers.export(exports, "itemStyles", ()=>itemStyles);
parcelHelpers.export(exports, "ListBoxItem", ()=>ListBoxItem);
parcelHelpers.export(exports, "dropdownItemStyles", ()=>dropdownItemStyles);
parcelHelpers.export(exports, "DropdownItem", ()=>DropdownItem);
parcelHelpers.export(exports, "DropdownSection", ()=>DropdownSection);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
function ListBox({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'outline-0 p-1 w-[200px] bg-white dark:bg-zinc-900 border border-gray-300 dark:border-zinc-600 rounded-lg font-sans'),
        children: children
    });
}
const itemStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group relative flex items-center gap-8 cursor-default select-none py-1.5 px-2.5 rounded-md will-change-transform text-sm forced-color-adjust-none',
    variants: {
        isSelected: {
            false: 'text-slate-700 dark:text-zinc-300 hover:bg-slate-200 dark:hover:bg-zinc-700 -outline-offset-2',
            true: 'bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] [&:has(+[data-selected])]:rounded-b-none [&+[data-selected]]:rounded-t-none -outline-offset-4 outline-white dark:outline-white forced-colors:outline-[HighlightText]'
        },
        isDisabled: {
            true: 'text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
function ListBoxItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        textValue: textValue,
        className: itemStyles,
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute left-4 right-4 bottom-0 h-px bg-white/20 forced-colors:bg-[HighlightText] hidden [.group[data-selected]:has(+[data-selected])_&]:block"
                    })
                ]
            }))
    });
}
const dropdownItemStyles = (0, _tailwindVariants.tv)({
    base: 'group flex items-center gap-4 cursor-default select-none py-2 pl-3 pr-1 rounded-lg outline outline-0 text-sm forced-color-adjust-none no-underline [&[href]]:cursor-pointer',
    variants: {
        isDisabled: {
            false: 'text-gray-900 dark:text-zinc-100',
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        },
        isFocused: {
            true: 'bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]'
        }
    },
    compoundVariants: [
        {
            isFocused: false,
            isOpen: true,
            className: 'bg-gray-100 dark:bg-zinc-700/60'
        }
    ]
});
function DropdownItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        textValue: textValue,
        className: dropdownItemStyles,
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold",
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center w-5",
                        children: isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                            className: "w-4 h-4"
                        })
                    })
                ]
            }))
    });
}
function DropdownSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBoxSection), {
        className: "first:-mt-[5px] after:content-[''] after:block after:h-[5px] last:after:hidden",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Header), {
                className: "text-sm font-semibold text-gray-500 dark:text-zinc-300 px-4 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 border-y border-y-gray-200 dark:border-y-zinc-700 [&+*]:mt-1",
                children: props.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: props.items,
                children: props.children
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["Check","9PYFQ","default"]],"react":"a1TxN","react-aria-components":[["Collection","2Jd0Q"],["composeRenderProps","bA6Cz"],["Header","kpwoY"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxSection","dNdIK"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Dr9D3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tailwindVariants = require("tailwind-variants");
'use client';
const styles = (0, _tailwindVariants.tv)({
    base: 'font-sans bg-white dark:bg-zinc-900/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] shadow-2xl rounded-xl bg-clip-padding border border-black/10 dark:border-white/[15%] text-slate-700 dark:text-zinc-300 outline-0',
    variants: {
        isEntering: {
            true: 'animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 ease-in duration-150'
        }
    }
});
function Popover({ children, showArrow, className, ...props }) {
    let offset = showArrow ? 12 : 8;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Popover), {
        offset: offset,
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(className, (className, renderProps)=>styles({
                ...renderProps,
                className
            })),
        children: [
            showArrow && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                className: "group",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 12,
                    height: 12,
                    viewBox: "0 0 12 12",
                    className: "block fill-white dark:fill-[#1f1f21] forced-colors:fill-[Canvas] stroke-1 stroke-black/10 dark:stroke-zinc-600 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0 0 L6 6 L12 0"
                    })
                })
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["OverlayArrow","kMtnS"],["Popover","l4JC0"]],"react":"a1TxN","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9xJpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldButton", ()=>FieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
let button = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative inline-flex items-center border-0 font-sans text-sm text-center transition rounded-lg cursor-default p-1 flex items-center justify-center text-gray-600 bg-transparent hover:bg-black/[5%] pressed:bg-black/10 dark:text-zinc-400 dark:hover:bg-white/10 dark:pressed:bg-white/20 disabled:bg-transparent',
    variants: {
        isDisabled: {
            true: 'bg-gray-100 dark:bg-zinc-800 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5'
        }
    }
});
function FieldButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>button({
                ...renderProps,
                className
            })),
        children: props.children
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b5U0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _calendar = require("./Calendar");
var _dateField = require("./DateField");
var _dialog = require("./Dialog");
var _field = require("./Field");
var _popover = require("./Popover");
var _utils = require("./utils");
var _fieldButton = require("./FieldButton");
'use client';
function DatePicker({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DatePicker), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                className: "min-w-[208px] w-auto",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                        className: "flex-1 min-w-[150px] px-2 py-1.5 text-sm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldButton.FieldButton), {
                        className: "w-6 mr-1 rounded-sm outline-offset-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CalendarIcon), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.Calendar), {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["CalendarIcon","79VlQ","default"]],"react":"a1TxN","react-aria-components":"59rph","./Calendar":"hFRUB","./DateField":"bPyay","./Dialog":"cRN3c","./Field":"5fXWs","./Popover":"Dr9D3","./utils":"jNXji","./FieldButton":"9xJpc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"79VlQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Calendar);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const Calendar = (0, _createLucideIconJsDefault.default)("calendar", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hFRUB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "CalendarHeader", ()=>CalendarHeader);
parcelHelpers.export(exports, "CalendarGridHeader", ()=>CalendarGridHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _button = require("./Button");
var _utils = require("./utils");
'use client';
const cellStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-9 h-9 text-sm cursor-default rounded-full flex items-center justify-center forced-color-adjust-none',
    variants: {
        isSelected: {
            false: 'text-zinc-900 dark:text-zinc-200 hover:bg-gray-100 dark:hover:bg-zinc-700 pressed:bg-gray-200 dark:pressed:bg-zinc-600',
            true: 'bg-blue-600 invalid:bg-red-600 text-white forced-colors:bg-[Highlight] forced-colors:invalid:bg-[Mark] forced-colors:text-[HighlightText]'
        },
        isDisabled: {
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
function Calendar({ errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Calendar), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarHeader, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.CalendarGrid), {
                className: "border-spacing-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarGridHeader, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGridBody), {
                        children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarCell), {
                                date: date,
                                className: cellStyles
                            })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
function CalendarHeader() {
    let { direction } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
        className: "flex items-center gap-1 pb-4 px-1 border-box",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "secondary",
                slot: "previous",
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                    "aria-hidden": true,
                    size: 18
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                    "aria-hidden": true,
                    size: 18
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                className: "flex-1 font-sans font-semibold [font-variation-settings:normal] text-lg text-center mx-2 text-zinc-900 dark:text-zinc-200"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "secondary",
                slot: "next",
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                    "aria-hidden": true,
                    size: 18
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                    "aria-hidden": true,
                    size: 18
                })
            })
        ]
    });
}
function CalendarGridHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGridHeader), {
        children: (day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarHeaderCell), {
                className: "text-xs text-gray-500 font-semibold",
                children: day
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronLeft","6gHLa","default"],["ChevronRight","elAlB","default"]],"react":"a1TxN","react-aria-components":[["Calendar","2DleA"],["CalendarCell","2DleA"],["CalendarGrid","2DleA"],["CalendarGridBody","2DleA"],["CalendarGridHeader","2DleA"],["CalendarHeaderCell","2DleA"],["Heading","2f4nH"],["Text","jt9fm"],["useLocale","4k4z8"]],"tailwind-variants":"dpXBU","./Button":"hk9LL","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6gHLa":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronLeft);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const ChevronLeft = (0, _createLucideIconJsDefault.default)("chevron-left", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAlB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bPyay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>DateField);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
function DateField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DateField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col gap-1'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}
const segmentStyles = (0, _tailwindVariants.tv)({
    base: 'inline p-0.5 type-literal:px-0 rounded-xs outline outline-0 forced-color-adjust-none caret-transparent text-gray-800 dark:text-zinc-200 forced-colors:text-[ButtonText]',
    variants: {
        isPlaceholder: {
            true: 'text-gray-600 dark:text-zinc-400 italic'
        },
        isDisabled: {
            true: 'text-gray-200 dark:text-zinc-600 forced-colors:text-[GrayText]'
        },
        isFocused: {
            true: 'bg-blue-600 text-white dark:text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]'
        }
    }
});
function DateInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateInput), {
        className: (renderProps)=>(0, _field.fieldGroupStyles)({
                ...renderProps,
                class: 'inline min-w-[150px] px-2 py-1.5 text-sm font-sans whitespace-nowrap overflow-x-auto [scrollbar-width:none]'
            }),
        ...props,
        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateSegment), {
                segment: segment,
                className: segmentStyles
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"5wv9P","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4hFdV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridList", ()=>GridList);
parcelHelpers.export(exports, "GridListItem", ()=>GridListItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _checkbox = require("./Checkbox");
var _utils = require("./utils");
'use client';
function GridList({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridList), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'overflow-auto w-[200px] relative bg-white dark:bg-zinc-900 border border-gray-300 dark:border-zinc-600 rounded-lg font-sans empty:flex empty:items-center empty:justify-center empty:italic empty:text-sm'),
        children: children
    });
}
const itemStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative flex gap-3 cursor-default select-none py-2 px-3 text-sm text-gray-900 dark:text-zinc-200 border-y dark:border-y-zinc-700 border-transparent first:border-t-0 last:border-b-0 first:rounded-t-lg last:rounded-b-lg -mb-px last:mb-0 -outline-offset-2',
    variants: {
        isSelected: {
            false: 'hover:bg-gray-100 dark:hover:bg-zinc-700/60',
            true: 'bg-blue-100 dark:bg-blue-700/30 hover:bg-blue-200 dark:hover:bg-blue-700/40 border-y-blue-200 dark:border-y-blue-900 z-20'
        },
        isDisabled: {
            true: 'text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText] z-10'
        }
    }
});
function GridListItem({ children, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridListItem), {
        textValue: textValue,
        ...props,
        className: itemStyles,
        children: (0, _reactAriaComponents.composeRenderProps)(children, (children, { selectionMode, selectionBehavior, allowsDragging })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "drag",
                        children: "\u2261"
                    }),
                    selectionMode === 'multiple' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                        slot: "selection"
                    }),
                    children
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"],["GridList","8bLgh"],["GridListItem","8bLgh"]],"tailwind-variants":"dpXBU","./Checkbox":"9J9Ug","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iPFGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
parcelHelpers.export(exports, "MenuSeparator", ()=>MenuSeparator);
parcelHelpers.export(exports, "MenuSection", ()=>MenuSection);
parcelHelpers.export(exports, "MenuTrigger", ()=>MenuTrigger);
parcelHelpers.export(exports, "SubmenuTrigger", ()=>SubmenuTrigger);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _listBox = require("./ListBox");
var _popover = require("./Popover");
'use client';
function Menu(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Menu), {
        ...props,
        className: "font-sans p-1 outline outline-0 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)] empty:text-center empty:pb-2"
    });
}
function MenuItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuItem), {
        textValue: textValue,
        ...props,
        className: (0, _listBox.dropdownItemStyles),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { selectionMode, isSelected, hasSubmenu })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    selectionMode !== 'none' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center w-4",
                        children: isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold",
                        children: children
                    }),
                    hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                        "aria-hidden": true,
                        className: "absolute w-4 h-4 right-2"
                    })
                ]
            }))
    });
}
function MenuSeparator(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Separator), {
        ...props,
        className: "mx-3 my-1 border-b border-gray-300 dark:border-zinc-700"
    });
}
function MenuSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.MenuSection), {
        ...props,
        className: "first:-mt-[5px] after:content-[''] after:block after:h-[5px]",
        children: [
            props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Header), {
                className: "text-sm font-semibold text-gray-500 dark:text-zinc-300 px-4 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 border-y border-y-gray-200 dark:border-y-zinc-700 [&+*]:mt-1",
                children: props.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: props.items,
                children: props.children
            })
        ]
    });
}
function MenuTrigger(props) {
    let [trigger, menu] = (0, _reactDefault.default).Children.toArray(props.children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.MenuTrigger), {
        ...props,
        children: [
            trigger,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                placement: props.placement,
                className: "min-w-[150px]",
                children: menu
            })
        ]
    });
}
function SubmenuTrigger(props) {
    let [trigger, menu] = (0, _reactDefault.default).Children.toArray(props.children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.SubmenuTrigger), {
        ...props,
        children: [
            trigger,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                offset: -2,
                crossOffset: -4,
                children: menu
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["Check","9PYFQ","default"],["ChevronRight","elAlB","default"]],"react":"a1TxN","react-aria-components":[["Collection","2Jd0Q"],["composeRenderProps","bA6Cz"],["Header","kpwoY"],["Menu","8JFUP"],["MenuItem","8JFUP"],["MenuSection","8JFUP"],["MenuTrigger","8JFUP"],["SubmenuTrigger","8JFUP"],["Separator","8A8dQ"]],"./ListBox":"4YPUR","./Popover":"Dr9D3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2GPV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>Modal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
'use client';
const overlayStyles = (0, _tailwindVariants.tv)({
    base: 'absolute top-0 left-0 w-full h-(--page-height) isolate z-20 bg-black/[50%] text-center backdrop-blur-lg',
    variants: {
        isEntering: {
            true: 'animate-in fade-in duration-200 ease-out'
        },
        isExiting: {
            true: 'animate-out fade-out duration-200 ease-in'
        }
    }
});
const modalStyles = (0, _tailwindVariants.tv)({
    base: 'font-sans w-full max-w-[min(90vw,450px)] max-h-[calc(var(--visual-viewport-height)*.9)] rounded-2xl bg-white dark:bg-zinc-800/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] text-left align-middle text-slate-700 dark:text-zinc-300 shadow-2xl bg-clip-padding border border-black/10 dark:border-white/10',
    variants: {
        isEntering: {
            true: 'animate-in zoom-in-105 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out zoom-out-95 ease-in duration-200'
        }
    }
});
function Modal(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalOverlay), {
        ...props,
        className: overlayStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "sticky top-0 left-0 w-full h-(--visual-viewport-height) flex items-center justify-center box-border",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
                ...props,
                className: modalStyles
            })
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"29rOq","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kG5mF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _agapanthusJpgAsWebp = require("url:./plants/agapanthus.jpg?as=webp");
var _agapanthusJpgAsWebpDefault = parcelHelpers.interopDefault(_agapanthusJpgAsWebp);
var _aloeJpgAsWebp = require("url:./plants/aloe.jpg?as=webp");
var _aloeJpgAsWebpDefault = parcelHelpers.interopDefault(_aloeJpgAsWebp);
var _dracaenaJpgAsWebp = require("url:./plants/dracaena.jpg?as=webp");
var _dracaenaJpgAsWebpDefault = parcelHelpers.interopDefault(_dracaenaJpgAsWebp);
var _fernJpgAsWebp = require("url:./plants/fern.jpg?as=webp");
var _fernJpgAsWebpDefault = parcelHelpers.interopDefault(_fernJpgAsWebp);
var _figJpgAsWebp = require("url:./plants/fig.jpg?as=webp");
var _figJpgAsWebpDefault = parcelHelpers.interopDefault(_figJpgAsWebp);
var _gardeniaJpgAsWebp = require("url:./plants/gardenia.jpg?as=webp");
var _gardeniaJpgAsWebpDefault = parcelHelpers.interopDefault(_gardeniaJpgAsWebp);
var _ivyJpgAsWebp = require("url:./plants/ivy.jpg?as=webp");
var _ivyJpgAsWebpDefault = parcelHelpers.interopDefault(_ivyJpgAsWebp);
var _jacarandaJpgAsWebp = require("url:./plants/jacaranda.jpg?as=webp");
var _jacarandaJpgAsWebpDefault = parcelHelpers.interopDefault(_jacarandaJpgAsWebp);
var _maidenhairJpgAsWebp = require("url:./plants/maidenhair.jpg?as=webp");
var _maidenhairJpgAsWebpDefault = parcelHelpers.interopDefault(_maidenhairJpgAsWebp);
var _moneyJpgAsWebp = require("url:./plants/money.jpg?as=webp");
var _moneyJpgAsWebpDefault = parcelHelpers.interopDefault(_moneyJpgAsWebp);
var _monsteraJpgAsWebp = require("url:./plants/monstera.jpg?as=webp");
var _monsteraJpgAsWebpDefault = parcelHelpers.interopDefault(_monsteraJpgAsWebp);
var _morningJpgAsWebp = require("url:./plants/morning.jpg?as=webp");
var _morningJpgAsWebpDefault = parcelHelpers.interopDefault(_morningJpgAsWebp);
var _nasturtiumJpgAsWebp = require("url:./plants/nasturtium.jpg?as=webp");
var _nasturtiumJpgAsWebpDefault = parcelHelpers.interopDefault(_nasturtiumJpgAsWebp);
var _oleanderJpgAsWebp = require("url:./plants/oleander.jpg?as=webp");
var _oleanderJpgAsWebpDefault = parcelHelpers.interopDefault(_oleanderJpgAsWebp);
var _poplarJpgAsWebp = require("url:./plants/poplar.jpg?as=webp");
var _poplarJpgAsWebpDefault = parcelHelpers.interopDefault(_poplarJpgAsWebp);
var _spiderJpgAsWebp = require("url:./plants/spider.jpg?as=webp");
var _spiderJpgAsWebpDefault = parcelHelpers.interopDefault(_spiderJpgAsWebp);
var _starJpgAsWebp = require("url:./plants/star.jpg?as=webp");
var _starJpgAsWebpDefault = parcelHelpers.interopDefault(_starJpgAsWebp);
var _treeFernJpgAsWebp = require("url:./plants/tree_fern.jpg?as=webp");
var _treeFernJpgAsWebpDefault = parcelHelpers.interopDefault(_treeFernJpgAsWebp);
var _xmasJpgAsWebp = require("url:./plants/xmas.jpg?as=webp");
var _xmasJpgAsWebpDefault = parcelHelpers.interopDefault(_xmasJpgAsWebp);
var _zzJpgAsWebp = require("url:./plants/zz.jpg?as=webp");
var _zzJpgAsWebpDefault = parcelHelpers.interopDefault(_zzJpgAsWebp);
exports.default = [
    {
        id: 1,
        common_name: 'Aloe',
        scientific_name: [
            'Aloe vera'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _aloeJpgAsWebpDefault.default)
        }
    },
    {
        id: 2,
        common_name: 'Blue Jacaranda',
        scientific_name: [
            'Jacaranda mimosifolia'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _jacarandaJpgAsWebpDefault.default)
        }
    },
    {
        id: 3,
        common_name: 'Oleander',
        scientific_name: [
            'Nerium oleander'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _oleanderJpgAsWebpDefault.default)
        }
    },
    {
        id: 4,
        common_name: 'Poplar',
        scientific_name: [
            'Populus'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _poplarJpgAsWebpDefault.default)
        }
    },
    {
        id: 5,
        common_name: 'Zanzibar Gem',
        scientific_name: [
            'Zamioculcas'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _zzJpgAsWebpDefault.default)
        }
    },
    {
        id: 6,
        common_name: 'Morning Glory',
        scientific_name: [
            'Ipomoea'
        ],
        watering: 'Frequent',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _morningJpgAsWebpDefault.default)
        }
    },
    {
        id: 7,
        common_name: 'Christmas Bush',
        scientific_name: [
            'Ceratopetalum gummiferum'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _xmasJpgAsWebpDefault.default)
        }
    },
    {
        id: 8,
        common_name: 'Gardenia',
        scientific_name: [
            'Gardenia jasminoides'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _gardeniaJpgAsWebpDefault.default)
        }
    },
    {
        id: 9,
        common_name: 'Spider Plant',
        scientific_name: [
            'Chlorophytum comosum'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _spiderJpgAsWebpDefault.default)
        }
    },
    {
        id: 10,
        common_name: 'Chinese Money Plant',
        scientific_name: [
            'Pilea peperomioides'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _moneyJpgAsWebpDefault.default)
        }
    },
    {
        id: 11,
        common_name: 'Fiddle Leaf Fig',
        scientific_name: [
            'Ficus lyrata'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _figJpgAsWebpDefault.default)
        }
    },
    {
        id: 12,
        common_name: 'Tuberous Sword Fern',
        scientific_name: [
            'Nephrolepis cordifolia'
        ],
        watering: 'Frequent',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _fernJpgAsWebpDefault.default)
        }
    },
    {
        id: 13,
        common_name: 'Star Jasmine',
        scientific_name: [
            'Trachelospermum jasminoides'
        ],
        watering: 'Frequent',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _starJpgAsWebpDefault.default)
        }
    },
    {
        id: 14,
        common_name: 'Split-leaf Philodendron',
        scientific_name: [
            'Monstera deliciosa'
        ],
        watering: 'Frequent',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _monsteraJpgAsWebpDefault.default)
        }
    },
    {
        id: 15,
        common_name: 'Agapanthus',
        scientific_name: [
            'Agapanthus praecox'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _agapanthusJpgAsWebpDefault.default)
        }
    },
    {
        id: 16,
        common_name: 'Tree Fern',
        scientific_name: [
            'Cyatheaceae'
        ],
        watering: 'Frequent',
        sunlight: [
            'part sun'
        ],
        cycle: 'Annual',
        default_image: {
            thumbnail: (0, _treeFernJpgAsWebpDefault.default)
        }
    },
    {
        id: 17,
        common_name: 'Striped Dracaena',
        scientific_name: [
            'Asparagaceae'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _dracaenaJpgAsWebpDefault.default)
        }
    },
    {
        id: 18,
        common_name: 'Delta Maidenhair Fern',
        scientific_name: [
            'Adiantum raddianum'
        ],
        watering: 'Average',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _maidenhairJpgAsWebpDefault.default)
        }
    },
    {
        id: 19,
        common_name: 'Ivy',
        scientific_name: [
            'Hedera'
        ],
        watering: 'Frequent',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _ivyJpgAsWebpDefault.default)
        }
    },
    {
        id: 20,
        common_name: 'Nasturtium',
        scientific_name: [
            'Tropaeolum'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Annual',
        default_image: {
            thumbnail: (0, _nasturtiumJpgAsWebpDefault.default)
        }
    }
];

},{"url:./plants/agapanthus.jpg?as=webp":"3Vi6L","url:./plants/aloe.jpg?as=webp":"8WGfs","url:./plants/dracaena.jpg?as=webp":"cUKL2","url:./plants/fern.jpg?as=webp":"fChVQ","url:./plants/fig.jpg?as=webp":"1HHWY","url:./plants/gardenia.jpg?as=webp":"68gwm","url:./plants/ivy.jpg?as=webp":"1PMZu","url:./plants/jacaranda.jpg?as=webp":"jrDBk","url:./plants/maidenhair.jpg?as=webp":"eO5Y0","url:./plants/money.jpg?as=webp":"dC83U","url:./plants/monstera.jpg?as=webp":"h7vfZ","url:./plants/morning.jpg?as=webp":"3bjOf","url:./plants/nasturtium.jpg?as=webp":"2FKPh","url:./plants/oleander.jpg?as=webp":"dAuvx","url:./plants/poplar.jpg?as=webp":"gvkLq","url:./plants/spider.jpg?as=webp":"3hsRp","url:./plants/star.jpg?as=webp":"hONAA","url:./plants/tree_fern.jpg?as=webp":"c9SOL","url:./plants/xmas.jpg?as=webp":"3CIBh","url:./plants/zz.jpg?as=webp":"8iNAi","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Vi6L":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cXaBB");

},{}],"8WGfs":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8mKaA");

},{}],"cUKL2":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1zdL2");

},{}],"fChVQ":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("112xf");

},{}],"1HHWY":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bHTqg");

},{}],"68gwm":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8iJhr");

},{}],"1PMZu":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3Dclt");

},{}],"jrDBk":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bsAtG");

},{}],"eO5Y0":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("fgfVd");

},{}],"dC83U":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6b5bz");

},{}],"h7vfZ":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("enHi9");

},{}],"3bjOf":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("59LDD");

},{}],"2FKPh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("53U7I");

},{}],"dAuvx":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("60Y2E");

},{}],"gvkLq":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2UjX6");

},{}],"3hsRp":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jMKg0");

},{}],"hONAA":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("gZb3q");

},{}],"c9SOL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("antzm");

},{}],"3CIBh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("61dWU");

},{}],"8iNAi":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kvgco");

},{}],"f0WdN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _field = require("./Field");
var _utils = require("./utils");
var _fieldButton = require("./FieldButton");
'use client';
function SearchField({ label, description, errorMessage, placeholder, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.SearchField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 min-w-[40px] font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.SearchIcon), {
                        "aria-hidden": true,
                        className: "w-4 h-4 ml-2 text-gray-500 dark:text-zinc-400 forced-colors:text-[ButtonText] group-disabled:text-gray-200 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                        placeholder: placeholder,
                        className: "[&::-webkit-search-cancel-button]:hidden"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldButton.FieldButton), {
                        className: "mr-1 w-6 group-empty:invisible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XIcon), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["SearchIcon","8cmET","default"],["XIcon","1gkBb","default"]],"react":"a1TxN","react-aria-components":"Uk5yj","./Field":"5fXWs","./utils":"jNXji","./FieldButton":"9xJpc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8cmET":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Search);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const Search = (0, _createLucideIconJsDefault.default)("search", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1gkBb":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>X);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const X = (0, _createLucideIconJsDefault.default)("x", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gYM2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
parcelHelpers.export(exports, "SelectItem", ()=>SelectItem);
parcelHelpers.export(exports, "SelectSection", ()=>SelectSection);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _listBox = require("./ListBox");
var _popover = require("./Popover");
var _utils = require("./utils");
'use client';
const styles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'flex items-center text-start gap-4 w-full cursor-default border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none rounded-lg pl-3 pr-2 py-2 min-w-[150px] transition bg-gray-50 dark:bg-zinc-900',
    variants: {
        isDisabled: {
            false: 'text-gray-800 dark:text-zinc-300 hover:bg-gray-100 pressed:bg-gray-200 dark:hover:bg-zinc-800 dark:pressed:bg-zinc-700 group-invalid:border-red-600 forced-colors:group-invalid:border-[Mark]',
            true: 'text-gray-200 dark:text-zinc-600 forced-colors:text-[GrayText] dark:bg-zinc-800 dark:border-white/5 forced-colors:border-[GrayText]'
        }
    }
});
function Select({ label, description, errorMessage, children, items, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Select), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 relative font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                className: styles,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectValue), {
                        className: "flex-1 text-sm placeholder-shown:italic",
                        children: ({ selectedText, defaultChildren })=>selectedText || defaultChildren
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                        "aria-hidden": true,
                        className: "w-4 h-4 text-gray-600 dark:text-zinc-400 forced-colors:text-[ButtonText] group-disabled:text-gray-200 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]"
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                className: "min-w-(--trigger-width)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                    items: items,
                    className: "outline-hidden box-border p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]",
                    children: children
                })
            })
        ]
    });
}
function SelectItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownItem), {
        ...props
    });
}
function SelectSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownSection), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronDown","kWVt3","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["ListBox","dNdIK"],["Select","f92ET"],["SelectValue","f92ET"]],"tailwind-variants":"dpXBU","./Field":"5fXWs","./ListBox":"4YPUR","./Popover":"Dr9D3","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9wXZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroup", ()=>TagGroup);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
const colors = {
    gray: 'bg-white text-gray-600 border-gray-200 hover:border-gray-300 dark:bg-zinc-900 dark:text-zinc-300 dark:border-zinc-600 dark:hover:border-zinc-500',
    green: 'bg-green-100 text-green-700 border-green-200 hover:border-green-300 dark:bg-green-300/20 dark:text-green-400 dark:border-green-300/10 dark:hover:border-green-300/20',
    yellow: 'bg-yellow-100 text-yellow-700 border-yellow-200 hover:border-yellow-300 dark:bg-yellow-300/20 dark:text-yellow-400 dark:border-yellow-300/10 dark:hover:border-yellow-300/20',
    blue: 'bg-blue-100 text-blue-700 border-blue-200 hover:border-blue-300 dark:bg-blue-400/20 dark:text-blue-300 dark:border-blue-400/10 dark:hover:border-blue-400/20'
};
const ColorContext = /*#__PURE__*/ (0, _react.createContext)('gray');
const tagStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'transition cursor-default text-xs rounded-full border px-3 py-0.5 flex items-center max-w-fit gap-1 font-sans',
    variants: {
        color: {
            gray: '',
            green: '',
            yellow: '',
            blue: ''
        },
        allowsRemoving: {
            true: 'pr-1'
        },
        isSelected: {
            true: 'bg-blue-600 text-white border-transparent forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] forced-color-adjust-none'
        },
        isDisabled: {
            true: 'bg-gray-100 dark:bg-transparent dark:border-white/20 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    },
    compoundVariants: Object.keys(colors).map((color)=>({
            isSelected: false,
            isDisabled: false,
            color,
            class: colors[color]
        }))
});
function TagGroup({ label, description, errorMessage, items, children, renderEmptyState, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TagGroup), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('flex flex-col gap-2 font-sans', props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorContext.Provider, {
                value: props.color || 'gray',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TagList), {
                    items: items,
                    renderEmptyState: renderEmptyState,
                    className: "flex flex-wrap gap-1",
                    children: children
                })
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
const removeButtonStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'cursor-default rounded-full transition-[background-color] p-0.5 flex items-center justify-center hover:bg-black/10 dark:hover:bg-white/10 pressed:bg-black/20 dark:pressed:bg-white/20'
});
function Tag({ children, color, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    let groupColor = (0, _react.useContext)(ColorContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tag), {
        textValue: textValue,
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>tagStyles({
                ...renderProps,
                className,
                color: color || groupColor
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(children, (children, { allowsRemoving })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    allowsRemoving && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "remove",
                        className: removeButtonStyles,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XIcon), {
                            "aria-hidden": true,
                            className: "w-3 h-3"
                        })
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["XIcon","1gkBb","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"],["Tag","dIN55"],["TagGroup","dIN55"],["TagList","dIN55"],["Text","jt9fm"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lhOW9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", ()=>TextField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
const inputStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'border-2 rounded-lg',
    variants: {
        isFocused: (0, _field.fieldBorderStyles).variants.isFocusWithin,
        isInvalid: (0, _field.fieldBorderStyles).variants.isInvalid,
        isDisabled: (0, _field.fieldBorderStyles).variants.isDisabled
    }
});
function TextField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TextField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col gap-1 font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                className: inputStyles
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"3CtQI","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4lonv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
'use client';
const styles = (0, _tailwindVariants.tv)({
    base: 'group bg-slate-700 dark:bg-slate-600 border border-slate-800 dark:border-white/10 shadow-[inset_0_1px_0_0_var(--color-gray-600)] dark:shadow-none font-sans text-white text-sm rounded-lg drop-shadow-lg will-change-transform px-3 py-1 box-border',
    variants: {
        isEntering: {
            true: 'animate-in fade-in placement-bottom:slide-in-from-top-0.5 placement-top:slide-in-from-bottom-0.5 placement-left:slide-in-from-right-0.5 placement-right:slide-in-from-left-0.5 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out fade-out placement-bottom:slide-out-to-top-0.5 placement-top:slide-out-to-bottom-0.5 placement-left:slide-out-to-right-0.5 placement-right:slide-out-to-left-0.5 ease-in duration-150'
        }
    }
});
function Tooltip({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Tooltip), {
        ...props,
        offset: 10,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>styles({
                ...renderProps,
                className
            })),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 8,
                    height: 8,
                    viewBox: "0 0 8 8",
                    className: "block fill-slate-700 dark:fill-slate-600 forced-colors:fill-[Canvas] stroke-gray-800 dark:stroke-white/10 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0 0 L4 4 L8 0"
                    })
                })
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["composeRenderProps","bA6Cz"],["OverlayArrow","kMtnS"],["Tooltip","fLMVd"]],"tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b4iJX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Styles", ()=>Styles);
var _jsxRuntime = require("react/jsx-runtime");
var _components = require("./components");
var _react = require("motion/react");
var _button = require("vanilla-starter/Button");
var _reactAriaComponents = require("react-aria-components");
var _comboBox = require("tailwind-starter/ComboBox");
var _datePicker = require("vanilla-starter/DatePicker");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _slider = require("vanilla-starter/Slider");
'use client';
function Styles({ children }) {
    let [styling, css, tailwind, styledComponents, panda] = children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedTabs, {
        tabs: [
            {
                id: 'css',
                label: 'Vanilla CSS',
                content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            className: "h-fit",
                            isBackground: true,
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-2 w-full",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FileTab), {
                                        children: "DatePicker.tsx"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FileTab), {
                                        className: "hidden lg:block",
                                        children: "DatePicker.css"
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-2 bg-gray-50 dark:bg-zinc-800/80 dark:backdrop-saturate-200",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Scrollable), {
                                        className: "rounded-bl-lg",
                                        children: styling
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex flex-row px-3 lg:hidden bg-gray-200/80 backdrop-blur-md dark:bg-zinc-700/80 border-y border-gray-300 dark:border-zinc-700",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FileTab), {
                                            children: "DatePicker.css"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Scrollable), {
                                        className: "rounded-br-lg lg:border-l lg:border-l-gray-200 dark:border-l-zinc-600",
                                        children: css
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            className: "lg:absolute bottom-10 left-[16.5%] max-w-[350px] sm:w-[350px]",
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.AddressBar), {
                                children: "https://your-app.com"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex items-center justify-center bg-gray-50 dark:bg-zinc-900 col-span-2 box-border pt-12 pb-14 text-sm",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.DatePicker), {
                                    label: "Date Planted"
                                })
                            })
                        })
                    ]
                })
            },
            {
                id: 'tailwind',
                label: 'Tailwind',
                content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col lg:flex-row gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            className: "flex-1 bg-gray-50 dark:bg-zinc-800/80 dark:backdrop-saturate-200",
                            isBackground: true,
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FileTab), {
                                children: "ComboBox.tsx"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Scrollable), {
                                className: "rounded-b-lg",
                                children: tailwind
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            className: " max-w-[350px] sm:w-[350px]",
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.AddressBar), {
                                children: "https://your-app.com"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-1 flex flex-col w-full box-border px-16 py-24 bg-gray-50 dark:bg-zinc-900",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBox), {
                                    label: "Assignee",
                                    items: people,
                                    defaultSelectedKey: 1,
                                    children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _comboBox.ComboBoxItem), {
                                            textValue: item.name,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    alt: "",
                                                    src: item.avatar,
                                                    className: "w-6 h-6 rounded-full"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "truncate",
                                                    children: item.name
                                                })
                                            ]
                                        })
                                })
                            })
                        })
                    ]
                })
            },
            {
                id: 'styled-components',
                label: 'Styled Components',
                content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            isBackground: true,
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FileTab), {
                                children: "Slider.tsx"
                            }),
                            className: "bg-gray-50 dark:bg-zinc-800/80 backdrop-saturate-200",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Scrollable), {
                                className: "rounded-b-lg",
                                children: styledComponents
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.AddressBar), {
                                children: "https://your-app.com"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-1 flex items-center justify-center bg-gray-50 dark:bg-zinc-800 py-20 box-border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slider.Slider), {
                                    label: "Opacity",
                                    defaultValue: 30
                                })
                            })
                        })
                    ]
                })
            },
            {
                id: 'panda',
                label: 'Panda',
                content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            isBackground: true,
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FileTab), {
                                children: "Button.tsx"
                            }),
                            className: "bg-gray-50 dark:bg-zinc-800/80 dark:backdrop-saturate-200",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Scrollable), {
                                className: "rounded-b-lg",
                                children: panda
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Window), {
                            toolbar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.AddressBar), {
                                children: "https://your-app.com"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-1 flex items-center justify-center bg-gray-50 dark:bg-zinc-800 py-20 box-border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "bg-blue-600 text-white pressed:bg-blue-700 border border-white/10 rounded-lg box-border px-4 py-2 cursor-default outline outline-0 focus-visible:outline-2 outline-blue-600 dark:outline-blue-500 outline-offset-2",
                                    children: "Initiate launch sequence\u2026"
                                })
                            })
                        })
                    ]
                })
            }
        ]
    });
}
function AnimatedTabs({ tabs }) {
    let [selectedKey, setSelectedKey] = (0, _react1.useState)(tabs[0].id);
    let tabListRef = (0, _react1.useRef)(null);
    let tabPanelsRef = (0, _react1.useRef)(null);
    // Track the scroll position of the tab panel container.
    let { scrollXProgress } = (0, _react.useScroll)({
        container: tabPanelsRef
    });
    // Find all the tab elements so we can use their dimensions.
    let [tabElements, setTabElements] = (0, _react1.useState)([]);
    (0, _react1.useEffect)(()=>{
        if (tabElements.length === 0) {
            let tabs = tabListRef.current.querySelectorAll('[role=tab]');
            setTabElements(Array.from(tabs));
        }
    }, [
        tabElements
    ]);
    // This function determines which tab should be selected
    // based on the scroll position.
    let getIndex = (0, _react1.useCallback)((x)=>Math.max(0, Math.floor((tabElements.length - 1) * x)), [
        tabElements
    ]);
    // This function transforms the scroll position into the X position
    // or width of the selected tab indicator.
    let transform = (x, property)=>{
        if (!tabElements.length) return 0;
        // Find the tab index for the scroll X position.
        let index = getIndex(x);
        // Get the difference between this tab and the next one.
        let difference = index < tabElements.length - 1 ? tabElements[index + 1][property] - tabElements[index][property] : tabElements[index].offsetWidth;
        // Get the percentage between tabs.
        // This is the difference between the integer index and fractional one.
        let percent = (tabElements.length - 1) * x - index;
        // Linearly interpolate to calculate the position of the selection indicator.
        let value = tabElements[index][property] + difference * percent;
        // iOS scrolls weird when translateX is 0 for some reason. 🤷‍♂️
        return value || 0.1;
    };
    let x = (0, _react.useTransform)(scrollXProgress, (x)=>transform(x, 'offsetLeft'));
    let width = (0, _react.useTransform)(scrollXProgress, (x)=>transform(x, 'offsetWidth'));
    // When the user scrolls, update the selected key
    // so that the correct tab panel becomes interactive.
    (0, _react.useMotionValueEvent)(scrollXProgress, 'change', (x)=>{
        if (animationRef.current || !tabElements.length) return;
        setSelectedKey(tabs[getIndex(x)].id);
    });
    // When the user clicks on a tab perform an animation of
    // the scroll position to the newly selected tab panel.
    let animationRef = (0, _react1.useRef)(null);
    let shouldReduceMotion = (0, _react.useReducedMotion)();
    let onSelectionChange = (selectedKey)=>{
        setSelectedKey(selectedKey);
        // If the scroll position is already moving but we aren't animating
        // then the key changed as a result of a user scrolling. Ignore.
        if (scrollXProgress.getVelocity() && !animationRef.current) return;
        let tabPanel = tabPanelsRef.current;
        let index = tabs.findIndex((tab)=>tab.id === selectedKey);
        let scrollLeft = tabPanel.scrollWidth * (index / tabs.length);
        if (shouldReduceMotion) {
            tabPanel.scrollLeft = scrollLeft;
            return;
        }
        animationRef.current?.stop();
        animationRef.current = (0, _react.animate)(tabPanel.scrollLeft, scrollLeft, {
            type: 'spring',
            bounce: 0.2,
            duration: 0.6,
            onUpdate: (v)=>{
                tabPanel.scrollLeft = v;
            },
            onPlay: ()=>{
                // Disable scroll snap while the animation is going or weird things happen.
                tabPanel.style.scrollSnapType = 'none';
            },
            onComplete: ()=>{
                tabPanel.style.scrollSnapType = '';
                animationRef.current = null;
            }
        });
    };
    // Scroll selected tab into view.
    let tabListScrollRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        let tab = tabListRef.current.querySelector(`[data-key="${selectedKey}"]`);
        if (tab) {
            let scroll = tabListScrollRef.current;
            // Would use scrollIntoView but it's broken in Chrome: https://github.com/facebook/react/issues/23396
            if (scroll && (tab.offsetLeft < scroll.scrollLeft || tab.offsetLeft + tab.offsetWidth > scroll.offsetWidth + scroll.scrollLeft)) scroll.scroll({
                left: tab.offsetLeft,
                behavior: 'smooth'
            });
        }
    }, [
        selectedKey
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Tabs), {
        className: "-mx-8 md:-mx-2",
        selectedKey: selectedKey,
        onSelectionChange: onSelectionChange,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "relative overflow-x-auto no-scrollbar dark:isolate p-2 sm:-m-2",
                ref: tabListScrollRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabList), {
                        ref: tabListRef,
                        className: "flex px-2 y-2 md:px-0",
                        items: tabs,
                        children: (tab)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tab), {
                                className: "shrink-0 cursor-default px-3 py-1.5 text-sm sm:text-base text-black dark:text-white transition outline outline-0 forced-colors:selected:text-[HighlightText]! forced-color-adjust-none",
                                children: ({ isSelected, isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            tab.label,
                                            isFocusVisible && isSelected && // Focus ring.
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.motion).span, {
                                                className: "absolute inset-y-2 inset-x-0 z-10 rounded-full outline outline-2 outline-black dark:outline-white forced-colors:outline-[Highlight]! outline-offset-2",
                                                style: {
                                                    x,
                                                    width
                                                }
                                            })
                                        ]
                                    })
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.motion).span, {
                        className: "absolute inset-y-2 inset-x-0 z-10 bg-white rounded-full mix-blend-difference forced-colors:bg-[Highlight] forced-colors:mix-blend-normal forced-colors:-z-10",
                        style: {
                            x,
                            width
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: tabPanelsRef,
                className: "relative pt-10 pb-10 overflow-auto snap-x snap-mandatory no-scrollbar flex edge-mask",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                    items: tabs,
                    children: (tab)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabPanel), {
                            shouldForceMount: true,
                            className: "shrink-0 w-full px-4 box-border snap-start snap-always outline outline-0 -outline-offset-2 rounded-sm focus-visible:outline-black",
                            children: tab.content
                        })
                })
            })
        ]
    });
}
const people = [
    {
        id: 1,
        avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        name: 'Gilberto Miguel',
        username: '@gilberto_miguel'
    },
    {
        id: 2,
        avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        name: 'Maia Pettegree',
        username: '@mpettegree'
    },
    {
        id: 3,
        avatar: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        name: 'Wade Redington',
        username: '@redington'
    },
    {
        id: 4,
        avatar: 'https://images.unsplash.com/photo-1528763380143-65b3ac89a3ff?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        name: 'Kurtis Gurrado',
        username: '@kurtis'
    },
    {
        id: 5,
        avatar: 'https://images.unsplash.com/photo-1569913486515-b74bf7751574?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        name: 'Sonja Balmann',
        username: '@sbalmann'
    },
    {
        id: 6,
        avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        name: 'Brent Mickelwright',
        username: '@brent_m'
    },
    {
        id: 7,
        avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80',
        name: 'Charles Webb',
        username: '@cwebb'
    }
];

},{"react/jsx-runtime":"2Is6Z","./components":"bkILc","motion/react":[["animate","7RE7L"],["motion","4SRLT"],["useMotionValueEvent","gAkxR"],["useReducedMotion","jiSPs"],["useScroll","koPiV"],["useTransform","hqG2Z"]],"vanilla-starter/Button":"36nan","react-aria-components":[["Collection","2Jd0Q"],["Tab","ahti0"],["TabList","ahti0"],["TabPanel","ahti0"],["Tabs","ahti0"]],"tailwind-starter/ComboBox":"3jskB","vanilla-starter/DatePicker":"bNsSL","react":"a1TxN","vanilla-starter/Slider":"1qmQL","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jiSPs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReducedMotion", ()=>useReducedMotion);
var _motionUtils = require("motion-utils");
var _react = require("react");
var _indexMjs = require("./index.mjs");
var _stateMjs = require("./state.mjs");
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function useReducedMotion() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !(0, _stateMjs.hasReducedMotionListener).current && (0, _indexMjs.initPrefersReducedMotion)();
    const [shouldReduceMotion] = (0, _react.useState)((0, _stateMjs.prefersReducedMotion).current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}

},{"motion-utils":"VlJc9","react":"a1TxN","./index.mjs":"dX7pK","./state.mjs":"cGosb","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"koPiV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScroll", ()=>useScroll);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _react = require("react");
var _indexMjs = require("../render/dom/scroll/index.mjs");
var _useConstantMjs = require("../utils/use-constant.mjs");
var _useIsomorphicEffectMjs = require("../utils/use-isomorphic-effect.mjs");
const createScrollMotionValues = ()=>({
        scrollX: (0, _motionDom.motionValue)(0),
        scrollY: (0, _motionDom.motionValue)(0),
        scrollXProgress: (0, _motionDom.motionValue)(0),
        scrollYProgress: (0, _motionDom.motionValue)(0)
    });
const isRefPending = (ref)=>{
    if (!ref) return false;
    return !ref.current;
};
function useScroll({ container, target, ...options } = {}) {
    const values = (0, _useConstantMjs.useConstant)(createScrollMotionValues);
    const scrollAnimation = (0, _react.useRef)(null);
    const needsStart = (0, _react.useRef)(false);
    const start = (0, _react.useCallback)(()=>{
        scrollAnimation.current = (0, _indexMjs.scroll)((_progress, { x, y })=>{
            values.scrollX.set(x.current);
            values.scrollXProgress.set(x.progress);
            values.scrollY.set(y.current);
            values.scrollYProgress.set(y.progress);
        }, {
            ...options,
            container: container?.current || undefined,
            target: target?.current || undefined
        });
        return ()=>{
            scrollAnimation.current?.();
        };
    }, [
        container,
        target,
        JSON.stringify(options.offset)
    ]);
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(()=>{
        needsStart.current = false;
        if (isRefPending(container) || isRefPending(target)) {
            needsStart.current = true;
            return;
        } else return start();
    }, [
        start
    ]);
    (0, _react.useEffect)(()=>{
        if (needsStart.current) {
            (0, _motionUtils.invariant)(!isRefPending(container), "Container ref is defined but not hydrated", "use-scroll-ref");
            (0, _motionUtils.invariant)(!isRefPending(target), "Target ref is defined but not hydrated", "use-scroll-ref");
            return start();
        } else return;
    }, [
        start
    ]);
    return values;
}

},{"motion-dom":"9GjLw","motion-utils":"bNkGa","react":"a1TxN","../render/dom/scroll/index.mjs":"3yHPZ","../utils/use-constant.mjs":"6nUVA","../utils/use-isomorphic-effect.mjs":"hZ0N7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3yHPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scroll", ()=>scroll);
var _motionUtils = require("motion-utils");
var _attachAnimationMjs = require("./attach-animation.mjs");
var _attachFunctionMjs = require("./attach-function.mjs");
function scroll(onScroll, { axis = "y", container = document.scrollingElement, ...options } = {}) {
    if (!container) return 0, _motionUtils.noop;
    const optionsWithDefaults = {
        axis,
        container,
        ...options
    };
    return typeof onScroll === "function" ? (0, _attachFunctionMjs.attachToFunction)(onScroll, optionsWithDefaults) : (0, _attachAnimationMjs.attachToAnimation)(onScroll, optionsWithDefaults);
}

},{"motion-utils":"iUHE5","./attach-animation.mjs":"3y4ud","./attach-function.mjs":"8GX3s","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3y4ud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachToAnimation", ()=>attachToAnimation);
var _motionDom = require("motion-dom");
var _getTimelineMjs = require("./utils/get-timeline.mjs");
function attachToAnimation(animation, options) {
    const timeline = (0, _getTimelineMjs.getTimeline)(options);
    return animation.attachTimeline({
        timeline: options.target ? undefined : timeline,
        observe: (valueAnimation)=>{
            valueAnimation.pause();
            return (0, _motionDom.observeTimeline)((progress)=>{
                valueAnimation.time = valueAnimation.duration * progress;
            }, timeline);
        }
    });
}

},{"motion-dom":"giZsZ","./utils/get-timeline.mjs":"jGmAY","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"giZsZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeTimeline", ()=>observeTimeline);
var _frameMjs = require("../frameloop/frame.mjs");
function observeTimeline(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, _frameMjs.frame).preUpdate(onFrame, true);
    return ()=>(0, _frameMjs.cancelFrame)(onFrame);
}

},{"../frameloop/frame.mjs":"5qpjY","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jGmAY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimeline", ()=>getTimeline);
var _motionDom = require("motion-dom");
var _trackMjs = require("../track.mjs");
const timelineCache = new Map();
function scrollTimelineFallback(options) {
    const currentTime = {
        value: 0
    };
    const cancel = (0, _trackMjs.scrollInfo)((info)=>{
        currentTime.value = info[options.axis].progress * 100;
    }, options);
    return {
        currentTime,
        cancel
    };
}
function getTimeline({ source, container, ...options }) {
    const { axis } = options;
    if (source) container = source;
    const containerCache = timelineCache.get(container) ?? new Map();
    timelineCache.set(container, containerCache);
    const targetKey = options.target ?? "self";
    const targetCache = containerCache.get(targetKey) ?? {};
    const axisKey = axis + (options.offset ?? []).join(",");
    if (!targetCache[axisKey]) targetCache[axisKey] = !options.target && (0, _motionDom.supportsScrollTimeline)() ? new ScrollTimeline({
        source: container,
        axis
    }) : scrollTimelineFallback({
        container,
        ...options
    });
    return targetCache[axisKey];
}

},{"motion-dom":"3lUVX","../track.mjs":"34wUr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"34wUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrollInfo", ()=>scrollInfo);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _infoMjs = require("./info.mjs");
var _onScrollHandlerMjs = require("./on-scroll-handler.mjs");
const scrollListeners = new WeakMap();
const resizeListeners = new WeakMap();
const onScrollHandlers = new WeakMap();
const getEventTarget = (element)=>element === document.scrollingElement ? window : element;
function scrollInfo(onScroll, { container = document.scrollingElement, ...options } = {}) {
    if (!container) return 0, _motionUtils.noop;
    let containerHandlers = onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ const info = (0, _infoMjs.createScrollInfo)();
    const containerHandler = (0, _onScrollHandlerMjs.createOnScrollHandler)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!scrollListeners.has(container)) {
        const measureAll = ()=>{
            for (const handler of containerHandlers)handler.measure((0, _motionDom.frameData).timestamp);
            (0, _motionDom.frame).preUpdate(notifyAll);
        };
        const notifyAll = ()=>{
            for (const handler of containerHandlers)handler.notify();
        };
        const listener = ()=>(0, _motionDom.frame).read(measureAll);
        scrollListeners.set(container, listener);
        const target = getEventTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) resizeListeners.set(container, (0, _motionDom.resize)(container, listener));
        target.addEventListener("scroll", listener, {
            passive: true
        });
        listener();
    }
    const listener = scrollListeners.get(container);
    (0, _motionDom.frame).read(listener, false, true);
    return ()=>{
        (0, _motionDom.cancelFrame)(listener);
        /**
         * Check if we even have any handlers for this container.
         */ const currentHandlers = onScrollHandlers.get(container);
        if (!currentHandlers) return;
        currentHandlers.delete(containerHandler);
        if (currentHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ const scrollListener = scrollListeners.get(container);
        scrollListeners.delete(container);
        if (scrollListener) {
            getEventTarget(container).removeEventListener("scroll", scrollListener);
            resizeListeners.get(container)?.();
            window.removeEventListener("resize", scrollListener);
        }
    };
}

},{"motion-dom":[["cancelFrame","5qpjY"],["frame","5qpjY"],["frameData","5qpjY"],["resize","gyPs3"]],"motion-utils":"iUHE5","./info.mjs":"hxTaY","./on-scroll-handler.mjs":"jofx3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gyPs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resize", ()=>resize);
var _handleElementMjs = require("./handle-element.mjs");
var _handleWindowMjs = require("./handle-window.mjs");
function resize(a, b) {
    return typeof a === "function" ? (0, _handleWindowMjs.resizeWindow)(a) : (0, _handleElementMjs.resizeElement)(a, b);
}

},{"./handle-element.mjs":"7YsPd","./handle-window.mjs":"bTbeH","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7YsPd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeElement", ()=>resizeElement);
var _isSvgElementMjs = require("../utils/is-svg-element.mjs");
var _resolveElementsMjs = require("../utils/resolve-elements.mjs");
const resizeHandlers = new WeakMap();
let observer;
const getSize = (borderBoxAxis, svgAxis, htmlAxis)=>(target, borderBoxSize)=>{
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, _isSvgElementMjs.isSVGElement)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
const getWidth = /*@__PURE__*/ getSize("inline", "width", "offsetWidth");
const getHeight = /*@__PURE__*/ getSize("block", "height", "offsetHeight");
function notifyTarget({ target, borderBoxSize }) {
    resizeHandlers.get(target)?.forEach((handler)=>{
        handler(target, {
            get width () {
                return getWidth(target, borderBoxSize);
            },
            get height () {
                return getHeight(target, borderBoxSize);
            }
        });
    });
}
function notifyAll(entries) {
    entries.forEach(notifyTarget);
}
function createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
    if (!observer) createResizeObserver();
    const elements = (0, _resolveElementsMjs.resolveElements)(target);
    elements.forEach((element)=>{
        let elementHandlers = resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        observer?.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = resizeHandlers.get(element);
            elementHandlers?.delete(handler);
            if (!elementHandlers?.size) observer?.unobserve(element);
        });
    };
}

},{"../utils/is-svg-element.mjs":"ktNyP","../utils/resolve-elements.mjs":"dQyMV","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bTbeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeWindow", ()=>resizeWindow);
const windowCallbacks = new Set();
let windowResizeHandler;
function createWindowResizeHandler() {
    windowResizeHandler = ()=>{
        const info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
    windowCallbacks.add(callback);
    if (!windowResizeHandler) createWindowResizeHandler();
    return ()=>{
        windowCallbacks.delete(callback);
        if (!windowCallbacks.size && typeof windowResizeHandler === "function") {
            window.removeEventListener("resize", windowResizeHandler);
            windowResizeHandler = undefined;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hxTaY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScrollInfo", ()=>createScrollInfo);
parcelHelpers.export(exports, "updateScrollInfo", ()=>updateScrollInfo);
var _motionUtils = require("motion-utils");
/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ const maxElapsed = 50;
const createAxisInfo = ()=>({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    });
const createScrollInfo = ()=>({
        time: 0,
        x: createAxisInfo(),
        y: createAxisInfo()
    });
const keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length, position } = keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element[`scroll${position}`];
    axis.scrollLength = element[`scroll${length}`] - element[`client${length}`];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, _motionUtils.progress)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity = elapsed > maxElapsed ? 0 : (0, _motionUtils.velocityPerSecond)(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
    updateAxisInfo(element, "x", info, time);
    updateAxisInfo(element, "y", info, time);
    info.time = time;
}

},{"motion-utils":[["progress","c6Pgl"],["velocityPerSecond","24oPa"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jofx3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOnScrollHandler", ()=>createOnScrollHandler);
var _motionUtils = require("motion-utils");
var _infoMjs = require("./info.mjs");
var _indexMjs = require("./offsets/index.mjs");
function measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while(node && node !== container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function createOnScrollHandler(element, onScroll, info, options = {}) {
    return {
        measure: (time)=>{
            measure(element, options.target, info);
            (0, _infoMjs.updateScrollInfo)(element, info, time);
            if (options.offset || options.target) (0, _indexMjs.resolveOffsets)(element, info, options);
        },
        notify: ()=>onScroll(info)
    };
}

},{"motion-utils":"VlJc9","./info.mjs":"hxTaY","./offsets/index.mjs":"5qCgb","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5qCgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveOffsets", ()=>resolveOffsets);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _insetMjs = require("./inset.mjs");
var _offsetMjs = require("./offset.mjs");
var _presetsMjs = require("./presets.mjs");
const point = {
    x: 0,
    y: 0
};
function getTargetSize(target) {
    return "getBBox" in target && target.tagName !== "svg" ? target.getBBox() : {
        width: target.clientWidth,
        height: target.clientHeight
    };
}
function resolveOffsets(container, info, options) {
    const { offset: offsetDefinition = (0, _presetsMjs.ScrollOffset).All } = options;
    const { target = container, axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? (0, _insetMjs.calcInset)(target, container) : point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ const targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : getTargetSize(target);
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for(let i = 0; i < numOffsets; i++){
        const offset = (0, _offsetMjs.resolveOffset)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, _motionDom.interpolate)(info[axis].offset, (0, _motionDom.defaultOffset)(offsetDefinition), {
            clamp: false
        });
        info[axis].interpolatorOffsets = [
            ...info[axis].offset
        ];
    }
    info[axis].progress = (0, _motionUtils.clamp)(0, 1, info[axis].interpolate(info[axis].current));
}

},{"motion-dom":[["defaultOffset","1j8d8"],["interpolate","b6UBK"]],"motion-utils":"eVEN5","./inset.mjs":"e3Tcx","./offset.mjs":"e57nA","./presets.mjs":"2fOXa","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e3Tcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcInset", ()=>calcInset);
var _motionDom = require("motion-dom");
function calcInset(element, container) {
    const inset = {
        x: 0,
        y: 0
    };
    let current = element;
    while(current && current !== container){
        if ((0, _motionDom.isHTMLElement)(current)) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current.tagName === "svg") {
            /**
             * This isn't an ideal approach to measuring the offset of <svg /> tags.
             * It would be preferable, given they behave like HTMLElements in most ways
             * to use offsetLeft/Top. But these don't exist on <svg />. Likewise we
             * can't use .getBBox() like most SVG elements as these provide the offset
             * relative to the SVG itself, which for <svg /> is usually 0x0.
             */ const svgBoundingBox = current.getBoundingClientRect();
            current = current.parentElement;
            const parentBoundingBox = current.getBoundingClientRect();
            inset.x += svgBoundingBox.left - parentBoundingBox.left;
            inset.y += svgBoundingBox.top - parentBoundingBox.top;
        } else if (current instanceof SVGGraphicsElement) {
            const { x, y } = current.getBBox();
            inset.x += x;
            inset.y += y;
            let svg = null;
            let parent = current.parentNode;
            while(!svg){
                if (parent.tagName === "svg") svg = parent;
                parent = current.parentNode;
            }
            current = svg;
        } else break;
    }
    return inset;
}

},{"motion-dom":"ezluK","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e57nA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveOffset", ()=>resolveOffset);
var _edgeMjs = require("./edge.mjs");
const defaultOffset = [
    0,
    0
];
function resolveOffset(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if (typeof offset === "number") /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if (typeof offset === "string") {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, _edgeMjs.namedEdges)[offset] ? offset : `0`
        ];
    }
    targetPoint = (0, _edgeMjs.resolveEdge)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, _edgeMjs.resolveEdge)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}

},{"./edge.mjs":"eUj9o","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eUj9o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "namedEdges", ()=>namedEdges);
parcelHelpers.export(exports, "resolveEdge", ()=>resolveEdge);
const namedEdges = {
    start: 0,
    center: 0.5,
    end: 1
};
function resolveEdge(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if (edge in namedEdges) edge = namedEdges[edge];
    /**
     * Handle unit values
     */ if (typeof edge === "string") {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if (typeof edge === "number") delta = length * edge;
    return inset + delta;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2fOXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollOffset", ()=>ScrollOffset);
const ScrollOffset = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8GX3s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachToFunction", ()=>attachToFunction);
var _motionDom = require("motion-dom");
var _trackMjs = require("./track.mjs");
var _getTimelineMjs = require("./utils/get-timeline.mjs");
/**
 * If the onScroll function has two arguments, it's expecting
 * more specific information about the scroll from scrollInfo.
 */ function isOnScrollWithInfo(onScroll) {
    return onScroll.length === 2;
}
function attachToFunction(onScroll, options) {
    if (isOnScrollWithInfo(onScroll)) return (0, _trackMjs.scrollInfo)((info)=>{
        onScroll(info[options.axis].progress, info);
    }, options);
    else return (0, _motionDom.observeTimeline)(onScroll, (0, _getTimelineMjs.getTimeline)(options));
}

},{"motion-dom":"giZsZ","./track.mjs":"34wUr","./utils/get-timeline.mjs":"jGmAY","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hqG2Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransform", ()=>useTransform);
var _motionDom = require("motion-dom");
var _useConstantMjs = require("../utils/use-constant.mjs");
var _useCombineValuesMjs = require("./use-combine-values.mjs");
var _useComputedMjs = require("./use-computed.mjs");
function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    if (typeof input === "function") return (0, _useComputedMjs.useComputed)(input);
    const transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : (0, _motionDom.transform)(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input) ? useListTransform(input, transformer) : useListTransform([
        input
    ], ([latest])=>transformer(latest));
}
function useListTransform(values, transformer) {
    const latest = (0, _useConstantMjs.useConstant)(()=>[]);
    return (0, _useCombineValuesMjs.useCombineMotionValues)(values, ()=>{
        latest.length = 0;
        const numValues = values.length;
        for(let i = 0; i < numValues; i++)latest[i] = values[i].get();
        return transformer(latest);
    });
}

},{"motion-dom":"i9tIS","../utils/use-constant.mjs":"6nUVA","./use-combine-values.mjs":"cMfTk","./use-computed.mjs":"3uDei","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i9tIS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transform", ()=>transform);
var _interpolateMjs = require("./interpolate.mjs");
function transform(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0, _interpolateMjs.interpolate)(inputRange, outputRange, options);
    return useImmediate ? interpolator(inputValue) : interpolator;
}

},{"./interpolate.mjs":"b6UBK","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3uDei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComputed", ()=>useComputed);
var _motionDom = require("motion-dom");
var _useCombineValuesMjs = require("./use-combine-values.mjs");
function useComputed(compute) {
    /**
     * Open session of collectMotionValues. Any MotionValue that calls get()
     * will be saved into this array.
     */ (0, _motionDom.collectMotionValues).current = [];
    compute();
    const value = (0, _useCombineValuesMjs.useCombineMotionValues)((0, _motionDom.collectMotionValues).current, compute);
    /**
     * Synchronously close session of collectMotionValues.
     */ (0, _motionDom.collectMotionValues).current = undefined;
    return value;
}

},{"motion-dom":"9GjLw","./use-combine-values.mjs":"cMfTk","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"36nan":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _progressCircle = require("./ProgressCircle");
var _buttonCss = require("./Button.css");
'use client';
function Button(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: "react-aria-Button button-base",
        "data-variant": props.variant || 'primary',
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isPending })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !isPending && children,
                    isPending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                        "aria-label": "Saving...",
                        isIndeterminate: true
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"./ProgressCircle":"c08Ay","./Button.css":"maD70","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c08Ay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressCircle", ()=>ProgressCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
'use client';
function ProgressCircle(props) {
    // SVG strokes are centered, so subtract half the stroke width from the radius to create an inner stroke.
    let strokeWidth = 4;
    let radius = `calc(50% - ${strokeWidth / 2}px)`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ProgressBar), {
        ...props,
        style: (0, _reactAriaComponents.composeRenderProps)(props.style, (style)=>({
                ...style,
                width: props.size || 16,
                height: props.size || 16
            })),
        children: ({ percentage, isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    fill: "none",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 32 32",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-pressed)",
                            strokeWidth: strokeWidth
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-background)",
                            strokeWidth: strokeWidth,
                            // Normalize the path length to 100 so we can easily set stroke-dashoffset to a percentage.
                            pathLength: "100",
                            // Add extra gap between dashes so 0% works in Chrome.
                            strokeDasharray: "100 200",
                            strokeDashoffset: 100 - (isIndeterminate || percentage == null ? 25 : percentage),
                            strokeLinecap: "round",
                            style: {
                                rotate: '-90deg',
                                transformOrigin: 'center center'
                            },
                            children: isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                dur: "0.75s",
                                values: "0;360",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["ProgressBar","kPGON"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"maD70":[function() {},{}],"bNsSL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _dateField = require("./DateField");
var _form = require("./Form");
var _calendar = require("./Calendar");
var _popover = require("./Popover");
var _lucideReact = require("lucide-react");
var _datePickerCss = require("./DatePicker.css");
'use client';
function DatePicker({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DatePicker), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Group), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateSegment), {
                                segment: segment
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldButton), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            size: 16
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                hideArrow: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.Calendar), {})
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["DatePicker","59rph"],["Group","6UspO"]],"./DateField":"1mJlu","./Form":"6qejZ","./Calendar":"iKsWV","./Popover":"cvyKh","lucide-react":[["ChevronDown","kWVt3","default"]],"./DatePicker.css":"fgaQT","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1mJlu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>DateField);
parcelHelpers.export(exports, "DateSegment", ()=>DateSegment);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _form = require("./Form");
var _dateFieldCss = require("./DateField.css");
'use client';
function DateField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DateField), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {
                children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DateSegment, {
                        segment: segment
                    })
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldError), {
                children: errorMessage
            })
        ]
    });
}
function DateSegment(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateSegment), {
        ...props
    });
}
function DateInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateInput), {
        ...props,
        className: "react-aria-DateInput inset"
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"5wv9P","./Form":"6qejZ","./DateField.css":"g2XHy","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6qejZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldButton", ()=>FieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _formCss = require("./Form.css");
var _content = require("./Content");
'use client';
function Form(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Form), {
        ...props
    });
}
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
        slot: "description",
        className: "field-description",
        ...props
    });
}
function FieldButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: "field-Button"
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["FieldError","algyu"],["Form","g7RKA"],["Label","fjKq6"]],"./Form.css":"7sxTy","./Content":"jYtLe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7sxTy":[function() {},{}],"jYtLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>Heading);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _contentCss = require("./Content.css");
function Heading(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...props
    });
}
function Text(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Heading","2f4nH"],["Text","jt9fm"]],"./Content.css":"kvyv3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvyv3":[function() {},{}],"g2XHy":[function() {},{}],"iKsWV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "CalendarCell", ()=>CalendarCell);
parcelHelpers.export(exports, "CalendarGrid", ()=>CalendarGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _content = require("./Content");
var _lucideReact = require("lucide-react");
var _button = require("./Button");
var _calendarCss = require("./Calendar.css");
'use client';
function Calendar({ errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Calendar), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        slot: "previous",
                        variant: "quiet",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Heading), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        slot: "next",
                        variant: "quiet",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarGrid, {
                children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarCell, {
                        date: date
                    })
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "errorMessage",
                children: errorMessage
            })
        ]
    });
}
function CalendarCell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarCell), {
        ...props,
        className: "react-aria-CalendarCell button-base",
        "data-variant": "quiet"
    });
}
function CalendarGrid(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGrid), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"2DleA","./Content":"jYtLe","lucide-react":[["ChevronLeft","6gHLa","default"],["ChevronRight","elAlB","default"]],"./Button":"36nan","./Calendar.css":"11b92","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"11b92":[function() {},{}],"cvyKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _popoverCss = require("./Popover.css");
'use client';
function Popover({ children, hideArrow, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Popover), {
        ...props,
        className: (0, _clsxDefault.default)("react-aria-Popover", props.className),
        children: ({ trigger })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !hideArrow && trigger !== 'MenuTrigger' && trigger !== 'SubmenuTrigger' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            width: 12,
                            height: 12,
                            viewBox: "0 0 12 12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M0 0 L6 6 L12 0"
                            })
                        })
                    }),
                    children
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["OverlayArrow","kMtnS"],["Popover","l4JC0"]],"clsx":"4P1lK","./Popover.css":"6SWas","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6SWas":[function() {},{}],"fgaQT":[function() {},{}],"1qmQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _form = require("./Form");
var _sliderCss = require("./Slider.css");
'use client';
function Slider({ label, thumbLabels, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Slider), {
        ...props,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderOutput), {
                children: ({ state })=>state.values.map((_, i)=>state.getThumbValueLabel(i)).join(" \u2013 ")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderTrack), {
                children: ({ state, isDisabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "track inset",
                                "data-disabled": isDisabled || undefined,
                                children: state.values.length === 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "fill",
                                    style: {
                                        '--size': state.getThumbPercent(0) * 100 + '%'
                                    }
                                }) : state.values.length === 2 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "fill",
                                    style: {
                                        '--start': state.getThumbPercent(0) * 100 + '%',
                                        '--size': (state.getThumbPercent(1) - state.getThumbPercent(0)) * 100 + '%'
                                    }
                                }) : null
                            }),
                            state.values.map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderThumb), {
                                    index: i,
                                    "aria-label": thumbLabels?.[i],
                                    className: "react-aria-SliderThumb indicator"
                                }, i))
                        ]
                    })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"34zZe","./Form":"6qejZ","./Slider.css":"1XWat","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1XWat":[function() {},{}],"hAT5h":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KanbanBoard", ()=>KanbanBoard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const tickets = [
    {
        'title': 'UI Button Alignment Issue',
        'description': 'Buttons in the Settings menu are misaligned on smaller screens.',
        'id': '#101',
        'assignee': 'Gilberto Miguel',
        'avatar': 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-15',
        'status': 'Open'
    },
    {
        'title': 'Login Page Redesign',
        'description': 'Requesting a redesign of the login page to improve user experience.',
        'id': '#102',
        'assignee': 'Maia Pettegree',
        'avatar': 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-16',
        'status': 'Open'
    },
    {
        'title': 'Database Connection Error',
        'description': 'Users are experiencing intermittent connection errors when accessing the database.',
        'id': '#103',
        'assignee': 'Mike Johnson',
        'avatar': 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-17',
        'status': 'In Progress'
    },
    {
        'title': 'Feature: Dark Mode',
        'description': 'Implement a dark mode option for improved accessibility and user preference.',
        'id': '#104',
        'assignee': 'Sarah Lee',
        'avatar': 'https://images.unsplash.com/photo-1569913486515-b74bf7751574?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-18',
        'status': 'Open'
    },
    {
        'title': 'Missing User Profile Pictures',
        'description': 'Some user profile pictures are not displaying properly in the user dashboard.',
        'id': '#105',
        'assignee': 'David Chen',
        'avatar': 'https://images.unsplash.com/photo-1528763380143-65b3ac89a3ff?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-19',
        'status': 'Open'
    },
    {
        'title': 'Performance Optimization',
        'description': 'Requesting performance optimization for the application to reduce load times.',
        'id': '#106',
        'assignee': 'Sarah Lee',
        'avatar': 'https://images.unsplash.com/photo-1569913486515-b74bf7751574?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-20',
        'status': 'Closed'
    },
    {
        'title': 'Broken Link on Homepage',
        'description': 'The "Learn More" link on the homepage is leading to a 404 error.',
        'id': '#107',
        'assignee': 'Alex Turner',
        'avatar': 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-21',
        'status': 'Open'
    },
    {
        'title': 'Feature: Export to PDF',
        'description': 'Implement a feature to allow users to export their data to PDF format.',
        'id': '#108',
        'assignee': 'Maia Pettegree',
        'avatar': 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-22',
        'status': 'Open'
    },
    {
        'title': 'Mobile Responsiveness Issue',
        'description': 'The application is not rendering properly on certain mobile devices.',
        'id': '#109',
        'assignee': 'Kevin Williams',
        'avatar': 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80',
        'date': '2023-09-23',
        'status': 'Open'
    },
    {
        'title': 'Feature: Two-Factor Authentication',
        'description': 'Requesting the addition of two-factor authentication for improved security.',
        'id': '#110',
        'assignee': 'Maia Pettegree',
        'avatar': 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        'date': '2023-09-24',
        'status': 'In Progress'
    }
];
function KanbanBoard() {
    let list = (0, _reactStately.useListData)({
        initialItems: tickets
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "grid grid-cols-[repeat(3,minmax(280px,1fr))] md:justify-center gap-4 -mx-8 box-border px-8 py-8 overflow-auto relative snap-x snap-mandatory no-scrollbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Column, {
                status: "Open",
                list: list,
                itemClassName: "selected:bg-green-100 selected:border-green-500 dark:selected:bg-green-900 dark:selected:border-green-700"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Column, {
                status: "In Progress",
                list: list,
                itemClassName: "selected:bg-blue-100 selected:border-blue-500 dark:selected:bg-blue-900 dark:selected:border-blue-700"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Column, {
                status: "Closed",
                list: list,
                itemClassName: "selected:bg-red-100 selected:border-red-500 dark:selected:bg-red-900 dark:selected:border-red-700"
            })
        ]
    });
}
function Column({ list, status, itemClassName }) {
    let items = list.items.filter((t)=>t.status === status);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        // Provide drag data in a custom format as well as plain text.
        getItems (keys) {
            return [
                ...keys
            ].map((id)=>({
                    'issue-id': String(id),
                    'text/plain': list.getItem(id)?.title ?? ''
                }));
        },
        renderDropIndicator (target) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropIndicator), {
                target: target,
                className: "h-0 -my-1.5 -translate-y-[5px] -mx-2 invisible drop-target:visible",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    height: 10,
                    className: "block w-full stroke-blue-500 fill-none forced-colors:stroke-[Highlight]",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 5,
                            cy: 5,
                            r: 4,
                            strokeWidth: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                            x1: 20,
                            x2: "100%",
                            transform: "translate(-10 0)",
                            y1: 5,
                            y2: 5,
                            strokeWidth: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "100%",
                            cy: 5,
                            r: 4,
                            transform: "translate(-5 0)",
                            strokeWidth: 2
                        })
                    ]
                })
            });
        },
        // Accept drops with the custom format.
        acceptedDragTypes: [
            'issue-id'
        ],
        // Ensure items are always moved rather than copied.
        getDropOperation: ()=>'move',
        // Handle drops between items from other lists.
        async onInsert (e) {
            let ids = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map((item)=>item.getText('issue-id')));
            for (let id of ids)list.update(id, {
                ...list.getItem(id),
                status
            });
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, ids);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, ids);
        },
        // Handle drops on the collection when empty.
        async onRootDrop (e) {
            let ids = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map((item)=>item.getText('issue-id')));
            for (let id of ids)list.update(id, {
                ...list.getItem(id),
                status
            });
        },
        // Handle reordering items within the same list.
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: "flex flex-col gap-2 snap-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "font-semibold text-base text-zinc-800 dark:text-zinc-200 m-0",
                        children: status
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "text-sm text-zinc-700 dark:text-zinc-400",
                        children: [
                            items.length,
                            " ",
                            items.length === 1 ? 'task' : 'tasks'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridList), {
                items: items,
                "aria-label": status,
                selectionMode: "multiple",
                dragAndDropHooks: dragAndDropHooks,
                renderEmptyState: ()=>'No tasks.',
                className: "h-[320px] box-border p-2 md:p-4 overflow-y-auto overflow-x-hidden relative outline outline-0 bg-white/70 dark:bg-zinc-900/60 backdrop-blur-sm border border-black/10 dark:border-white/10 bg-clip-padding text-gray-700 dark:text-zinc-400 flex flex-col gap-3 rounded-xl shadow-xl drop-target:bg-blue-200 dark:drop-target:bg-blue-800/60 drop-target:outline-2 outline-blue-500 forced-colors:outline-[Highlight] -outline-offset-2 empty:items-center empty:justify-center",
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
                        item: item,
                        className: itemClassName
                    })
            })
        ]
    });
}
function Card({ id, item, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.GridListItem), {
        id: id,
        textValue: item.title,
        className: `group grid grid-cols-[1fr_auto] gap-1 box-border p-2 rounded-lg border border-solid border-black/10 hover:border-black/20 dark:border-white/10 dark:hover:border-white/20 forced-colors:border-[ButtonBorder]! bg-white/80 dark:bg-zinc-900/70 bg-clip-padding hover:shadow-md selected:shadow-md dragging:opacity-50 transition text-slate-700 dark:text-slate-200 cursor-default select-none outline outline-0 outline-offset-2 focus-visible:outline-2 outline-blue-500 forced-colors:outline-[Highlight] forced-colors:text-[ButtonText]! forced-colors:selected:bg-[Highlight]! forced-colors:selected:text-[HighlightText]! forced-color-adjust-none ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-bold truncate",
                children: item.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-sm justify-self-end",
                children: item.id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "description",
                className: "text-sm line-clamp-2 col-span-2 text-slate-500 dark:text-zinc-300 forced-colors:text-inherit!",
                children: item.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: item.avatar,
                        alt: "",
                        className: "h-4 w-4 rounded-full"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-sm",
                        children: item.assignee
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                slot: "drag",
                className: "bg-transparent border-none text-gray-500 dark:text-zinc-300 text-base leading-none w-fit aspect-square p-0 justify-self-end outline outline-0 focus-visible:outline-2 outline-blue-500 forced-colors:outline-[Highlight] rounded-xs sr-only group-focus-visible:not-sr-only focus:not-sr-only forced-colors:group-selected:text-[HighlightText] forced-colors:group-selected:outline-[HighlightText]",
                children: "\u2261"
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["DropIndicator","kft18"],["GridList","8bLgh"],["GridListItem","8bLgh"],["isTextDropItem","gR4JY"],["Text","jt9fm"],["useDragAndDrop","dAd3y"]],"react-stately":"5lXoQ","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5lXoQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useListData", ()=>useListData);
parcelHelpers.export(exports, "createListActions", ()=>createListActions);
var _react = require("react");
function useListData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id ?? item.key, filter, initialFilterText = '' } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, _react.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, _react.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...createListActions({
            getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function createListActions(opts, dispatch) {
    let { cursor, getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys
                }));
        },
        addKeysToSelection (selectedKeys) {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return state;
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: 'all'
                };
                return {
                    ...state,
                    selectedKeys: new Set([
                        ...state.selectedKeys,
                        ...selectedKeys
                    ])
                };
            });
        },
        removeKeysFromSelection (selectedKeys) {
            dispatch((state)=>{
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: new Set()
                };
                let selection = state.selectedKeys === 'all' ? new Set(state.items.map(getKey)) : new Set(state.selectedKeys);
                for (let key of selectedKeys)selection.delete(key);
                return {
                    ...state,
                    selectedKeys: selection
                };
            });
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = 'all';
                if (state.selectedKeys !== 'all') {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let updatedValue;
                if (typeof newValue === 'function') updatedValue = newValue(state.items[index]);
                else updatedValue = newValue;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        updatedValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Oyim":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchAnimation", ()=>SwitchAnimation);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("./utils");
var _components = require("./components");
var _reactDom = require("react-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
'use client';
function SwitchAnimation() {
    let ref = (0, _react.useRef)(null);
    let [isAnimating, setAnimating] = (0, _react.useState)(false);
    let [isSelected, setSelected] = (0, _react.useState)(true);
    (0, _utils.useIntersectionObserver)(ref, (0, _react.useCallback)(()=>{
        let job = {
            isCanceled: false,
            async run () {
                (0, _reactDom.flushSync)(()=>{
                    setAnimating(true);
                });
                let animation = document.getAnimations().find((anim)=>anim instanceof CSSAnimation && anim.animationName === 'touch-animation');
                try {
                    await animation?.finished;
                } catch  {
                // ignore abort errors.
                }
                setAnimating(false);
            }
        };
        (0, _utils.animationQueue).next(job);
        return ()=>{
            job.isCanceled = true;
            setAnimating(false);
            setSelected(true);
        };
    }, []));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Finger), {
                style: {
                    animation: isAnimating ? 'touch-animation 12s ease-in-out 500ms' : undefined
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Switch), {
                "aria-label": "Example switch",
                ref: ref,
                isSelected: isSelected,
                onChange: isAnimating ? undefined : setSelected,
                className: "group inline-flex touch-none",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "[--bg:var(--color-slate-300)] dark:[--bg:var(--color-zinc-600)] forced-colors:[--bg:ButtonFace]! bg-(--bg) [--bg-selected:var(--color-green-500)] forced-colors:[--bg-selected:Highlight]! group-selected:bg-(--bg-selected) group-focus-visible:outline-2 outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2 mr-4 h-10 w-16 rounded-full border border-black/[5%] dark:border-white/10 box-border p-[3px] transition duration-200",
                    style: {
                        animation: isAnimating ? 'switch-background-animation 12s ease-in-out 500ms' : undefined
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "group-selected:ml-6 group-selected:group-pressed:ml-4 group-pressed:w-10 block box-border h-8 w-8 origin-right rounded-full bg-white forced-colors:bg-[ButtonText] forced-colors:group-selected:bg-[HighlightText] border border-transparent shadow-sm transition-all duration-200",
                        style: {
                            animation: isAnimating ? 'switch-animation 12s ease-in-out 500ms' : undefined,
                            contain: 'layout'
                        }
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","./utils":"6X865","./components":"bkILc","react-dom":"gC2PC","react":"a1TxN","react-aria-components":"fs6Z0","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6X865":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationQueue", ()=>animationQueue);
parcelHelpers.export(exports, "animate", ()=>animate);
parcelHelpers.export(exports, "useIntersectionObserver", ()=>useIntersectionObserver);
var _react = require("react");
async function* createAnimationQueue() {
    while(true){
        let { isCanceled, run } = yield;
        if (!isCanceled) await run();
    }
}
let animationQueue = createAnimationQueue();
animationQueue.next(); // advance to first yield
function animate(steps) {
    let cancelCurrentStep;
    async function run() {
        for (let step of steps)try {
            step.perform();
            let { promise, cancel } = sleep(step.time);
            cancelCurrentStep = cancel;
            await promise;
        } catch  {
            break;
        }
    }
    let job = {
        isCanceled: false,
        run
    };
    animationQueue.next(job);
    return ()=>{
        job.isCanceled = true;
        if (cancelCurrentStep) cancelCurrentStep();
    };
}
function sleep(ms) {
    let timeout;
    let cancel;
    let promise = new Promise((resolve, reject)=>{
        timeout = setTimeout(resolve, ms);
        cancel = reject;
    });
    return {
        promise,
        cancel () {
            clearTimeout(timeout);
            cancel();
        }
    };
}
function useIntersectionObserver(ref, onIntersect) {
    (0, _react.useEffect)(()=>{
        let element = ref.current;
        if (!element) return;
        let cancel = undefined;
        let observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) cancel = onIntersect();
            else if (typeof cancel === 'function') {
                cancel();
                cancel = undefined;
            }
        }, {
            threshold: 1
        });
        observer.observe(element);
        return ()=>{
            if (typeof cancel === 'function') cancel();
            observer.unobserve(element);
        };
    }, [
        ref,
        onIntersect
    ]);
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"hEZ6p":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MouseAnimation", ()=>MouseAnimation);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("./utils");
var _button = require("tailwind-starter/Button");
var _reactAriaComponents = require("react-aria-components");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tooltip = require("tailwind-starter/Tooltip");
'use client';
function MouseAnimation() {
    let ref = (0, _react.useRef)(null);
    let [tooltip, setTooltip] = (0, _react.useState)(null);
    let [hovered, setHovered] = (0, _react.useState)(null);
    let [isPressed, setPressed] = (0, _react.useState)(false);
    let isAnimating = (0, _react.useRef)(false);
    let mouseRef = (0, _react.useRef)(null);
    (0, _utils.useIntersectionObserver)(ref, (0, _react.useCallback)(()=>{
        isAnimating.current = true;
        let cancel = (0, _utils.animate)([
            {
                time: 500,
                perform () {}
            },
            {
                time: 700,
                perform () {
                    mouseRef.current.animate({
                        transform: [
                            'translate(-50px, 150px)',
                            'translate(10px, 10px)'
                        ]
                    }, {
                        duration: 1000,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 1700,
                perform () {
                    setHovered('edit');
                }
            },
            {
                time: 800,
                perform () {
                    setTooltip('edit');
                }
            },
            {
                time: 700,
                perform () {
                    mouseRef.current.animate({
                        transform: [
                            'translate(10px, 10px)',
                            'translate(110px, 14px)'
                        ]
                    }, {
                        duration: 2000,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 600,
                perform () {
                    setHovered('share');
                    setTooltip('share');
                }
            },
            {
                time: 1500,
                perform () {
                    setHovered('settings');
                    setTooltip('settings');
                }
            },
            {
                time: 300,
                perform () {
                    setPressed(true);
                    setTooltip(null);
                }
            },
            {
                time: 1000,
                perform () {
                    setPressed(false);
                }
            },
            {
                time: 400,
                perform () {
                    mouseRef.current.animate({
                        transform: [
                            'translate(110px, 14px)',
                            'translate(170px, 150px)'
                        ]
                    }, {
                        duration: 1500,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 1100,
                perform () {
                    setHovered(null);
                }
            },
            {
                time: 0,
                perform () {
                    isAnimating.current = false;
                }
            }
        ]);
        return ()=>{
            cancel();
            setTooltip(null);
            setHovered(null);
            setPressed(false);
            mouseRef.current.getAnimations().forEach((a)=>a.cancel());
            isAnimating.current = false;
        };
    }, []));
    let onOpenChange = (tooltip, isOpen)=>{
        if (!isAnimating.current) setTooltip(isOpen ? tooltip : null);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex gap-2",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                ref: mouseRef,
                viewBox: "0 0 12 19",
                width: 12,
                height: 19,
                "aria-hidden": "true",
                className: "absolute z-10",
                style: {
                    filter: 'drop-shadow(0 1px 1px #aaa)',
                    transform: 'translate(-50px, 130px)'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "matrix(1, 0, 0, 1, -150, -63.406998)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M150 79.422V63.407l11.591 11.619h-6.781l-.411.124Z",
                            fill: "#fff",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "m159.084 80.1-3.6 1.535-4.684-11.093 3.686-1.553Z",
                            fill: "#fff",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "m157.751 79.416-1.844.774-3.1-7.374 1.841-.775Z",
                            fillRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M151 65.814V77l2.969-2.866.431-.134h4.768Z",
                            fillRule: "evenodd"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TooltipTrigger), {
                isOpen: tooltip === 'edit',
                onOpenChange: (o)=>onOpenChange('edit', o),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        "aria-label": "Edit",
                        variant: "secondary",
                        className: `w-9 h-9 p-0 relative ${hovered === 'edit' ? 'bg-gray-200 dark:bg-zinc-500' : ''}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.PencilIcon), {
                            "aria-hidden": true,
                            className: "inline w-5 h-5"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                        children: "Edit"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TooltipTrigger), {
                isOpen: tooltip === 'share',
                onOpenChange: (o)=>onOpenChange('share', o),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        "aria-label": "Share",
                        variant: "secondary",
                        className: `w-9 h-9 p-0 relative ${hovered === 'share' ? 'bg-gray-200 dark:bg-zinc-500' : ''}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ShareIcon), {
                            "aria-hidden": true,
                            className: "inline w-5 h-5"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                        children: "Share"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TooltipTrigger), {
                isOpen: tooltip === 'settings',
                onOpenChange: (o)=>onOpenChange('settings', o),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ButtonContext).Provider, {
                        value: {
                            isPressed
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            "aria-label": "Settings",
                            variant: "secondary",
                            className: `w-9 h-9 p-0 relative ${hovered === 'settings' ? 'bg-gray-200 dark:bg-zinc-500' : ''}`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CogIcon), {
                                "aria-hidden": true,
                                className: "inline w-5 h-5"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                        children: "Settings"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","./utils":"6X865","tailwind-starter/Button":"hk9LL","react-aria-components":[["ButtonContext","9G5XO"],["TooltipTrigger","fLMVd"]],"lucide-react":[["CogIcon","e59TW","default"],["PencilIcon","lKTtr","default"],["ShareIcon","g4buQ","default"]],"react":"a1TxN","tailwind-starter/Tooltip":"4lonv","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e59TW":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Cog);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
            key: "sobvz5"
        }
    ],
    [
        "path",
        {
            d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            key: "11i496"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 22v-2",
            key: "1osdcq"
        }
    ],
    [
        "path",
        {
            d: "m17 20.66-1-1.73",
            key: "eq3orb"
        }
    ],
    [
        "path",
        {
            d: "M11 10.27 7 3.34",
            key: "16pf9h"
        }
    ],
    [
        "path",
        {
            d: "m20.66 17-1.73-1",
            key: "sg0v6f"
        }
    ],
    [
        "path",
        {
            d: "m3.34 7 1.73 1",
            key: "1ulond"
        }
    ],
    [
        "path",
        {
            d: "M14 12h8",
            key: "4f43i9"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "m20.66 7-1.73 1",
            key: "1ow05n"
        }
    ],
    [
        "path",
        {
            d: "m3.34 17 1.73-1",
            key: "nuk764"
        }
    ],
    [
        "path",
        {
            d: "m17 3.34-1 1.73",
            key: "2wel8s"
        }
    ],
    [
        "path",
        {
            d: "m11 13.73-4 6.93",
            key: "794ttg"
        }
    ]
];
const Cog = (0, _createLucideIconJsDefault.default)("cog", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eYURE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBoxExample", ()=>ListBoxExample);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("./utils");
var _reactAriaComponents = require("react-aria-components");
var _listBox = require("tailwind-starter/ListBox");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const keyframes = [
    {
        fill: 'transparent',
        offset: 0
    },
    {
        fill: 'var(--press-fill)',
        offset: 0.5
    },
    {
        fill: 'transparent',
        offset: 1
    }
];
function ListBoxExample() {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    let [focusedKey, setFocusedKey] = (0, _react.useState)(null);
    let isAnimating = (0, _react.useRef)(false);
    let ref = (0, _react.useRef)(null);
    (0, _utils.useIntersectionObserver)(ref, (0, _react.useCallback)(()=>{
        let spaceKey = document.getElementById('space-key');
        let downKey = document.getElementById('down-key');
        let upKey = document.getElementById('up-key');
        let shiftKey = document.getElementById('shift-key');
        isAnimating.current = true;
        let cancel = (0, _utils.animate)([
            {
                time: 500,
                perform () {}
            },
            {
                time: 800,
                perform () {
                    setFocusedKey('chocolate');
                    setSelectedKeys(new Set());
                }
            },
            {
                time: 800,
                perform () {
                    downKey.animate(keyframes, {
                        duration: 600
                    });
                    setFocusedKey('mint');
                }
            },
            {
                time: 800,
                perform () {
                    spaceKey.animate(keyframes, {
                        duration: 600
                    });
                    setSelectedKeys(new Set([
                        'mint'
                    ]));
                }
            },
            {
                time: 800,
                perform () {
                    shiftKey.animate([
                        {
                            fill: 'transparent'
                        },
                        {
                            fill: 'var(--press-fill)',
                            offset: 1
                        }
                    ], {
                        duration: 300,
                        fill: 'forwards'
                    });
                }
            },
            {
                time: 800,
                perform () {
                    downKey.animate(keyframes, {
                        duration: 600
                    });
                    setFocusedKey('strawberry');
                    setSelectedKeys(new Set([
                        'mint',
                        'strawberry'
                    ]));
                }
            },
            {
                time: 600,
                perform () {
                    downKey.animate(keyframes, {
                        duration: 600
                    });
                    setFocusedKey('vanilla');
                    setSelectedKeys(new Set([
                        'mint',
                        'strawberry',
                        'vanilla'
                    ]));
                }
            },
            {
                time: 600,
                perform () {
                    upKey.animate(keyframes, {
                        duration: 600
                    });
                    setFocusedKey('strawberry');
                    setSelectedKeys(new Set([
                        'mint',
                        'strawberry'
                    ]));
                }
            },
            {
                time: 1200,
                perform () {
                    shiftKey.animate([
                        {
                            fill: 'var(--press-fill)'
                        },
                        {
                            fill: 'transparent',
                            offset: 1
                        }
                    ], {
                        duration: 300,
                        fill: 'forwards'
                    });
                }
            },
            {
                time: 0,
                perform () {
                    setFocusedKey(null);
                    setSelectedKeys(new Set());
                    isAnimating.current = false;
                }
            }
        ]);
        return ()=>{
            cancel();
            setFocusedKey(null);
            setSelectedKeys(new Set());
            spaceKey.getAnimations().forEach((a)=>a.cancel());
            downKey.getAnimations().forEach((a)=>a.cancel());
            upKey.getAnimations().forEach((a)=>a.cancel());
            shiftKey.getAnimations().forEach((a)=>a.cancel());
            isAnimating.current = false;
        };
    }, []));
    let onSelectionChange = (keys)=>{
        if (!isAnimating.current) setSelectedKeys(keys);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBox), {
        ref: ref,
        className: "outline-0 p-1 border border-gray-300 dark:border-zinc-600 rounded-lg",
        "aria-label": "Ice cream flavor",
        selectionMode: "multiple",
        selectedKeys: selectedKeys,
        onSelectionChange: onSelectionChange,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListBoxItem, {
                id: "chocolate",
                focusedKey: focusedKey,
                children: "Chocolate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListBoxItem, {
                id: "mint",
                focusedKey: focusedKey,
                children: "Mint"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListBoxItem, {
                id: "strawberry",
                focusedKey: focusedKey,
                children: "Strawberry"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListBoxItem, {
                id: "vanilla",
                focusedKey: focusedKey,
                children: "Vanilla"
            })
        ]
    });
}
function ListBoxItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        textValue: textValue,
        className: ({ isFocusVisible, ...renderProps })=>(0, _listBox.itemStyles)({
                isFocusVisible: isFocusVisible || props.id === props.focusedKey,
                ...renderProps
            }),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    typeof props.children === 'function' ? props.children(renderProps) : props.children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute left-2.5 right-2.5 bottom-0 h-px bg-white/20 forced-colors:bg-[HighlightText] hidden [.group[data-selected]:has(+[data-selected])_&]:block"
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","./utils":"6X865","react-aria-components":"dNdIK","tailwind-starter/ListBox":"4YPUR","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ht7Pj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusExample", ()=>FocusExample);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("tailwind-starter/Button");
var _lucideReact = require("lucide-react");
var _reactAriaComponents = require("react-aria-components");
var _popover = require("tailwind-starter/Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textField = require("tailwind-starter/TextField");
'use client';
function FocusExample() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex items-center justify-center h-full",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    variant: "secondary",
                    className: "w-9 h-9 p-0",
                    "aria-label": "Account",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CircleUser), {
                        "aria-hidden": true,
                        className: "inline w-5 h-5"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                    showArrow: true,
                    className: "w-[250px]",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Dialog), {
                        className: "outline outline-0 p-4 overflow-auto flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                                slot: "title",
                                className: "text-lg font-semibold m-0 mb-2",
                                children: "Your Account"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textField.TextField), {
                                label: "First Name",
                                defaultValue: "Devon",
                                autoFocus: navigator.maxTouchPoints === 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textField.TextField), {
                                label: "Last Name",
                                defaultValue: "Govett"
                            })
                        ]
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/Button":"hk9LL","lucide-react":[["CircleUser","jEBn3","default"]],"react-aria-components":[["Dialog","l2uUY"],["DialogTrigger","l2uUY"],["Heading","2f4nH"]],"tailwind-starter/Popover":"Dr9D3","react":"a1TxN","tailwind-starter/TextField":"lhOW9","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jEBn3":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleUser);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ],
    [
        "path",
        {
            d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662",
            key: "154egf"
        }
    ]
];
const CircleUser = (0, _createLucideIconJsDefault.default)("circle-user", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9PBNd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A11y", ()=>A11y);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("./utils");
var _button = require("tailwind-starter/Button");
var _lucideReact = require("lucide-react");
var _reactDom = require("react-dom");
var _components = require("./components");
var _reactAria = require("react-aria");
var _field = require("tailwind-starter/Field");
var _reactAriaComponents = require("react-aria-components");
var _popover = require("tailwind-starter/Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("tailwind-starter/Select");
'use client';
const swipeRightKeyframes = {
    transform: [
        'translate(-80px, 0)',
        'translate(-80px, 0)',
        'translate(80px, 0)',
        'translate(80px, 0)'
    ],
    opacity: [
        '0',
        'var(--pressed-opacity)',
        'var(--pressed-opacity)',
        '0'
    ],
    offset: [
        0,
        0.2,
        0.8,
        1
    ],
    easing: 'ease-in-out'
};
const doubleTapKeyframes = {
    opacity: [
        '0',
        'var(--pressed-opacity)',
        'var(--hover-opacity)',
        'var(--pressed-opacity)',
        '0'
    ],
    easing: 'ease-in-out'
};
function A11y() {
    let ref = (0, _react.useRef)(null);
    let fingerRef = (0, _react.useRef)(null);
    let [cursorRect, setCursorRect] = (0, _react.useState)(null);
    let [fingerPos, setFingerPos] = (0, _react.useState)(null);
    let [isOpen, setOpen] = (0, _react.useState)(false);
    let [caption, setCaption] = (0, _react.useState)('');
    let [selectedKey, setSelectedKey] = (0, _react.useState)('read');
    (0, _utils.useIntersectionObserver)(ref, (0, _react.useCallback)(()=>{
        let button = null;
        let listbox = null;
        const swipeRight = {
            time: 500,
            perform () {
                fingerRef.current.animate(swipeRightKeyframes, {
                    duration: 500
                });
            }
        };
        const doubleTap = {
            time: 800,
            perform () {
                fingerRef.current.animate(doubleTapKeyframes, {
                    duration: 500
                });
            }
        };
        let rect = getRect(ref.current);
        (0, _reactDom.flushSync)(()=>{
            setFingerPos({
                top: rect.top + rect.height - 170,
                left: rect.left + rect.width / 2 - 20
            });
        });
        let cancel = (0, _utils.animate)([
            swipeRight,
            {
                time: 1000,
                perform () {
                    let label = ref.current.querySelector('span');
                    setCursorRect(getRect(label, 5));
                    setCaption('Permissions');
                }
            },
            swipeRight,
            {
                time: 2000,
                perform () {
                    button = ref.current.querySelector('button');
                    setCursorRect(getRect(button));
                    setCaption('Read Only Permissions, Pop up button, List box popup, Double tap to activate the picker');
                }
            },
            doubleTap,
            {
                time: 180,
                perform () {
                    setOpen(true);
                }
            },
            {
                time: 1500,
                perform () {
                    listbox = document.getElementById(button.getAttribute('aria-controls'));
                    let option = listbox.querySelector('[role=option]');
                    setCursorRect(getRect(option));
                    setCaption('Permissions, Read Only, List start');
                }
            },
            swipeRight,
            {
                time: 1000,
                perform () {
                    let option = listbox.querySelectorAll('[role=option]')[1];
                    setCursorRect(getRect(option));
                    setCaption('Edit');
                }
            },
            swipeRight,
            {
                time: 1500,
                perform () {
                    let option = listbox.querySelectorAll('[role=option]')[2];
                    setCursorRect(getRect(option));
                    setCaption('Admin, List end');
                }
            },
            swipeRight,
            {
                time: 1500,
                perform () {
                    let option = listbox.parentElement.querySelector('button');
                    setCursorRect(getRect(option));
                    setCaption('Dismiss, button');
                }
            },
            doubleTap,
            {
                time: 2000,
                perform () {
                    setOpen(false);
                    setCursorRect(getRect(button));
                    setCaption('Read Only Permissions, Pop up button, List box popup, Double tap to activate the picker');
                }
            },
            {
                time: 800,
                perform () {
                    setCursorRect(null);
                    setCaption('');
                }
            }
        ]);
        return ()=>{
            cancel();
            setOpen(false);
            setCursorRect(null);
            setCaption('');
        };
    }, []));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col h-full relative",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-1 px-6 py-3 text-xs font-medium text-black dark:text-white border-b dark:border-white/10 bg-gray-100 dark:bg-zinc-600",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Clock, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.WifiIcon), {
                        className: "w-3 h-3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        viewBox: "0 0 28 24",
                        className: "h-5 stroke-gray-600 dark:stroke-zinc-400",
                        fill: "none",
                        strokeWidth: "1",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: "20",
                                height: "10",
                                x: "2",
                                y: "7",
                                rx: "3",
                                ry: "3"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: "13",
                                height: "7",
                                x: "3.5",
                                y: "8.5",
                                rx: "2",
                                ry: "2",
                                fill: "currentColor",
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                x1: "25",
                                x2: "25",
                                y1: "11",
                                y2: "13",
                                strokeWidth: "2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-1 flex justify-center pt-28 md:pt-40 pb-40 relative",
                ref: ref,
                children: [
                    fingerPos && /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Finger), {
                        ref: fingerRef,
                        style: {
                            ...fingerPos,
                            zIndex: 100000000
                        }
                    }), document.body),
                    cursorRect && /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rounded-md border-2 box-border border-black absolute forced-color-adjust-none",
                        style: {
                            ...cursorRect,
                            zIndex: 100000000,
                            boxShadow: '0 0 0 1px white, inset 0 0 0 1px white',
                            minWidth: 10,
                            minHeight: 10
                        }
                    }), document.body),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Select), {
                        className: "group flex flex-col gap-1",
                        selectedKey: selectedKey,
                        onSelectionChange: cursorRect ? undefined : setSelectedKey,
                        isOpen: isOpen,
                        onOpenChange: cursorRect ? undefined : setOpen,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                                children: "Permissions"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                className: "flex items-center text-start gap-4 w-full cursor-default border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none rounded-lg box-border pl-3 pr-2 py-2 min-w-[150px] transition bg-gray-50 hover:bg-gray-100 pressed:bg-gray-200 dark:bg-zinc-700 dark:hover:bg-zinc-600 dark:pressed:bg-zinc-500 group-invalid:border-red-600 disabled:text-gray-200 dark:disabled:text-zinc-600 outline-hidden focus-visible:outline-blue-600 dark:focus-visible:outline-blue-500 outline-offset-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectValue), {
                                        className: "flex-1 text-sm text-gray-800 dark:text-zinc-300 placeholder-shown:italic"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                        className: "w-4 h-4 text-gray-600 dark:text-zinc-400"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                                isNonModal: !!cursorRect,
                                className: "min-w-(--trigger-width)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBox), {
                                    shouldUseVirtualFocus: !!cursorRect,
                                    className: "outline-hidden p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                            id: "read",
                                            children: "Read Only"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                            id: "edit",
                                            children: "Edit"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                            id: "admin",
                                            children: "Admin"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            caption && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "absolute bottom-4 md:bottom-8 left-8 right-8 bg-gray-700 text-white border border-transparent text-center text-xs px-2 py-1.5 rounded-lg",
                children: caption
            })
        ]
    });
}
function Clock() {
    let formatter = (0, _reactAria.useDateFormatter)({
        timeStyle: 'short'
    });
    let [time, setTime] = (0, _react.useState)(()=>new Date());
    (0, _react.useEffect)(()=>{
        let nextMinute = Math.floor((Date.now() + 60000) / 60000) * 60000;
        let timeout = setTimeout(()=>{
            setTime(new Date());
        }, nextMinute - Date.now());
        return ()=>clearTimeout(timeout);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs font-semibold",
        children: formatter.format(time)
    });
}
function getRect(element, px = 0) {
    if (!element) return {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    };
    let rect = element.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX - px,
        width: rect.width + px * 2,
        height: rect.height
    };
}

},{"react/jsx-runtime":"2Is6Z","./utils":"6X865","tailwind-starter/Button":"hk9LL","lucide-react":[["ChevronDown","kWVt3","default"],["WifiIcon","biA3B","default"]],"react-dom":"gC2PC","./components":"bkILc","react-aria":"l0ABP","tailwind-starter/Field":"5fXWs","react-aria-components":[["ListBox","dNdIK"],["Select","f92ET"],["SelectValue","f92ET"]],"tailwind-starter/Popover":"Dr9D3","react":"a1TxN","tailwind-starter/Select":"gYM2m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"biA3B":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Wifi);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 20 0",
            key: "dnpr2z"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 14 0",
            key: "1x1e6c"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ]
];
const Wifi = (0, _createLucideIconJsDefault.default)("wifi", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l0ABP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized date formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the date formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useDateFormatter", ()=>useDateFormatter);
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _context = require("./context");
var _react = require("react");
function useDateFormatter(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, _utils.useDeepMemo)(options ?? {}, isEqual);
    let { locale } = (0, _context.useLocale)();
    return (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}

},{"@internationalized/date":"6ueXY","@react-aria/utils":"6otos","./context":"4k4z8","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ueXY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** A wrapper around Intl.DateTimeFormat that fixes various browser bugs, and polyfills new features. */ parcelHelpers.export(exports, "DateFormatter", ()=>DateFormatter);
let formatterCache = new Map();
class DateFormatter {
    constructor(locale, options = {}){
        this.formatter = getCachedDateFormatter(locale, options);
        this.options = options;
    }
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') // @ts-ignore
        return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') // @ts-ignore
        return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if (hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
        return resolvedOptions;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {
    }
};
function getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref ?? defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let _hasBuggyHour12Behavior = null;
function hasBuggyHour12Behavior() {
    if (_hasBuggyHour12Behavior == null) _hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return _hasBuggyHour12Behavior;
}
let _hasBuggyResolvedHourCycle = null;
function hasBuggyResolvedHourCycle() {
    if (_hasBuggyResolvedHourCycle == null) _hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return _hasBuggyResolvedHourCycle;
}
function getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour').value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour').value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6otos":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepMemo", ()=>useDeepMemo);
var _react = require("react");
function useDeepMemo(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, _react.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kP20J":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _jsxRuntime = require("react/jsx-runtime");
var _calendar = require("tailwind-starter/Calendar");
var _dateField = require("tailwind-starter/DateField");
var _reactAriaComponents = require("react-aria-components");
var _date = require("@internationalized/date");
var _numberField = require("tailwind-starter/NumberField");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("tailwind-starter/Select");
'use client';
// https://github.com/unicode-org/cldr/blob/22af90ae3bb04263f651323ce3d9a71747a75ffb/common/supplemental/supplementalData.xml#L4649-L4664
const preferences = [
    // Tier 1
    {
        value: 'fr-FR'
    },
    {
        value: 'fr-CA'
    },
    {
        value: 'de-DE'
    },
    {
        value: 'en-US'
    },
    {
        value: 'en-GB'
    },
    {
        value: 'ja-JP',
        ordering: 'gregory japanese'
    },
    // // Tier 2
    {
        value: 'da-DK'
    },
    {
        value: 'nl-NL'
    },
    {
        value: 'fi-FI'
    },
    {
        value: 'it-IT'
    },
    {
        value: 'nb-NO'
    },
    {
        value: 'es-ES'
    },
    {
        value: 'sv-SE'
    },
    {
        value: 'pt-BR'
    },
    // // Tier 3
    {
        value: 'zh-CN'
    },
    {
        value: 'zh-TW',
        ordering: 'gregory roc chinese'
    },
    {
        value: 'ko-KR'
    },
    // // Tier 4
    {
        value: 'bg-BG'
    },
    {
        value: 'hr-HR'
    },
    {
        value: 'cs-CZ'
    },
    {
        value: 'et-EE'
    },
    {
        value: 'hu-HU'
    },
    {
        value: 'lv-LV'
    },
    {
        value: 'lt-LT'
    },
    {
        value: 'pl-PL'
    },
    {
        value: 'ro-RO'
    },
    {
        value: 'ru-RU'
    },
    {
        value: 'sr-SP'
    },
    {
        value: 'sk-SK'
    },
    {
        value: 'sl-SI'
    },
    {
        value: 'tr-TR'
    },
    {
        value: 'uk-UA'
    },
    // // Tier 5
    {
        value: 'ar-AE',
        ordering: 'gregory islamic-umalqura islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-DZ',
        ordering: 'gregory islamic islamic-civil islamic-tbla'
    },
    {
        value: 'AR-EG',
        ordering: 'gregory coptic islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-SA',
        ordering: 'islamic-umalqura gregory islamic islamic-rgsa'
    },
    {
        value: 'el-GR'
    },
    {
        value: 'he-IL',
        ordering: 'gregory hebrew islamic islamic-civil islamic-tbla'
    },
    {
        value: 'fa-AF',
        ordering: 'persian gregory islamic islamic-civil islamic-tbla'
    },
    // {territories: 'CN CX HK MO SG', ordering: 'gregory chinese'},
    {
        value: 'am-ET',
        ordering: 'gregory ethiopic ethioaa'
    },
    {
        value: 'hi-IN',
        ordering: 'gregory indian'
    },
    // {territories: 'KR', ordering: 'gregory dangi'},
    {
        value: 'th-TH',
        ordering: 'buddhist gregory'
    }
];
const calendars = [
    {
        key: 'gregory',
        name: 'Gregorian'
    },
    {
        key: 'japanese',
        name: 'Japanese'
    },
    {
        key: 'buddhist',
        name: 'Buddhist'
    },
    {
        key: 'roc',
        name: 'Taiwan'
    },
    {
        key: 'persian',
        name: 'Persian'
    },
    {
        key: 'indian',
        name: 'Indian'
    },
    {
        key: 'islamic-umalqura',
        name: 'Islamic (Umm al-Qura)'
    },
    {
        key: 'islamic-civil',
        name: 'Islamic Civil'
    },
    {
        key: 'islamic-tbla',
        name: 'Islamic Tabular'
    },
    {
        key: 'hebrew',
        name: 'Hebrew'
    },
    {
        key: 'coptic',
        name: 'Coptic'
    },
    {
        key: 'ethiopic',
        name: 'Ethiopic'
    },
    {
        key: 'ethioaa',
        name: 'Ethiopic (Amete Alem)'
    }
];
function matchLocale(defaultLocale) {
    let parsed;
    try {
        parsed = new Intl.Locale(defaultLocale);
    } catch  {
        return 'en-US';
    }
    let locales = preferences.map((p)=>new Intl.Locale(p.value));
    // Try with both language and region first, and if that fails, try again with just language
    let p = locales.find((locale)=>locale.language === parsed.language && locale.region === parsed.region) || locales.find((locale)=>locale.language === parsed.language);
    return p?.toString() || 'en-US';
}
function I18n() {
    let { locale: defaultLocale } = (0, _reactAriaComponents.useLocale)();
    let [locale, setLocale] = (0, _reactDefault.default).useState(()=>matchLocale(defaultLocale));
    let [calendar, setCalendar] = (0, _reactDefault.default).useState(calendars[0].key);
    let [numberingSystem, setNumberingSystem] = (0, _reactDefault.default).useState(()=>new Intl.NumberFormat(defaultLocale).resolvedOptions().numberingSystem);
    let langDisplay = (0, _reactDefault.default).useMemo(()=>new Intl.DisplayNames(defaultLocale, {
            type: 'language'
        }), [
        defaultLocale
    ]);
    let regionDisplay = (0, _reactDefault.default).useMemo(()=>new Intl.DisplayNames(defaultLocale, {
            type: 'region'
        }), [
        defaultLocale
    ]);
    let locales = (0, _reactDefault.default).useMemo(()=>{
        return preferences.map((item)=>{
            let locale = new Intl.Locale(item.value);
            return {
                ...item,
                label: `${langDisplay.of(locale.language)} (${regionDisplay.of(locale.region)})`
            };
        }).sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        langDisplay,
        regionDisplay
    ]);
    let pref = preferences.find((p)=>p.value === locale);
    // @ts-ignore there cannot be any undefined values in the array
    let preferredCalendars = (0, _reactDefault.default).useMemo(()=>pref ? (pref.ordering || 'gregory').split(' ').map((p)=>calendars.find((c)=>c.key === p)).filter(Boolean) : [
            calendars[0]
        ], [
        pref
    ]);
    let otherCalendars = (0, _reactDefault.default).useMemo(()=>calendars.filter((c)=>!preferredCalendars.some((p)=>p?.key === c.key)), [
        preferredCalendars
    ]);
    let updateLocale = (locale)=>{
        setLocale(locale);
        let pref = preferences.find((p)=>p.value === locale);
        setCalendar((pref?.ordering || 'gregory').split(' ')[0]);
        setNumberingSystem(new Intl.NumberFormat(locale || defaultLocale).resolvedOptions().numberingSystem);
    };
    let updateCalendar = (calendar)=>{
        setCalendar(calendar);
        let selectedLocale = new Intl.Locale(locale || defaultLocale, {
            calendar: calendar && calendar !== preferredCalendars[0].key ? calendar : undefined
        });
        setNumberingSystem(new Intl.NumberFormat(selectedLocale.toString()).resolvedOptions().numberingSystem);
    };
    let selectedLocale = new Intl.Locale(locale || defaultLocale, {
        calendar: calendar && calendar !== preferredCalendars[0].key ? calendar : undefined,
        numberingSystem
    });
    let [numberFormat, setNumberFormat] = (0, _reactDefault.default).useState('decimal');
    if (numberingSystem === 'arabext') numberingSystem = 'arab';
    let [date, setDate] = (0, _reactDefault.default).useState(()=>(0, _date.now)((0, _date.getLocalTimeZone)()));
    let [focusedDate, setFocusedDate] = (0, _reactDefault.default).useState(date);
    let [number, setNumber] = (0, _reactDefault.default).useState(1234);
    let updateNumberFormat = (format)=>{
        setNumberFormat(format);
        switch(format){
            case 'decimal':
            case 'currency':
                setNumber(1234);
                break;
            case 'percent':
                setNumber(.875);
                break;
            case 'unit':
                setNumber(14.5);
                break;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "grid items-center justify-items-center py-10 px-0 md:p-10 lg:p-0 gap-10 lg:gap-0 lg:grid-cols-[auto_1fr_1fr] mt-10 card-shadow rounded-2xl bg-white dark:bg-zinc-800/90 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid md:grid-cols-2 lg:grid-cols-1 flex-col gap-4 lg:p-10 lg:mr-10 lg:border-r border-r-gray-200 dark:border-r-zinc-300/10",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Select), {
                        label: "Locale",
                        items: locales,
                        selectedKey: locale,
                        onSelectionChange: updateLocale,
                        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: item.value,
                                children: item.label
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                        label: "Calendar",
                        selectedKey: calendar,
                        onSelectionChange: updateCalendar,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectSection), {
                                title: "Preferred",
                                items: preferredCalendars,
                                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                        children: item.name
                                    })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectSection), {
                                title: "Other",
                                items: otherCalendars,
                                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                        children: item.name
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                        label: "Numbering System",
                        selectedKey: numberingSystem,
                        onSelectionChange: setNumberingSystem,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "latn",
                                children: "Latin"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "arab",
                                children: "Arabic"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "hanidec",
                                children: "Hanidec"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "deva",
                                children: "Devanagari"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "beng",
                                children: "Bengali"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                        label: "Number Format",
                        selectedKey: numberFormat,
                        onSelectionChange: updateNumberFormat,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "decimal",
                                children: "Decimal"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "percent",
                                children: "Percent"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "currency",
                                children: "Currency"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                id: "unit",
                                children: "Unit"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.I18nProvider), {
                locale: selectedLocale.toString(),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LangWrapper, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.Calendar), {
                            value: date,
                            onChange: setDate,
                            focusedValue: focusedDate,
                            onFocusChange: setFocusedDate
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _numberField.NumberField), {
                                    label: "Number",
                                    value: number,
                                    onChange: setNumber,
                                    minValue: 0,
                                    formatOptions: {
                                        style: numberFormat,
                                        currency: 'USD',
                                        unit: 'inch',
                                        maximumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateField), {
                                    label: "Date and Time",
                                    value: date,
                                    onChange: (date)=>{
                                        setDate(date);
                                        setFocusedDate(date);
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function LangWrapper({ children }) {
    let { locale, direction } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        lang: locale,
        dir: direction,
        className: "contents",
        children: children
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/Calendar":"hFRUB","tailwind-starter/DateField":"bPyay","react-aria-components":"4k4z8","@internationalized/date":"1rmIt","tailwind-starter/NumberField":"e3KUP","react":"a1TxN","tailwind-starter/Select":"gYM2m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e3KUP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberField", ()=>NumberField);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
function NumberField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.NumberField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldGroup), {
                children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _field.fieldBorderStyles)({
                                    ...renderProps,
                                    class: 'flex flex-col border-s-2'
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepperButton, {
                                        slot: "increment",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronUp), {
                                            "aria-hidden": true,
                                            className: "w-4 h-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _field.fieldBorderStyles)({
                                            ...renderProps,
                                            class: 'border-b-2'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepperButton, {
                                        slot: "decrement",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                            "aria-hidden": true,
                                            className: "w-4 h-4"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}
function StepperButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: "flex border-0 py-0 px-0.5 box-border cursor-default text-gray-500 bg-transparent pressed:bg-gray-100 group-disabled:text-gray-200 dark:text-zinc-400 dark:pressed:bg-zinc-800 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]"
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronDown","kWVt3","default"],["ChevronUp","kvLo9","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["NumberField","7hOK8"]],"./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvLo9":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const ChevronUp = (0, _createLucideIconJsDefault.default)("chevron-up", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"89Ptg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginatedCarousel", ()=>PaginatedCarousel);
var _jsxRuntime = require("react/jsx-runtime");
var _pagination = require("./Pagination");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function PaginatedCarousel({ children, className, paginationClassName }) {
    let carouselRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: carouselRef,
                className: className,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                carouselRef: carouselRef,
                className: paginationClassName
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","./Pagination":"bl138","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bl138":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", ()=>Pagination);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("tailwind-starter/Button");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function Pagination({ carouselRef, className }) {
    let scroll = (dir)=>{
        let carousel = carouselRef.current;
        let style = window.getComputedStyle(carousel);
        carousel.scrollBy({
            left: dir * (carousel.clientWidth - parseInt(style.paddingLeft, 10) - parseInt(style.paddingRight, 10) + parseInt(style.columnGap, 10)),
            behavior: 'smooth'
        });
    };
    let [isPrevDisabled, setPrevDisabled] = (0, _react.useState)(true);
    let [isNextDisabled, setNextDisabled] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let carousel = carouselRef.current;
        let update = ()=>{
            setPrevDisabled(carousel.scrollLeft <= 0);
            setNextDisabled(carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth);
        };
        update();
        if ('onscrollend' in document) {
            carousel.addEventListener('scrollend', update);
            return ()=>carousel.removeEventListener('scrollend', update);
        } else {
            carousel.addEventListener('scroll', update);
            return ()=>carousel.removeEventListener('scroll', update);
        }
    }, [
        carouselRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `flex gap-2 justify-end md:justify-center mt-4 ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "secondary",
                className: "rounded-full p-2",
                "aria-label": "Previous Page",
                isDisabled: isPrevDisabled,
                onPress: ()=>scroll(-1),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                    className: "w-5 h-5"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "secondary",
                className: "rounded-full p-2",
                "aria-label": "Next Page",
                isDisabled: isNextDisabled,
                onPress: ()=>scroll(1),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                    className: "w-5 h-5"
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/Button":"hk9LL","lucide-react":[["ChevronLeft","6gHLa","default"],["ChevronRight","elAlB","default"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ilALz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchMenuWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _homeGlobalCss = require("../tailwind/home.global.css");
var _reactAriaComponents = require("react-aria-components");
var _reactDom = require("react-dom");
var _searchMenuTrigger = require("./SearchMenuTrigger");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../../../@react-spectrum/s2/src/Modal");
var _searchMenu = require("./SearchMenu");
'use client';
const MobileSearchMenu = /*#__PURE__*/ (0, _react.lazy)(()=>require("cca13004895a0b79").then(({ MobileSearchMenu })=>({
            default: MobileSearchMenu
        })));
let underlayStyle = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa12';
    rules += ' Wr12';
    rules += ' _Er12';
    rules += ' Za12';
    rules += ' FKem6Ob12';
    rules += ' _Bb12';
    rules += ' g812';
    if (props.isExiting) rules += ' _Ia12';
    else if (props.isEntering) rules += ' _Ia12';
    rules += ' Yf12';
    if (props.isExiting) rules += ' Xa12';
    else rules += ' Xd12';
    rules += ' _2b12';
    return rules;
};
let modalStyle = " _Pa12 WJ12 Za12 LykyMMb12 g_g12 Sf12 Rf12 Tt12 Qt12 _9G1Ky12 _kb12 hb12 mb12 lb12 iq12 _jf12 oe12 ne12 ke12 je12 _nLeasBb12 _Er12 _Rr12 JM12 GM12 IM12 HM12 FGMCvrc12";
function SearchMenuWrapper({ pages, currentPage }) {
    const [searchOpen, setSearchOpen] = (0, _react.useState)(false);
    let openSearchMenu = async ()=>{
        if (!document.startViewTransition) {
            setSearchOpen((prev)=>!prev);
            return;
        }
        // Preload SearchMenu so it is ready to render immediately.
        await (0, _searchMenuTrigger.preloadSearchMenu)();
        document.startViewTransition(()=>{
            (0, _reactDom.flushSync)(()=>{
                setSearchOpen((prev)=>!prev);
            });
        });
    };
    let closeSearchMenu = ()=>{
        if (!document.startViewTransition) {
            setSearchOpen(false);
            return;
        }
        document.startViewTransition(()=>{
            (0, _reactDom.flushSync)(()=>{
                setSearchOpen(false);
            });
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sk12 spd12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
                    isOpen: searchOpen,
                    onOpenChange: ()=>{
                        openSearchMenu();
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                            className: "font-spectrum no-underline bg-white/60 border border-black/10 bg-clip-padding text-base md:text-lg font-bold text-slate-800 px-8 py-3 rounded-full backdrop-saturate-150 backdrop-brightness-125 transition hover:bg-white/60 focus-ring  dark:outline-white outline-offset-2 active:scale-95 cursor-pointer",
                            children: "Explore Components"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalOverlay), {
                            style: {
                                zIndex: 21
                            },
                            isDismissable: true,
                            className: underlayStyle,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
                                className: modalStyle,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchMenu.SearchMenu), {
                                    pages: pages,
                                    currentPage: currentPage,
                                    onClose: closeSearchMenu,
                                    initialSearchValue: "",
                                    isSearchOpen: searchOpen
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sd12 spk12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                            className: "font-spectrum no-underline bg-white/60 border border-black/10 bg-clip-padding text-base md:text-lg font-bold text-slate-800 px-8 py-3 rounded-full backdrop-saturate-150 backdrop-brightness-125 transition hover:bg-white/60 focus-ring  dark:outline-white outline-offset-2 active:scale-95 cursor-pointer",
                            children: "Explore Components"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                            size: "fullscreenTakeover",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileSearchMenu, {
                                pages: pages,
                                currentPage: currentPage
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","react/jsx-runtime":"2Is6Z","../tailwind/home.global.css":"f9d2i","react-aria-components":[["Button","9G5XO"],["DialogTrigger","l2uUY"],["Modal","29rOq"],["ModalOverlay","29rOq"]],"react-dom":"gC2PC","./SearchMenuTrigger":"kwXgr","react":"a1TxN","../../../@react-spectrum/s2/src/Modal":"iUTZq","./SearchMenu":"7ohac","cca13004895a0b79":"aqSkB","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"f9d2i":[function() {},{}],"aqSkB":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lBmtU"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("aPVyw"),
    module.bundle.load("9f8mp"),
    module.bundle.load("9x1Lo"),
    module.bundle.load("4HyJE"),
    module.bundle.load("4UxgA"),
    module.bundle.load("dZMz1"),
    module.bundle.load("lfyA4"),
    module.bundle.load("8aknZ"),
    module.bundle.load("3vA1P")
]).then(()=>{
    let originalModule = module.bundle.root("7ohac");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("aPVyw")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("9f8mp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lBmtU"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("9x1Lo")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("4HyJE")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("4UxgA")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("dZMz1")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("lfyA4")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("8aknZ")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("3vA1P")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"iKyDQ":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /* eslint-disable react/react-in-jsx-scope */ /* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesProxy", ()=>createResourcesProxy);
parcelHelpers.export(exports, "waitForCSS", ()=>waitForCSS);
var _jsxRuntime = require("react/jsx-runtime");
function createResourcesProxy(module, esModule, resources, bootstrapScript) {
    if (typeof module === 'function') return createResourcesValueProxy(module, resources, bootstrapScript);
    return new Proxy(module, {
        get (target, prop, receiver) {
            if (prop === '__esModule' && esModule) return true;
            let value = Reflect.get(target, prop, receiver);
            return createResourcesValueProxy(value, resources, bootstrapScript);
        }
    });
}
let cache = new WeakMap();
function createResourcesValueProxy(value, resources, bootstrapScript) {
    if (typeof value === 'function') {
        let cached = cache.get(value);
        if (cached) return cached;
        // Detect reads of `Component.prototype.isReactComponent` or `Component.$$typeof`
        // prior to the function being called as an indication that this is a React component.
        // If so, inject the resources as a sibling of the return value.
        let isReactComponent = false;
        let prototypeProxy;
        if (typeof value.prototype === 'object') prototypeProxy = new Proxy(value.prototype, {
            get (target, prop, receiver) {
                if (prop === 'isReactComponent') isReactComponent = true;
                return Reflect.get(target, prop, receiver);
            }
        });
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                if (prototypeProxy && prop === 'prototype' && Object.getOwnPropertyDescriptor(target, 'prototype').configurable) return prototypeProxy;
                if (prop === '$$typeof') isReactComponent = true;
                if (bootstrapScript && prop === 'bootstrapScript') return bootstrapScript;
                return Reflect.get(target, prop, receiver);
            },
            apply (target, thisArg, args) {
                let result = Reflect.apply(target, thisArg, args);
                if (isReactComponent) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        resources,
                        result
                    ]
                });
                return result;
            }
        });
        cache.set(value, proxy);
        return proxy;
    } else if (value && typeof value === 'object') {
        let cached = cache.get(value);
        if (cached) return cached;
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                let value = Reflect.get(target, prop, receiver);
                return createResourcesValueProxy(value, resources, bootstrapScript);
            }
        });
        cache.set(value, proxy);
        return proxy;
    }
    return value;
}
function waitForCSS(url) {
    return new Promise((resolve, reject)=>{
        if (typeof document === 'undefined') return resolve();
        // Find a link element corresponding to this URL.
        let link = document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`);
        if (!link) return resolve();
        // If the link element already has a stylesheet associated with it, then it is already loaded.
        if (link.sheet) return resolve();
        link.addEventListener('load', ()=>{
            resolve();
        });
        link.addEventListener('error', (e)=>{
            reject(e);
        });
    });
}

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cuPh9":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("3vA1P"),
    module.bundle.load("8aknZ"),
    module.bundle.load("lfyA4"),
    module.bundle.load("dZMz1"),
    module.bundle.load("4UxgA"),
    module.bundle.load("4HyJE"),
    module.bundle.load("9x1Lo"),
    require("c38c519a5220575e")(module.bundle.resolve("lBmtU")),
    module.bundle.load("9f8mp"),
    module.bundle.load("aPVyw")
]).then(()=>module.bundle.root('7ohac'));

},{"c38c519a5220575e":"819rl"}],"819rl":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e87h6"}],"e87h6":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hH0ym":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid list.
 * @param props - Props for the selection checkbox.
 * @param state - State of the list, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>useGridListSelectionCheckbox);
var _grid = require("@react-aria/grid");
var _utils = require("./utils");
function useGridListSelectionCheckbox(props, state) {
    let { key } = props;
    const { checkboxProps } = (0, _grid.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, _utils.getRowId)(state, key)}`
        }
    };
}

},{"@react-aria/grid":"8WxyV","./utils":"aJkqW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PgS5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragPreview", ()=>DragPreview);
var _reactDom = require("react-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const DragPreview = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function DragPreview(props, ref) {
    let render = props.children;
    let [children, setChildren] = (0, _react.useState)(null);
    let domRef = (0, _react.useRef)(null);
    let raf = (0, _react.useRef)(undefined);
    (0, _react.useImperativeHandle)(ref, ()=>(items, callback)=>{
            // This will be called during the onDragStart event by useDrag. We need to render the
            // preview synchronously before this event returns so we can call event.dataTransfer.setDragImage.
            let result = render(items);
            let element;
            let offsetX;
            let offsetY;
            if (result && typeof result === 'object' && 'element' in result) {
                element = result.element;
                offsetX = result.x;
                offsetY = result.y;
            } else element = result;
            (0, _reactDom.flushSync)(()=>{
                setChildren(element);
            });
            // Yield back to useDrag to set the drag image.
            callback(domRef.current, offsetX, offsetY);
            // Remove the preview from the DOM after a frame so the browser has time to paint.
            raf.current = requestAnimationFrame(()=>{
                setChildren(null);
            });
        }, [
        render
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    if (!children) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            zIndex: -100,
            position: 'fixed',
            top: 0,
            left: -100000
        },
        ref: domRef
    }, children);
});

},{"react-dom":"gC2PC","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6Pwfq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for an element, with support for traditional mouse and touch
 * based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDrag", ()=>useDrag);
var _react = require("react");
var _dragManager = require("./DragManager");
var _constants = require("./constants");
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
const MESSAGES = {
    keyboard: {
        start: 'dragDescriptionKeyboard',
        end: 'endDragKeyboard'
    },
    touch: {
        start: 'dragDescriptionTouch',
        end: 'endDragTouch'
    },
    virtual: {
        start: 'dragDescriptionVirtual',
        end: 'endDragVirtual'
    }
};
function useDrag(options) {
    let { hasDragButton, isDisabled } = options;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/dnd');
    let state = (0, _react.useRef)({
        options,
        x: 0,
        y: 0
    }).current;
    state.options = options;
    let isDraggingRef = (0, _react.useRef)(null);
    let [isDragging, setDraggingState] = (0, _react.useState)(false);
    let setDragging = (element)=>{
        isDraggingRef.current = element;
        setDraggingState(!!element);
    };
    let { addGlobalListener, removeAllGlobalListeners } = (0, _utils1.useGlobalListeners)();
    let modalityOnPointerDown = (0, _react.useRef)(null);
    let onDragStart = (e)=>{
        if (e.defaultPrevented) return;
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        // If this drag was initiated by a mobile screen reader (e.g. VoiceOver or TalkBack), enter virtual dragging mode.
        if (modalityOnPointerDown.current === 'virtual') {
            e.preventDefault();
            startDragging(e.target);
            modalityOnPointerDown.current = null;
            return;
        }
        if (typeof options.onDragStart === 'function') options.onDragStart({
            type: 'dragstart',
            x: e.clientX,
            y: e.clientY
        });
        let items = options.getItems();
        // Clear existing data (e.g. selected text on the page would be included in some browsers)
        e.dataTransfer.clearData?.();
        (0, _utils.writeToDataTransfer)(e.dataTransfer, items);
        let allowed = (0, _constants.DROP_OPERATION).all;
        if (typeof options.getAllowedDropOperations === 'function') {
            let allowedOperations = options.getAllowedDropOperations();
            allowed = (0, _constants.DROP_OPERATION).none;
            for (let operation of allowedOperations)allowed |= (0, _constants.DROP_OPERATION)[operation] || (0, _constants.DROP_OPERATION).none;
        }
        (0, _utils.setGlobalAllowedDropOperations)(allowed);
        let effectAllowed = (0, _constants.EFFECT_ALLOWED)[allowed] || 'none';
        e.dataTransfer.effectAllowed = effectAllowed === 'cancel' ? 'none' : effectAllowed;
        // If there is a preview option, use it to render a custom preview image that will
        // appear under the pointer while dragging. If not, the element itself is dragged by the browser.
        if (typeof options.preview?.current === 'function') options.preview.current(items, (node, userX, userY)=>{
            if (!node) return;
            // Compute the offset that the preview will appear under the mouse.
            // If possible, this is based on the point the user clicked on the target.
            // If the preview is much smaller, then just use the center point of the preview.
            let size = node.getBoundingClientRect();
            let rect = e.currentTarget.getBoundingClientRect();
            let defaultX = e.clientX - rect.x;
            let defaultY = e.clientY - rect.y;
            if (defaultX > size.width || defaultY > size.height) {
                defaultX = size.width / 2;
                defaultY = size.height / 2;
            }
            // Start with default offsets.
            let offsetX = defaultX;
            let offsetY = defaultY;
            // If the preview renderer supplied explicit offsets, use those.
            if (typeof userX === 'number' && typeof userY === 'number') {
                offsetX = userX;
                offsetY = userY;
            }
            // Clamp the offset so it stays within the preview bounds. Browsers
            // automatically clamp out-of-range values, but doing it ourselves
            // prevents the visible "snap" that can occur when the browser adjusts
            // them after the first drag update.
            offsetX = Math.max(0, Math.min(offsetX, size.width));
            offsetY = Math.max(0, Math.min(offsetY, size.height));
            // Rounding height to an even number prevents blurry preview seen on some screens
            let height = 2 * Math.round(size.height / 2);
            node.style.height = `${height}px`;
            e.dataTransfer.setDragImage(node, offsetX, offsetY);
        });
        // Enforce that drops are handled by useDrop.
        addGlobalListener(window, 'drop', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            console.warn('Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.');
        }, {
            once: true
        });
        state.x = e.clientX;
        state.y = e.clientY;
        // Wait a frame before we set dragging to true so that the browser has time to
        // render the preview image before we update the element that has been dragged.
        let target = e.target;
        requestAnimationFrame(()=>{
            setDragging(target);
        });
    };
    let onDrag = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (e.clientX === state.x && e.clientY === state.y) return;
        if (typeof options.onDragMove === 'function') options.onDragMove({
            type: 'dragmove',
            x: e.clientX,
            y: e.clientY
        });
        state.x = e.clientX;
        state.y = e.clientY;
    };
    let onDragEnd = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (typeof options.onDragEnd === 'function') {
            let event = {
                type: 'dragend',
                x: e.clientX,
                y: e.clientY,
                dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[e.dataTransfer.dropEffect]
            };
            // Chrome Android always returns none as its dropEffect so we use the drop effect set in useDrop via
            // onDragEnter/onDragOver instead. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
            if (0, _utils.globalDropEffect) event.dropOperation = (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[0, _utils.globalDropEffect];
            options.onDragEnd(event);
        }
        setDragging(null);
        removeAllGlobalListeners();
        (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
        (0, _utils.setGlobalDropEffect)(undefined);
    };
    // If the dragged element is removed from the DOM via onDrop, onDragEnd won't fire: https://bugzilla.mozilla.org/show_bug.cgi?id=460801
    // In this case, we need to manually call onDragEnd on cleanup
    (0, _react.useEffect)(()=>{
        return ()=>{
            // Check that the dragged element has actually unmounted from the DOM and not a React Strict Mode false positive.
            // https://github.com/facebook/react/issues/29585
            // React 16 ran effect cleanups before removing elements from the DOM but did not have this issue.
            if (isDraggingRef.current && (!isDraggingRef.current.isConnected || parseInt((0, _react.version), 10) < 17)) {
                if (typeof state.options.onDragEnd === 'function') {
                    let event = {
                        type: 'dragend',
                        x: 0,
                        y: 0,
                        dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[(0, _utils.globalDropEffect) || 'none']
                    };
                    state.options.onDragEnd(event);
                }
                setDragging(null);
                (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
                (0, _utils.setGlobalDropEffect)(undefined);
            }
        };
    }, [
        state
    ]);
    let onPress = (e)=>{
        if (e.pointerType !== 'keyboard' && e.pointerType !== 'virtual') return;
        startDragging(e.target);
    };
    let startDragging = (target)=>{
        if (typeof state.options.onDragStart === 'function') {
            let rect = target.getBoundingClientRect();
            state.options.onDragStart({
                type: 'dragstart',
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            });
        }
        _dragManager.beginDragging({
            element: target,
            items: state.options.getItems(),
            allowedDropOperations: typeof state.options.getAllowedDropOperations === 'function' ? state.options.getAllowedDropOperations() : [
                'move',
                'copy',
                'link'
            ],
            onDragEnd (e) {
                setDragging(null);
                if (typeof state.options.onDragEnd === 'function') state.options.onDragEnd(e);
            }
        }, stringFormatter);
        setDragging(target);
    };
    let modality = (0, _utils.useDragModality)();
    let message = !isDragging ? MESSAGES[modality].start : MESSAGES[modality].end;
    let descriptionProps = (0, _utils1.useDescription)(stringFormatter.format(message));
    let interactions = {};
    if (!hasDragButton) // If there's no separate button to trigger accessible drag and drop mode,
    // then add event handlers to the draggable element itself to start dragging.
    // For keyboard, we use the Enter key in a capturing listener to prevent other
    // events such as selection from also occurring. We attempt to infer whether a
    // pointer event (e.g. long press) came from a touch screen reader, and then initiate
    // dragging in the native onDragStart listener above.
    interactions = {
        ...descriptionProps,
        onPointerDown (e) {
            modalityOnPointerDown.current = (0, _utils1.isVirtualPointerEvent)(e.nativeEvent) ? 'virtual' : e.pointerType;
            // Try to detect virtual drag passthrough gestures.
            if (e.width < 1 && e.height < 1) // iOS VoiceOver.
            modalityOnPointerDown.current = 'virtual';
            else {
                let rect = e.currentTarget.getBoundingClientRect();
                let offsetX = e.clientX - rect.x;
                let offsetY = e.clientY - rect.y;
                let centerX = rect.width / 2;
                let centerY = rect.height / 2;
                if (Math.abs(offsetX - centerX) <= 0.5 && Math.abs(offsetY - centerY) <= 0.5) // Android TalkBack.
                modalityOnPointerDown.current = 'virtual';
                else modalityOnPointerDown.current = e.pointerType;
            }
        },
        onKeyDownCapture (e) {
            if (e.target === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        onKeyUpCapture (e) {
            if (e.target === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                startDragging(e.target);
            }
        },
        onClick (e) {
            // Handle NVDA/JAWS in browse mode, and touch screen readers. In this case, no keyboard events are fired.
            if ((0, _utils1.isVirtualClick)(e.nativeEvent) || modalityOnPointerDown.current === 'virtual') {
                e.preventDefault();
                e.stopPropagation();
                startDragging(e.target);
            }
        }
    };
    if (isDisabled) return {
        dragProps: {
            draggable: 'false'
        },
        dragButtonProps: {},
        isDragging: false
    };
    return {
        dragProps: {
            ...interactions,
            draggable: 'true',
            onDragStart,
            onDrag,
            onDragEnd
        },
        dragButtonProps: {
            ...descriptionProps,
            onPress
        },
        isDragging
    };
}

},{"react":"a1TxN","./DragManager":"43gWL","./constants":"dL7d2","./utils":"gR4JY","../intl/*.json":"8XG9M","@react-aria/utils":[["isVirtualClick","81Nqj"],["isVirtualPointerEvent","81Nqj"],["useDescription","h4qnk"],["useGlobalListeners","ceyTG"]],"@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/e21dd1ad40251f6db23ee70ad9f11ae77365fc4c/s2-docs/")

//# sourceMappingURL=react-aria.84e95581.js.map
